import React, { useState, useEffect, ChangeEvent, useCallback, useRef, useMemo } from "react" 
import Chart, { Grid as GridChart, ConstantLine, CommonSeriesSettings, Annotation, ArgumentAxis, Series, Legend, ValueAxis, ZoomAndPan, ScrollBar, Tooltip, TickInterval, Aggregation, Point, Title, AggregationInterval, Label, Height, Crosshair, Font, MinorTickInterval, Tick, MinorTick, Strip, CommonAxisSettings, VisualRangeChangeEvent } from 'devextreme-react/chart';
import RangeSelector, {Size, Chart as ChartOptions, Margin, Scale, Behavior, RangeSelectorTypes, ValueAxis as RangeAxis 
} from 'devextreme-react/range-selector';
import { CreateUrl, CallGetAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { APILoggerDetail, buildAPILoggerDetail } from '../../models/APILoggerDetail';
import ApiFailed from '../../Utils/ApiFailed';
import ClipLoader from "react-spinners/ClipLoader";
import { APIGetLoggerReadingsModel, buildAPIGetLoggerReadingsModel } from '../../models/APIGetLoggerReadingsModel';
import moment from 'moment'
import { decodeFlowMultiplier } from 'Utils/FlowMultiplier';
import { adjustTime } from '../../Utils/AdjustTime'
import DateRange from '../../components/Dates/DateRange';
import CardHeader from "components/Card/CardHeader.js";
import { withStyles, createStyles } from '@mui/styles';
import { Grid, Switch } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { VisualRange } from 'devextreme-react/common/charts';
import { TextField, Chip, Button, Select, MenuItem, Checkbox } from "@mui/material"
import Modal from 'react-bootstrap/Modal';
import { Item } from 'devextreme-react/tab-panel';
import Tabs from 'devextreme-react/tabs'
import { PeriodStatsCHR } from '../../components/Readings/PeriodStatsCHR'
import { PeriodStatsTOR } from '../../components/Readings/PeriodStatsTOR'
import { Export } from 'devextreme-react/data-grid';
import { enumChariotAlarmInput } from '../../models/enumChariotAlarmInput';
import { enumChariotAlarmOperator } from '../../models/enumChariotAlarmOperator';
import GraphSettingsComponent from '../../components/Graphing Functions/GraphSettingsComponent'
import { GraphTemplate, graphTemplateModel, GraphSettings, deepCopyAshridgeDefault } from '../../models/GraphTemplateModel'
import { NotificationManager } from 'react-notifications';
import ExcelJS, { Column } from 'exceljs';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { Radio, useTheme } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Tooltip as TooltipMUI } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { isLCLLogger } from 'variables/chariotProductIds';
import { Redirect } from "react-router-dom";
import GraphChannelDisplay from "../../components/Graphing Functions/graphChannelDisplay";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import GraphRangeSelector from "../../components/Graphing Functions/GraphRangeSelector";
import { FormattedMessage, useIntl } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import {flowConverter, pressureConverter, totalConverter, flowRateUnits, flowUnits, pressureUnits } from '../../Utils/UnitConverters'
import { drawGraph, SiteDetails, Readings, MinMax, ImportedData } from '../../components/Graphing Functions/GraphUtilityFunctions'
import { loadLCAlarmLevels, Alarm, loadLoggerAlarmLevels, loadSiteAlarmLevels, checkAlarmAxisLevels } from '../../components/Graphing Functions/GraphAlarmLevelsFunctions'
import {onDateChange } from '../../components/Graphing Functions/GraphDateChangeFunctions'
import { exportConfirm } from '../../components/Graphing Functions/GraphExportData'
import { colors } from '../../components/Graphing Functions/GraphColors'
import { renderTooltip } from '../../components/Graphing Functions/GraphRenderTooltip'
import { DataGrid, Column as DataColumn, Export as DataExport, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting, DataGridTypes } from 'devextreme-react/data-grid';
import { CombinedFlowUnits, CombinedFlowValueAxis } from '../../components/Graphing Functions/GraphCombineFlowFunctions'
import Loader from '../../Utils/Loader/NewLoader2025'
import { renderImportedDataStrips } from '../../components/Graphing Functions/GraphImportDataRender'
import { unit } from "esri/layers/voxel/VoxelVariable";


interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            groupId: number | null;
            loggers: Array<number>;
            showBackButton: boolean;
            site: number | null;
            combinedFlowSiteId: number | null
        }
    }
    startDateProps: Date;
    endDateProps: Date;
    showDates: boolean;
    ref: React.RefObject<unknown>;
    fullscreen: boolean
    handleDateUpdate: (startDate: Date, endDate: Date) => void | null
}

interface RedirectProps {
    serial: number
    mapKey: string
}


interface ChannelInterval {
    interval: number
    count: number
}



interface MinMaxDisplay {
    serial: number
    'Channel A Min': string | null
    'Channel A Max': string | null
    'Channel A Avg': string | null
    'Channel B Min': string | null
    'Channel B Max': string | null
    'Channel B Avg': string | null
    'Channel C Min': string | null
    'Channel C Max': string | null
    'Channel C Avg': string | null
    'Channel D Min': string | null
    'Channel D Max': string | null
    'Channel D Avg': string | null
    'Channel E Min': string | null
    'Channel E Max': string | null
    'Channel E Avg': string | null
}


interface MNFValue {
    value: number
    ratio: number
}






const MultiLoggerGraphV2: React.FC<Props> = ({ classes, history, location, startDateProps, endDateProps, showDates, fullscreen , handleDateUpdate }) => {


    locale(sessionStorage.getItem("language"));
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);



    const intl = useIntl()
    const chartRef = useRef(null);
    const tabsRef = useRef(null)
    const styles: Record<any, any> = {
        formControl: {
            minWidth: 120,
        },
        cardCategoryWhite: {
            "&,& a,& a:hover,& a:focus": {
                color: "rgba(255,255,255,.62)",
                margin: "0",
                fontSize: "14px",
                marginTop: "0",
                marginBottom: "0"
            },
            "& a,& a:hover,& a:focus": {
                color: "#FFFFFF"
            }
        },
        cardTitleWhite: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            color: "#FFFFFF",
            minHeight: "auto",
            fontWeight: "300",
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
            textDecoration: "none",
            "& small": {
                color: "#777",
                fontSize: "65%",
                fontWeight: "400",
                lineHeight: "1"
            }
        }
    };

    const style = createStyles(styles);

    //UseEffect for initial load

    //useEffect(() => {
    //    setLoading(true)
    //    reloadData(location.state.groupId, location.state.loggers, location.state.site, null)
    //}, [])

    useEffect(() => {
        setLoading(true)
        reloadData(location.state.groupId, location.state.loggers, location.state.site, null)
    }, [location.state.loggers])


   



    //State
    const [loading, setLoading] = useState<boolean>(true)
    const [APIFailed, setAPIFailed] = useState<boolean>(false)
    const [authorised, setAuthorised] = useState<boolean>(true)
    const [siteNameUserFriendly, setSiteNameUserFriendly] = useState<string>("")
    const [siteName, setSiteName] = useState<string>("")
    const [startDate, setStartDate] = useState<moment>((startDateProps != null ? moment(startDateProps) : moment().subtract(7, "days")).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate())
    const [endDate, setEndDate] = useState<moment>(endDateProps != null ? moment(endDateProps) : moment().toDate())
    const [readingsData, setReadingsData] = useState<Array<APIGetLoggerReadingsModel>>([])
    const [graphData, setGraphData] = useState<Array<Readings>>([])
    const [loggers, setLoggers] = useState<Array<APILoggerDetail>>([])
    const [loggersToTemplate, setLoggersToTemplate] = useState<number | null>(null)
    const [ashridgeDefaultInUse, setAshridgeDefaultInUse] = useState<boolean>(false)
    ///modal
    const [createCompanyDefault, setCreateCompanyDefault] = useState<boolean>(false)
    const [createUserDefault, setCreateUserDefault] = useState<boolean>(false)
    const [createTemplateOpen, setCreateTemplateOpen] = useState<boolean>(false)
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [selectedTabName, setSelectedTabName] = useState<string>("")
    const [selectLoggerToTemplate, setSelectLoggerToTemplate] = useState<boolean>(false)
    ///Units an values State
    const [unitsAndValues, setUnitsAndValues] = useState<Array<GraphTemplate>>([])
    const [graphTemplate, setGraphTemplate] = useState<GraphTemplate>(graphTemplateModel)
    const [alarms, setAlarms] = useState<Array<Alarm>>([])
    const [checkAlarms, setCheckAlarms] = useState<boolean>(false)
    const [showFlow, setShowFlow] = useState<boolean>(false)
    const [showPressure, setShowPressure] = useState<boolean>(false)
    const [showMinMax, setShowMinMax] = useState<boolean>(false)
    const [hasPressureChannels, setHasPressureChannels] = useState<boolean>(false)
    const [hasTotal, setHasTotal] = useState<boolean>(false)
    const [hasConsumption, setHasConsumption] = useState<boolean>(false)
    const [hasFlow, setHasFlow] = useState<boolean>(false)
    const [showTotal, setShowTotal] = useState<boolean>(false)
    const [showConsumption, setShowConsumption] = useState<boolean>(false)
    const [showMNFAF, setShowMNFAF] = useState<boolean>(false)
    ///channel References 
    const [toggling, setToggling] = useState<boolean>(false)

    /// Range state
    const [visualRange, setVisualRange] = useState<VisualRange>({ startValue: startDate, endValue: endDate })
    const [exportAs, setExportAs] = useState<string>("CSV")
    const [exportModal, setExportModal] = useState<boolean>(false)
    const [noLoggersInGroup, setNoLoggersInGroup] = useState<boolean>(false)
    const [loggerSiteDetails, setLoggerSiteDetails] = useState<Array<SiteDetails>>([])
    const [enablePoint, setEnablePoint] = useState<boolean>(false)
    //redirect
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps>({serial: 0, mapKey: ""})
    const [combineY, setCombineY] = useState<boolean>(false)
    const [graphHeight, setGraphHeight] = useState<string>("50vh")
    const [combinedFlowAUnit, setCombinedFlowAUnit] = useState<string>("")
    const [combinedFlowBUnit, setCombinedFlowBUnit] = useState<string>("")
    const [combinedPressureCUnit, setCombinedPressureCUnit] = useState<string>("")
    const [combinedPressureDUnit, setCombinedPressureDUnit] = useState<string>("")
    const [combinedPressureEUnit, setCombinedPressureEUnit] = useState<string>("")
    const [combinedTotalAUnit, setCombinedTotalAUnit] = useState<string>("")
    const [combinedTotalBUnit, setCombinedTotalBUnit] = useState<string>("")
    const [combinedConsumptionAUnit, setCombinedConsumptionAUnit] = useState<string>("")
    const [combinedConsumptionBUnit, setCombinedConsumptionBUnit] = useState<string>("")
    const [splitDate, setSplitDate] = useState<boolean>(true)
    const [showButton, setShowButton] = useState<boolean>(false)
    const [shouldReloadData, setShouldReloadData]= useState<boolean>(false)
    const [hasDigital, setHasDigital] = useState<boolean>(false)
    const [showDigital, setShowDigital] = useState<boolean>(false)
    const [specifyTime, setSpecifyTime] = useState<boolean>(false)
    const [minMaxData, setMinMaxData] = useState<MinMax[]>()
    const [minMaxDisplay, setMinMaxDisplay] = useState<MinMaxDisplay[]>()
    const [minMaxModal, setMinMaxModal] = useState<boolean>(false)
    const [importData, setImportData] = useState<ImportedData>()
    const [showCombinedFlow, setShowCombinedFlow] = useState<boolean>(false)
    const [allowCombinedFlow, setAllowCombinedFlow] = useState<boolean>(true)
    const [combinedFlowUnits, setCombinedFlowUnits] = useState<CombinedFlowUnits>({ A: "", B: "" })
    const [isProcessingUnitChange, setIsProcessingUnitChange] = useState(false);
    const [exportPrintType, setExportPrintType] = useState<string>("")
    const [combinedFlowValueAxis, setCombinedFlowValueAxis] = useState<CombinedFlowValueAxis>(
        {
            A: { min: Number.MAX_VALUE, max: Number.NEGATIVE_INFINITY },
            B: { min: Number.MAX_VALUE, max: Number.NEGATIVE_INFINITY }

        }
    )
    const [MNFValue, setMNFValue] = useState<MNFValue>({value: 0, ratio: 0})
    const [combinedFlowGraphType, setCombinedFlowGraphType] = useState<string>("spline")




    const normaliseData = (graphData: Array<Readings>): Array<Readings> => {

        
        const minMaxValues = []
        graphData.forEach(data => {
            if (minMaxValues.length > 0 && minMaxValues.map(val => val.serial).includes(parseInt(data.serial))) {
                const selectedDevice = minMaxValues.filter(val => val.serial === parseInt(data.serial))[0]
                if (data.ChannelLetter === 'A') {
                    selectedDevice.flowAMin = Math.min(selectedDevice.flowAMin, data[`${data.serial}flowRateA`])
                    selectedDevice.flowAMax = Math.max(selectedDevice.flowAMax, data[`${data.serial}flowRateA`])
                    selectedDevice.flowATotalMin = Math.min(selectedDevice.flowATotalMin, data[`${data.serial}readingA`])
                    selectedDevice.flowATotalMax = Math.max(selectedDevice.flowATotalMax, data[`${data.serial}readingA`])
                    selectedDevice.flowAConsumptionMin = Math.min(selectedDevice.flowAConsumptionMin, data[`${data.serial}consumptionA`])
                    selectedDevice.flowAConsumptionMax = Math.max(selectedDevice.flowAConsumptionMax, data[`${data.serial}consumptionA`])
                }
                if (data.ChannelLetter === 'B') {
                    selectedDevice.flowBMin = Math.min(selectedDevice.flowBMin, data[`${data.serial}flowRateB`])
                    selectedDevice.flowBMax = Math.max(selectedDevice.flowBMax, data[`${data.serial}flowRateB`])
                    selectedDevice.flowBTotalMin = Math.min(selectedDevice.flowBTotalMin, data[`${data.serial}readingB`])
                    selectedDevice.flowBTotalMax = Math.max(selectedDevice.flowBTotalMax, data[`${data.serial}readingB`])
                    selectedDevice.flowBConsumptionMin = Math.min(selectedDevice.flowBConsumptionMin, data[`${data.serial}consumptionB`])
                    selectedDevice.flowBConsumptionMax = Math.max(selectedDevice.flowBConsumptionMax, data[`${data.serial}consumptionB`])
                }
                if (data.ChannelLetter === 'C') {
                    selectedDevice.pressureCMin = Math.min(selectedDevice.pressureCMin, data[`${data.serial}readingC`])
                    selectedDevice.pressureCMax = Math.max(selectedDevice.pressureCMax, data[`${data.serial}readingC`])
                }
                if (data.ChannelLetter === 'D') {
                    selectedDevice.pressureDMin = Math.min(selectedDevice.pressureDMin, data[`${data.serial}readingD`])
                    selectedDevice.pressureDMax = Math.max(selectedDevice.pressureDMax, data[`${data.serial}readingD`])
                }
                if (data.ChannelLetter === 'E') {
                    selectedDevice.pressureEMin = Math.min(selectedDevice.pressureEMin, data[`${data.serial}readingE`])
                    selectedDevice.pressureEMax = Math.max(selectedDevice.pressureEMax, data[`${data.serial}readingE`])
                }
            } else {
                minMaxValues.push({
                    serial: parseInt(data.serial),
                    flowAMin: data[`${data.serial}flowRateA`],
                    flowAMax: data[`${data.serial}flowRateA`],
                    flowATotalMin: data[`${data.serial}readingA`],
                    flowATotalMax: data[`${data.serial}readingA`],
                    flowAConsumptionMin: data[`${data.serial}consumptionA`],
                    flowAConsumptionMax: data[`${data.serial}consumptionA`],
                    flowBMin: data[`${data.serial}flowRateB`],
                    flowBMax: data[`${data.serial}flowRateB`],
                    flowBTotalMin: data[`${data.serial}readingB`],
                    flowBTotalMax: data[`${data.serial}readingB`],
                    flowBConsumptionMin: data[`${data.serial}consumptionB`],
                    flowBConsumptionMax: data[`${data.serial}consumptionB`],
                    pressureCMin: data[`${data.serial}readingC`],
                    pressureCMax: data[`${data.serial}readingC`],
                    pressureDMin: data[`${data.serial}readingD`],
                    pressureDMax: data[`${data.serial}readingD`],
                    pressureEMin: data[`${data.serial}readingE`],
                    pressureEMax: data[`${data.serial}readingE`],
                })
            }
            
        })
        const modifiedData = graphData.map(point => {
            const newpoint = {...point}
            const minMaxData = minMaxValues.filter(item => item.serial === parseInt(newpoint.serial))[0]
            if (newpoint.ChannelLetter === 'A') {
                newpoint[`${parseInt(point.serial)}flowRateA`] = (newpoint[`${parseInt(newpoint.serial)}flowRateA`] - minMaxData.flowAMin) / (minMaxData.flowAMax - minMaxData.flowAMin)
                newpoint[`${parseInt(point.serial)}readingA`] = (newpoint[`${parseInt(newpoint.serial)}readingA`] - minMaxData.flowATotalMin) / (minMaxData.flowATotalMax - minMaxData.flowATotalMin)
                newpoint[`${parseInt(point.serial)}consumptionA`] = (newpoint[`${parseInt(newpoint.serial)}consumptionA`] - minMaxData.flowAConsumptionMin) / (minMaxData.flowAConsumptionMax - minMaxData.flowAConsumptionMin)
            }
            if (newpoint.ChannelLetter === 'B') {
                newpoint[`${parseInt(point.serial)}flowRateB`] = (newpoint[`${parseInt(newpoint.serial)}flowRateB`] - minMaxData.flowBMin) / (minMaxData.flowBMax - minMaxData.flowBMin)
                newpoint[`${parseInt(point.serial)}readingB`] = (newpoint[`${parseInt(newpoint.serial)}readingB`] - minMaxData.flowBTotalMin) / (minMaxData.flowBTotalMax - minMaxData.flowBTotalMin)
                newpoint[`${parseInt(point.serial)}consumptionB`] = (newpoint[`${parseInt(newpoint.serial)}consumptionB`] - minMaxData.flowBConsumptionMin) / (minMaxData.flowBConsumptionMax - minMaxData.flowBConsumptionMin)
            }
            if (newpoint.ChannelLetter === 'C') {
                newpoint[`${parseInt(point.serial)}readingC`] = (newpoint[`${parseInt(newpoint.serial)}readingC`] - minMaxData.pressureCMin) / (minMaxData.pressureCMax - minMaxData.pressureCMin)
            }
            if (newpoint.ChannelLetter === 'D') {
                newpoint[`${parseInt(point.serial)}readingD`] = (newpoint[`${parseInt(newpoint.serial)}readingD`] - minMaxData.pressureDMin) / (minMaxData.pressureDMax - minMaxData.pressureDMin)
            }
            if (newpoint.ChannelLetter === 'E') {
                newpoint[`${parseInt(point.serial)}readingE`] = (newpoint[`${parseInt(newpoint.serial)}readingE`] - minMaxData.pressureEMin) / (minMaxData.pressureEMax - minMaxData.pressureEMin)
            }
            return newpoint
        })


        return modifiedData
    }
    //Use Memo to normalise data for Range finder to between 0 and 1
    const normalisedData = useMemo(() => {
        if (graphData.length > 0) {
            return normaliseData(graphData)
        }
        return []  // <-- Return empty array instead of undefined
    }, [graphData])



    useEffect(() => {
        if (minMaxData && minMaxData.length > 0) {

            const display: MinMaxDisplay[] = []
            minMaxData.forEach(item => {
                const unitDetails = unitsAndValues.find(u => u.serial === item.serial)
                
                const r: MinMaxDisplay | null = {}
                r.serial = item.serial ? item.serial : 'Combined Flow'
                if (unitDetails && unitDetails.channelsAvail & 0x01) {
                    r['Channel A Min'] = `${item.A.min} ${unitDetails.graphSettings?.flowAUnit}`
                    r['Channel A Max'] = `${item.A.max} ${unitDetails.graphSettings?.flowAUnit}`
                    r['Channel A Avg'] = `${item.A.min === 0 && item.A.max === 0 ? 0 : item.A.avg} ${unitDetails.graphSettings?.flowAUnit}`
                }
                if (unitDetails && unitDetails.channelsAvail & 0x02) {
                    r['Channel B Min'] = `${item.B.min} ${unitDetails.graphSettings?.flowBUnit}`
                    r['Channel B Max'] = `${item.B.max} ${unitDetails.graphSettings?.flowBUnit}`
                    r['Channel B Avg'] = `${item.B.min === 0 && item.B.max === 0 ? 0 : item.B.avg} ${unitDetails.graphSettings?.flowBUnit}`
                }
                if (unitDetails && unitDetails.channelsAvail & 0x04) {
                    r['Channel C Min'] = `${item.C.min} ${unitDetails.graphSettings?.pressureCUnit}`
                    r['Channel C Max'] = `${item.C.max} ${unitDetails.graphSettings?.pressureCUnit}`
                    r['Channel C Avg'] = `${item.C.min === 0 && item.C.max === 0 ? 0 : item.C.avg} ${unitDetails.graphSettings?.pressureCUnit}`
                }
                if (unitDetails && unitDetails.channelsAvail & 0x08) {
                    r['Channel D Min'] = `${item.D.min} ${unitDetails.graphSettings?.pressureDUnit}`
                    r['Channel D Max'] = `${item.D.max} ${unitDetails.graphSettings?.pressureDUnit}`
                    r['Channel D Avg'] = `${item.D.min === 0 && item.D.max === 0 ? 0 : item.D.avg} ${unitDetails.graphSettings?.pressureDUnit}`
                }
                if (unitDetails && unitDetails.channelsAvail & 0x10) {
                    r['Channel E Min'] = `${item.E.min} ${unitDetails.graphSettings?.pressureEUnit}`
                    r['Channel D Max'] = `${item.E.max} ${unitDetails.graphSettings?.pressureEUnit}`
                    r['Channel D Avg'] = `${item.E.min === 0 && item.E.max === 0 ? 0 : item.E.avg} ${unitDetails.graphSettings?.pressureEUnit}`
                }
                if (item.serial === null) {
                    r['Channel A Min'] = `${item.A.min} ${unitsAndValues[0].graphSettings.flowACombinedUnit}`
                    r['Channel A Max'] = `${item.A.max} ${unitsAndValues[0].graphSettings.flowACombinedUnit}`
                    r['Channel A Avg'] = `${item.A.min === 0 && item.A.max === 0 ? 0 : item.A.avg} ${unitsAndValues[0].graphSettings.flowACombinedUnit}`
                }
                
                
                
                display.push(r)

            })
            setMinMaxDisplay(display)
        }
    }, [minMaxData])

    useEffect(() => {
            if (isProcessingUnitChange) {
                setLoading(false);
                setIsProcessingUnitChange(false);
            } 
    }, [graphData, unitsAndValues]);



    ///gets user settings for combineY and applies fo rthe last time the viewed the graph
    useEffect(() => {
        if (loggers.length > 1) {
            CallGetAPI(CreateUrl(`/api/aquaguard/usersettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=Graph`), {})
                .then(data => {

                    data.forEach(d => { 
                    if (d.settingsKey === 'CombineY' && d.settingsValue === 'true') {
                        handleCombineY()
                        }
                    })
                })
                .catch(err => console.error(err))
        }
    }, [loggers])


    /// Functions

    const reloadData = (groupId: number | null, loggersProps: Array<number>, site: number | null, dateChange: boolean | null): boolean => {

        setAlarms([])
        setLoading(true)
        setCheckAlarms(false)
        if (groupId != null && groupId != 0) {

            // Group selected - graph loggers deployed to sites in group
            CallGetAPI(CreateUrl('/api/aquaguard/GetAllLoggersForGroup?groupid=' + groupId), {})
                .then(data => {
            
                    if (data.length > 0) {

                        let siteId = 0;
                        // Copy the data records into deviceData, adding the clickEvent
                        const records: Array<APILoggerDetail> = [];
                        for (let i = 0; i < data.length; i++) {
                            const rec = buildAPILoggerDetail(data[i])
                            records.push(rec);

                            if (rec.FkSiteId != null) {
                                if (siteId == 0) {
                                    siteId = rec.FkSiteId;
                                }
                                else {
                                    // Check if all loggers from same site
                                    if (siteId != rec.FkSiteId) {
                                        siteId = -1;
                                    }
                                }
                            }
                        }

                        //// Load alarm levels if single Chariot logger
                        if (records.length === 1) {
                            if (records[0].LoggerId > 500000) {
                                loadLCAlarmLevels(records[0].Serial, setAlarms)
                            }
                            else {
                                loadLoggerAlarmLevels(records[0].Serial, startDate, endDate, setAlarms);
                            }
                        }
                        
                            if (siteId > 0) {
                                // Load alarm levels for Site if all loggers deployed to same site
                                if (records[0].FkSiteId != null) {
                                    loadSiteAlarmLevels(siteId, alarms, setAlarms);
                                }
                            }
                        
                        
                        drawGraph(
                            records,
                            null,
                            dateChange,
                            setLoggerSiteDetails,
                            setLoading,
                            setAshridgeDefaultInUse,
                            setAPIFailed,
                            setAuthorised,
                            startDate,
                            endDate,
                            setStartDate,
                            setVisualRange,
                            setHasFlow,
                            setHasTotal,
                            setHasConsumption,
                            setHasPressureChannels,
                            setShowMinMax,
                            setShowFlow,
                            setShowPressure,
                            setShowTotal,
                            setShowConsumption,
                            setGraphData,
                            setReadingsData,
                            setUnitsAndValues,
                            setCheckAlarms,
                            setLoggers,
                            setLoggersToTemplate,
                            setHasDigital,
                            setShowDigital,
                            setMinMaxData,
                            setImportData,
                            setShowCombinedFlow,
                            location.state.combinedFlowSiteId
                        );

                    }
                    else {
  
                        setNoLoggersInGroup(true)
                        setLoading(false)
                    }

                })
                .catch((error) => {
                    console.log(error);
                    setAPIFailed(true)
                    setAuthorised(false)

                })
        }

        if (loggersProps?.length > 0) {
            // List of loggers selected
            
            const loggerIds: Array<{ Id: number }> = [];
            let selectedLoggers = []
            if (loggersProps.length > 1) {
                selectedLoggers = sessionStorage.getItem('selectedLoggers').split(',').map(item => parseInt(item))
            } else {
                selectedLoggers.push(parseInt(sessionStorage.getItem('selectedLoggers')))
            }

            if (loggersProps.length > 0) {
                loggersProps.map((l) => {
                    if (selectedLoggers.includes(l)) {
                        loggerIds.push({ Id: l });
                    }
                });
            }

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(loggerIds)
            };

            CallGetAPI(CreateUrl('/api/aquaguard/LoggerDetailsByIdList'), requestOptions)
                .then(data => {
                   
                    
                    if (data.length > 0) {
                        // Copy the data records into deviceData, adding the clickEvent
                        const records: Array<APILoggerDetail> = [];
                        let siteId = 0;

                        for (let i = 0; i < data.length; i++) {
                            const rec = buildAPILoggerDetail(data[i])

                            records.push(rec);

                            if (rec.FkSiteId != null) {
                                if (siteId == 0) {
                                    siteId = rec.FkSiteId;
                                }
                                else {
                                    // Check if all loggers from same site
                                    if (siteId != rec.FkSiteId) {
                                        siteId = -1;
                                    }
                                }
                            }
                        }

                        // Load alarm levels if single Chariot logger
                        if (records.length === 1) {
                            if (records[0].LoggerId > 500000) {
                                loadLCAlarmLevels(records[0].Serial, setAlarms, alarms)
                            }
                            else {

                                loadLoggerAlarmLevels(records[0].Serial, startDate, endDate, alarms, setAlarms);
                            }
                        }
                        
                        drawGraph(
                            records,
                            null,
                            dateChange,
                            setLoggerSiteDetails,
                            setLoading,
                            setAshridgeDefaultInUse,
                            setAPIFailed,
                            setAuthorised,
                            startDate,
                            endDate,
                            setStartDate,
                            setVisualRange,
                            setHasFlow,
                            setHasTotal,
                            setHasConsumption,
                            setHasPressureChannels,
                            setShowMinMax,
                            setShowFlow,
                            setShowPressure,
                            setShowTotal,
                            setShowConsumption,
                            setGraphData,
                            setReadingsData,
                            setUnitsAndValues,
                            setCheckAlarms,
                            setLoggers,
                            setLoggersToTemplate,
                            setHasDigital,
                            setShowDigital,
                            setMinMaxData,
                            setImportData,
                            setShowCombinedFlow,
                            location.state.combinedFlowSiteId
                        );

                    }
                    else {
                        drawGraph(
                            [],
                            null,
                            dateChange,
                            setLoggerSiteDetails,
                            setLoading,
                            setAshridgeDefaultInUse,
                            setAPIFailed,
                            setAuthorised,
                            startDate,
                            endDate,
                            setStartDate,
                            setVisualRange,
                            setHasFlow,
                            setHasTotal,
                            setHasConsumption,
                            setHasPressureChannels,
                            setShowMinMax,
                            setShowFlow,
                            setShowPressure,
                            setShowTotal,
                            setShowConsumption,
                            setGraphData,
                            setReadingsData,
                            setUnitsAndValues,
                            setCheckAlarms,
                            setLoggers,
                            setLoggersToTemplate,
                            setHasDigital,
                            setShowDigital,
                            setMinMaxData,
                            setImportData,
                            setShowCombinedFlow,
                            location.state.combinedFlowSiteId
                        );
                    }

                })
                .catch((error) => {
                    console.log(error)
                    setAPIFailed(true)
                    setAuthorised(false)
                        
                });
        }

        // For site just pull readings and alarm levels for site
        if (site != null && site != 0) {
            let extractedData = []
            let loggerIds: Array<{ Id: number }> = [];
            //TODO: Need to get SiteUserFriendlyName
            CallGetAPI(CreateUrl('/api/aquaguard/site?id=' + site), {})
                .then(data => {

                    if (data.siteNameUserFriendly != null) {
                        setSiteNameUserFriendly(data.siteNameUserFriendly.length > 0 ? data.siteNameUserFriendly : "") 
                        setSiteName(data.siteName.length > 0 ? data.siteName : "")
                    }
                    else {
                        setSiteNameUserFriendly(data.siteName.length > 0 ? data.siteName : "")
                        setSiteName(data.siteName.length > 0 ? data.siteName : "")
                    }
                    
                    CallGetAPI(CreateUrl('/api/aquaguard/HistoryForSite?siteId=' + site), {})
                        .then(data => {
                           extractedData = []
                           extractedData = data.filter(item => {
 
                               if (!moment(item.startDate).isAfter(endDate)) {
                                   if (item.endDate === null) {
                                       return item
                                   } else if (!moment(item.endDate).isBefore(startDate)) {

                                       return item
                                   }
                               }
                           })
                            extractedData = extractedData.filter((item, index, self) => index === self.findIndex(obj => obj.serial === item.serial))

                            if (extractedData.length > 0) {
                                loggerIds = []
                                extractedData.forEach(p => loggerIds.push({ Id: p.loggerId }))
                                const requestOptions = {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify(loggerIds)
                                };

                                CallGetAPI(CreateUrl('/api/aquaguard/LoggerDetailsByIdList'), requestOptions)
                                    .then(data => {
                                        const records: Array<APILoggerDetail> = [];
                                        const siteDeetsTemp = []

                                        for (let i = 0; i < data.length; i++) {
                                            const rec = buildAPILoggerDetail(data[i])

                                            records.push(rec);
                                            
                                            siteDeetsTemp.push({ siteRef: data.SiteName, siteName: data.SiteNameUserFriendly, serial: rec.Serial })
                                        }
                                        setLoggerSiteDetails(siteDeetsTemp)
                                        drawGraph(
                                            records,
                                            site,
                                            dateChange,
                                            setLoggerSiteDetails,
                                            setLoading,
                                            setAshridgeDefaultInUse,
                                            setAPIFailed,
                                            setAuthorised,
                                            startDate,
                                            endDate,
                                            setStartDate,
                                            setVisualRange,
                                            setHasFlow,
                                            setHasTotal,
                                            setHasConsumption,
                                            setHasPressureChannels,
                                            setShowMinMax,
                                            setShowFlow,
                                            setShowPressure,
                                            setShowTotal,
                                            setShowConsumption,
                                            setGraphData,
                                            setReadingsData,
                                            setUnitsAndValues,
                                            setCheckAlarms,
                                            setLoggers,
                                            setLoggersToTemplate,
                                            setHasDigital,
                                            setShowDigital,
                                            setMinMaxData,
                                            setImportData,
                                            setShowCombinedFlow,
                                            location.state.combinedFlowSiteId
                                            
                                        );
                                    })
                            } else {
                                drawGraph(
                                    [],
                                    site,
                                    dateChange,
                                    setLoggerSiteDetails,
                                    setLoading,
                                    setAshridgeDefaultInUse,
                                    setAPIFailed,
                                    setAuthorised,
                                    startDate,
                                    endDate,
                                    setStartDate,
                                    setVisualRange,
                                    setHasFlow,
                                    setHasTotal,
                                    setHasConsumption,
                                    setHasPressureChannels,
                                    setShowMinMax,
                                    setShowFlow,
                                    setShowPressure,
                                    setShowTotal,
                                    setShowConsumption,
                                    setGraphData,
                                    setReadingsData,
                                    setUnitsAndValues,
                                    setCheckAlarms,
                                    setLoggers,
                                    setLoggersToTemplate,
                                    setHasDigital,
                                    setShowDigital,
                                    setMinMaxData,
                                    setImportData,
                                    setShowCombinedFlow,
                                    location.state.combinedFlowSiteId
                                );
                            }
                            
                        })

                })
                .catch((error) => {
                    console.log(error);
                    setAPIFailed(true)
                    setAuthorised(false)
                });


            
        }

        return true;
    }


    useEffect(() => {
        if (alarms.length > 0) {

            checkAlarmAxisLevels(unitsAndValues, alarms, setUnitsAndValues);
        }
    }, [alarms, checkAlarms]);






    const removeLogger = (serial: number): void => {
        const loggersRemove = [ ...loggers ];
        
        const idx = loggersRemove.findIndex((l) => l.Serial == serial);
        loggersRemove.splice(idx, 1);

        if (loggersRemove.length > 1) {
            sessionStorage.setItem('selectedLoggers', loggersRemove.map(logger => logger.LoggerId.toString()).join())
        } else {
            sessionStorage.setItem('selectedLoggers', loggersRemove[0].LoggerId.toString())
        }
            setLoggers(loggersRemove)
    }
    const handleRedrawClick = (): void => {

        setShowButton(false)
        setGraphData([])
        //setUnitsAndValues([])
        if (handleDateUpdate) {
            handleDateUpdate(startDate, endDate)
        }

        reloadData(location.state?.groupId ? location.state?.groupId : 0, location.state?.loggers, location.state?.site, true);
        setVisualRange({startValue: startDate, endValue: endDate})
    }

    useEffect(() => {
        if (shouldReloadData) {
            if (handleRedrawClick) {
                handleRedrawClick()
            }
            setShouldReloadData(false)
        }
    }, [startDate, endDate, shouldReloadData])




    const updateVisualRange = useCallback((e: RangeSelectorTypes.ValueChangedEvent) => {
        if (handleDateUpdate) {
            handleDateUpdate(e.value[0], e.value[1])
        }
        if (!showButton) setVisualRange(e.value);
        
    }, [visualRange, showButton]);





    useEffect(() => {
        console.log(location.state.combinedFlowSiteId)
        if (showMNFAF) {
            if (window.location.pathname.includes('SiteDetail')) {
                CallGetAPI(CreateUrl(`/api/aquaguard/getmnf?siteId=${location.state.combinedFlowSiteId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`), {})
                    .then(data => {
                        console.log(data)
                        let MNF = Number.MAX_VALUE
                        data.forEach(d => {
                            if (d.minValue < MNF) {
                                MNF = d.minValue
                            }
                        })
                        console.log(MNF, minMaxData)
                        const ratio = MNF / minMaxData[loggers.length].A.avg
                        setMNFValue({
                            value: parseFloat(MNF.toFixed(3)),
                            ratio: ratio
                        })
                    })
                     
                
            } else {
                CallGetAPI(CreateUrl(`/api/aquaguard/getmnf?serial=${loggers[0].Serial}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`), {})
                    .then(data => {
                        console.log(data, minMaxDisplay, minMaxData)
                        let MNF = Number.MAX_VALUE
                        data.forEach(d => {
                            if (d.minValue < MNF) {
                                MNF = d.minValue
                            }
                        })
                        const ratio = MNF / minMaxData[0].A.avg
                        setMNFValue({
                            value: parseFloat(MNF.toFixed(3)),
                            ratio: ratio
                        })
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        }
    }, [showMNFAF])



    const toggleCreateTemplateOpen = (isSelected: boolean | null, companyDefault: boolean | null, userDefault: boolean | null): void => {

        if (companyDefault) {
            const newTemplate: GraphTemplate = deepCopyAshridgeDefault(graphTemplate)
            newTemplate.channelsAvail = 31
            setGraphTemplate(newTemplate)
            setCreateTemplateOpen(!createTemplateOpen)
        } else if (userDefault) {
            const newTemplate: GraphTemplate = deepCopyAshridgeDefault(graphTemplate)
            newTemplate.channelsAvail = 31
            setGraphTemplate(newTemplate)
            setCreateTemplateOpen(!createTemplateOpen)
        } else {
            if ((sessionStorage.getItem('userLevel') === 'useradmin' || sessionStorage.getItem('userLevel') === 'identityadmin') && loggers.length === 1 && !isSelected) {
 
                setCreateTemplateOpen(false)
                setSelectLoggerToTemplate(true)
            }
            else if (loggers.length > 1) {
                if (!isSelected) {

                    setSelectLoggerToTemplate(!selectLoggerToTemplate)
                } else {
 
                    const templateToLoad = unitsAndValues.filter(item => item.serial === (loggersToTemplate))
                    setGraphTemplate(templateToLoad[0])
                    setCreateTemplateOpen(!createTemplateOpen)
                }
            } else {

                const templateToLoad = unitsAndValues.filter(item => item.serial === (loggersToTemplate))

                setGraphTemplate(templateToLoad[0])
                setCreateTemplateOpen(!createTemplateOpen)
            }
        }
    }

    const handleLoggerTemplateChange = (value: number): void => {
        setLoggersToTemplate(value)
    }

    const toggleCreateCompanyDefault = ():void => {
        setCreateCompanyDefault(!createCompanyDefault)
        toggleCreateTemplateOpen(false, true, false)
    }

    const toggleCreateUserDefault = (): void => { 
        setCreateUserDefault(!createUserDefault)
        toggleCreateTemplateOpen(false, false, true)
    }

    const closeGraphTemplateWindow = ():void => {
        setCreateTemplateOpen(false)
        setCreateCompanyDefault(false)
        setCreateUserDefault(false)
        setSelectLoggerToTemplate(false)
        setSelectedTab(0)
        setSelectedTabName("")
        setTimeout(reloadData(location.state.groupId, location.state.loggers, location.state.site, null), 500)
    }

    const handlePostGraphTemplate = (): void => {


        interface RequestInit {
            method: string
            headers: {
                'Content-Type': string
            }
            body: string
        }

        const info = { ...graphTemplate }
        if (info.graphSettings.flowAIsDigital) {
            info.graphSettings.flowAUnit = 'l/s'
        }
        if (info.graphSettings.flowBIsDigital) {
            info.graphSettings.flowBUnit = 'l/s'
        }
        const settings = JSON.stringify(info.graphSettings)
        
        let requestOptions = {}
        if (createCompanyDefault && sessionStorage.getItem('companyId') !== null) {
            const confirm = window.confirm(intl.formatMessage({ id: 'Are you sure you want to overwrite the company default?' }))
            if (!confirm) return
            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    serial: null,
                    siteId: null,
                    fkCompanyId: parseInt(sessionStorage.getItem('companyId')),
                    graphSettings: settings,
                    userId: null
                })
            };

        } else if (createUserDefault) {
            const confirm = window.confirm(intl.formatMessage({ id: 'Are you sure you want to overwrite your default settings?' }))
            if (!confirm) return
            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    serial: null,
                    siteId: null,
                    fkCompanyId: parseInt(sessionStorage.getItem('companyId')),
                    graphSettings: settings,
                    userId: parseInt(sessionStorage.getItem('userId'))
                })
            };

        } else {
            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    serial: parseInt(info.serial),
                    siteId: parseInt(info.siteId),
                    fkCompanyId: parseInt(sessionStorage.getItem('companyId')),
                    graphSettings: settings,
                    userId: parseInt(sessionStorage.getItem('userId'))
                })
            };
        }
        if (!window.location.pathname.includes('SiteDetail') || createUserDefault || (createCompanyDefault && sessionStorage.getItem('companyId') !== null)) {
            CallPostAPI(CreateUrl('/api/aquaguard/graphtemplate'), requestOptions)
                .then(data => {
                    createSuccessNotification()
                    closeGraphTemplateWindow()
                    setTimeout(reloadData(location.state.groupId, location.state.loggers, location.state.site, null), 500)

                })
                .catch(err => {
                    console.log(err)
                    createErrorNotification()
                })
        } else {
            //deal with combined flow chnages
            const graphTemplateUpdatePromises = loggers.map((log) => {
                if (info.serial === log.Serial) {
                    return CallPostAPI(CreateUrl('/api/aquaguard/graphtemplate'), requestOptions);
                }

                const unitAndValueForLogger = unitsAndValues.find(sett => sett.serial === log.Serial);
                const loggerGraphSettings = unitAndValueForLogger?.graphSettings;
                const newGraphSettings = info.graphSettings;

                if (loggerGraphSettings) {
                    loggerGraphSettings.flowACombinedVisible = newGraphSettings.flowACombinedVisible;
                    loggerGraphSettings.flowACombinedUnit = newGraphSettings.flowACombinedUnit;
                    loggerGraphSettings.flowACombinedMinState = newGraphSettings.flowACombinedMinState;
                    loggerGraphSettings.flowACombinedMaxState = newGraphSettings.flowACombinedMaxState;
                    loggerGraphSettings.flowACombinedMinValue = newGraphSettings.flowACombinedMinValue;
                    loggerGraphSettings.flowACombinedMaxValue = newGraphSettings.flowACombinedMaxValue;
                    loggerGraphSettings.flowACombinedOriginalMax = newGraphSettings.flowACombinedOriginalMax;
                    loggerGraphSettings.flowACombinedOriginalMin = newGraphSettings.flowACombinedOriginalMin;
                    loggerGraphSettings.flowACombinedAxisPosition = newGraphSettings.flowACombinedAxisPosition;
                    loggerGraphSettings.flowACombinedGraphType = newGraphSettings.flowACombinedGraphType;
                    loggerGraphSettings.flowACombinedLineWidth = newGraphSettings.flowACombinedLineWidth;
                    loggerGraphSettings.flowACombinedColor = newGraphSettings.flowACombinedColor;
                    loggerGraphSettings.flowACombinedDefaultColor = newGraphSettings.flowACombinedDefaultColor;
                    loggerGraphSettings.flowACombinedLabelSize = newGraphSettings.flowACombinedLabelSize;
                }

                const loggerRequestOptions: RequestInit = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        serial: unitAndValueForLogger?.serial,
                        siteId: unitAndValueForLogger?.siteId,
                        fkCompanyId: parseInt(sessionStorage.getItem('companyId') ?? '0'),
                        graphSettings: JSON.stringify(loggerGraphSettings),
                        userId: parseInt(sessionStorage.getItem('userId') ?? '0')
                    })
                };

                return CallPostAPI(CreateUrl('/api/aquaguard/graphtemplate'), loggerRequestOptions);
            });

            Promise.all(graphTemplateUpdatePromises)
                .then(() => {
                    createSuccessNotification();
                    closeGraphTemplateWindow();
                    setTimeout(() => {
                        reloadData(location.state.groupId, location.state.loggers, location.state.site, null);
                    }, 500);
                })
                .catch((err) => {
                    console.log(err);
                    createErrorNotification();
                });
        }
    }

    
    //NOTIFICATIONS
    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Template' }), 'Success')

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }));
    };

    const handleGraphSettingsChange = (name: string, value: any, channel: string): void => {
        const graphTemplateTemp = { ...graphTemplate };  
        if (isNaN(value) && typeof (value) !== 'string') {
                value = 0
        }
        if (name === "DisplayAll" && value === true) {
            graphTemplateTemp.graphSettings[`${channel}ValueAs`] = 'mean'
        }
        graphTemplateTemp.graphSettings[`${channel}${name}`] = value;

        setGraphTemplate(graphTemplateTemp);
    };

    //const colors = {
    //    red: ["#B22222", "#8B0000", "#DC143C", "#D2691E", "#E34234", "#CD5C5C", "#A52A2A", "#FA8072", "#FF4500", "#C71585"],
    //    yellow: ["#B8860B", "#DAA520", "#FFD700", "#FFC125", "#F4C430", "#CD9B1D", "#FFDEAD", "#EEDC82", "#FFCC00", "#FADA5E"],
    //    brown: ["#8B4513", "#A0522D", "#6B4423", "#8B5A2B", "#995C32", "#704214", "#5C4033", "#D2B48C", "#A67B5B", "#C19A6B"],
    //    green: ["#006400", "#32CD32", "#228B22", "#00FF00", "#3CB371", "#ADFF2F", "#7FFF00", "#6B8E23", "#008000", "#9ACD32"],
    //    blue: ["#0000CD", "#87CEEB", "#1E90FF", "#4169E1", "#4682B4", "#00BFFF", "#6495ED", "#5F9EA0", "#007FFF", "#6A5ACD"],
    //    orange: ["#FF6F00", "#FFCC66", "#FFA500", "#FF8500", "#FF9F1C", "#FFB84D", "#E67E22", "#FF4500", "#F28500", "#D2691E"],
    //    purple: ["#800080", "#9370DB", "#8A2BE2", "#9400D3", "#DDA0DD", "#9932CC", "#BA55D3", "#DA70D6", "#6A0DAD", "#A020F0"],
    //    teal: ["#008080", "#20B2AA", "#40E0D0", "#5F9EA0", "#66CDAA", "#2E8B57", "#48D1CC", "#008B8B", "#00CED1", "#468189"],
    //    pink: ["#FF69B4", "#FF1493", "#DB7093", "#FFC0CB", "#FF91A4", "#D87093", "#FFB6C1", "#FF85A2", "#FF6EC7", "#E75480"]
    //};



    const renderAlarmSeries = (items, settings: GraphTemplate) => {
        let counter = 0
        let type = ""
        let unit = ""
        const alarmSeries = []
        items.forEach(item => {

           // if (settings.isAshridgeDefault) {
                switch (item.channel) {
                    case "A":
                        type = intl.formatMessage({ id: "Flow" })
                        unit = unitsAndValues[0].graphSettings.flowAUnit
                        break
                    case "B":
                        type = intl.formatMessage({ id: "Flow" })
                        unit = unitsAndValues[0].graphSettings.flowBUnit
                        break
                    case "C":
                        type = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Pressure / Analog" })
                        unit = unitsAndValues[0].graphSettings.pressureCUnit
                        break
                    case "D":
                        type = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Pressure / Analog" })
                        unit = unitsAndValues[0].graphSettings.pressureDUnit
                        break
                    case "E":
                        type = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Pressure / Analog" })
                        unit = unitsAndValues[0].graphSettings.pressureEUnit
                        break
            }


           // }
            if (item.operator === '>' && item.visible) {
                alarmSeries.push(<Strip startValue={item.maxValue} color={`${item.color}${item.transparency}`} key={`${item.color}${item.maxValue}`}>
                    <Label text={`${item.message} - ${intl.formatMessage({ id: 'Alarm' })} (${type} > ${item.maxValue} ${unit})`} font={{ size: item.labelSize, color: "#000000" }} ></Label>
                </Strip>)
                alarmSeries.push(<Strip startValue={item.minValue} endValue={item.maxValue} color={`#ffbf0030`} key={`${item.color}${item.maxValue}`}>
                </Strip>)
            }
            if (item.operator === '<' && item.visible) {
                alarmSeries.push(<Strip endValue={item.maxValue} startValue={item.minValue} color={`#ffbf00${item.transparency}`} key={`${item.color}${item.maxValue}`}>
                    <Label horizontalAlignment={'right'} text={`${item.message} - ${intl.formatMessage({ id: 'Alarm' })} (${type} < ${item.minValue} ${unit})`} font={{ size: item.labelSize, color: "#000000" }} ></Label>
                </Strip>)
                alarmSeries.push(<Strip endValue={item.minValue} color={`${item.color}${item.transparency}`} key={`${item.color}${item.maxValue}`}>
                   
                </Strip>)
            }
            counter++

        })

        return alarmSeries
    }

    //const renderCurrentMinMax = ():React.ReactNode => {
    //    const currentMinMaxSeries = []
    //    currentMinMaxSeries.push(<Strip endValue={currentMinMax.minC} color={unitsAndValues[0].graphSettings.pressureCColor + '33'}><Label text={`Min Value (${currentMinMax.minC})`}></Label></Strip>)
    //    currentMinMaxSeries.push(<Strip startValue={currentMinMax.maxC} color={unitsAndValues[0].graphSettings.pressureCColor + '33'}><Label text={`Max Value (${currentMinMax.maxC})`}></Label></Strip>)
    //    return currentMinMaxSeries
    //}

    //useEffect(() => {
    //    const unitsAndValuesTemp = [...unitsAndValues]

    //    if (currentMinMax.maxC > unitsAndValuesTemp[0]?.graphSettings.pressureCMaxValue) {
    //        unitsAndValuesTemp[0].graphSettings.pressureCMaxValue = currentMinMax.maxC
    //    }
    //    setUnitsAndValues(unitsAndValuesTemp)
    //}, [currentMinMax])
     

    const renderValueAxis = (logger) => {
        let counter = 0;
        const valueAxisArray = [];
        const hasCombinedAChannel = unitsAndValues.some(u => u.channelsAvail & 0x01)
        const hasCombinedBChannel = unitsAndValues.some(u => u.channelsAvail & 0x02)
        if (!combineY) {
            
            unitsAndValues.map(item => {
                const hasAlarms = item.alarms.length > 0
                const i = item.graphSettings
                // flow A
                let flowAMinValueLogger = 0;
                let flowAMaxValueLogger = 0; // Default value now dynamic
                let flowAColor = '';
                let flowAVisibleLogger = false;
                let flowAAxisPosition = '';
                let flowALabelSize = 0;
                let flowAUnit = '';
                let flowAMarginMin = 0
                let flowAMarginMax = 0


                ///Total A
                let flowATotalMinValueLogger = 0;
                let flowATotalMaxValueLogger = 0; // Default value now dynamic
                let flowATotalColor = '';
                let flowATotalVisibleLogger = false;
                let flowATotalAxisPosition = '';
                let flowATotalLabelSize = 0;
                let flowATotalUnit = '';
                let flowATotal24Hrs = false
                let flowATotalMarginMin = 0
                let flowATotalMarginMax = 0


                ///Consumption A
                let flowAConsumptionMinValueLogger = 0;
                let flowAConsumptionMaxValueLogger = 0; // Default value now dynamic
                let flowAConsumptionColor = '';
                let flowAConsumptionVisibleLogger = false;
                let flowAConsumptionAxisPosition = '';
                let flowAConsumptionLabelSize = 0;
                let flowAConsumptionUnit = '';
                let flowAConsumption24Hrs = false
                let flowAConsumptionMarginMin = 0
                let flowAConsumptionMarginMax = 0

                ///combined A
                let flowACombinedMinValueLogger = 0;
                let flowACombinedMaxValueLogger = 0; // Default value now dynamic
                let flowACombinedColor = '';
                let flowACombinedVisibleLogger = false;
                let flowACombinedAxisPosition = '';
                let flowACombinedLabelSize = 0;
                let flowACombinedUnit = '';
                let flowACombinedMarginMin = 0
                let flowACombinedMarginMax = 0



                //flow B
                let flowBMinValueLogger = 0;
                let flowBMaxValueLogger = 0; // Default value now dynamic
                let flowBColor = '';
                let flowBVisibleLogger = false;
                let flowBAxisPosition = '';
                let flowBLabelSize = 0;
                let flowBUnit = '';
                let flowBMarginMin = 0
                let flowBMarginMax = 0

                ///Consumption B
                let flowBConsumptionMinValueLogger = 0;
                let flowBConsumptionMaxValueLogger = 0; // Default value now dynamic
                let flowBConsumptionColor = '';
                let flowBConsumptionVisibleLogger = false;
                let flowBConsumptionAxisPosition = '';
                let flowBConsumptionLabelSize = 0;
                let flowBConsumptionUnit = '';
                let flowBConsumption24Hrs = false
                let flowBConsumptionMarginMin = 0
                let flowBConsumptionMarginMax = 0

                ///Total B
                let flowBTotalMinValueLogger = 0;
                let flowBTotalMaxValueLogger = 0; // Default value now dynamic
                let flowBTotalColor = '';
                let flowBTotalVisibleLogger = false;
                let flowBTotalAxisPosition = '';
                let flowBTotalLabelSize = 0;
                let flowBTotalUnit = '';
                let flowBTotal24Hrs = false
                let flowBTotalMarginMin = 0
                let flowBTotalMarginMax = 0

                //pressure C
                let pressureCMinValueLogger = 0;
                let pressureCMaxValueLogger = 0; // Default value now dynamic
                let pressureCColor = '';
                let pressureCVisibleLogger = false;
                let pressureCAxisPosition = '';
                let pressureCLabelSize = 0;
                let pressureCUnit = '';
                let pressureCChannelName = ""
                let pressureCMarginMin = 0
                let pressureCMarginMax = 0

                //pressure D
                let pressureDMinValueLogger = 0;
                let pressureDMaxValueLogger = 0; // Default value now dynamic
                let pressureDColor = '';
                let pressureDVisibleLogger = false;
                let pressureDAxisPosition = '';
                let pressureDLabelSize = 0;
                let pressureDUnit = '';
                let pressureDChannelName = ""
                let pressureDMarginMin = 0
                let pressureDMarginMax = 0

                //pressure E
                let pressureEMinValueLogger = 0;
                let pressureEMaxValueLogger = 0; // Default value now dynamic
                let pressureEColor = '';
                let pressureEVisibleLogger = false;
                let pressureEAxisPosition = '';
                let pressureELabelSize = 0;
                let pressureEUnit = '';
                let pressureEChannelName = ""
                let pressureEMarginMin = 0
                let pressureEMarginMax = 0
                // Match logger with item.serial and get graph settings
                if (item.serial === logger.Serial) {

                    //flow A
                    flowAMinValueLogger = i.flowAMinValue;
                    flowAMaxValueLogger = i.flowAMaxValue;
                    flowAVisibleLogger = i.flowAVisible;
                    flowAAxisPosition = i.flowAAxisPosition;
                    flowALabelSize = i.flowALabelSize;
                    flowAUnit = i.flowAUnit;
                    flowAMarginMin = i.flowAMinState === 'custom' ? 0 : 0.1
                    flowAMarginMax = i.flowAMaxState === 'custom' ? 0 : 0.1
                    //Total A
                    flowATotalMinValueLogger = i.flowATotalMinValue;
                    flowATotalMaxValueLogger = i.flowATotalMaxValue;
                    flowATotalVisibleLogger = i.flowATotalVisible;
                    flowATotalAxisPosition = i.flowATotalAxisPosition;
                    flowATotalLabelSize = i.flowATotalLabelSize;
                    flowATotalUnit = i.flowATotalUnit;
                    flowATotal24Hrs = i.flowATotalPerDay
                    flowATotalMarginMin = i.flowATotalMinState === 'custom' ? 0 : 0.1
                    flowATotalMarginMax = i.flowATotalMaxState === 'custom' ? 0 : 0.1

                    //Consumption A
                    flowAConsumptionMinValueLogger = i.flowAConsumptionMinValue;
                    flowAConsumptionMaxValueLogger = i.flowAConsumptionMaxValue;
                    flowAConsumptionVisibleLogger = i.flowAConsumptionVisible;
                    flowAConsumptionAxisPosition = i.flowAConsumptionAxisPosition;
                    flowAConsumptionLabelSize = i.flowAConsumptionLabelSize;
                    flowAConsumptionUnit = i.flowAConsumptionUnit;
                    flowAConsumption24Hrs = i.flowAConsumptionPerDay
                    flowAConsumptionMarginMin = i.flowAConsumptionMinState === 'custom' ? 0 : 0.1
                    flowAConsumptionMarginMax = i.flowAConsumptionMaxState === 'custom' ? 0 : 0.1


                    ///flow A combined

                    flowACombinedMinValueLogger = i.flowACombinedMinValue;
                    flowACombinedMaxValueLogger = i.flowACombinedMaxValue;
                    flowACombinedVisibleLogger = i.flowACombinedVisible;
                    flowACombinedColor = i.flowACombinedColor;
                    flowACombinedAxisPosition = i.flowACombinedAxisPosition;
                    flowACombinedLabelSize = i.flowACombinedLabelSize;
                    flowACombinedUnit = i.flowACombinedUnit;
                    flowACombinedMarginMin = i.flowACombinedMinState === 'custom' ? 0 : 0.1
                    flowACombinedMarginMax = i.flowACombinedMaxState === 'custom' ? 0 : 0.1


                    //flow B
                    flowBMinValueLogger = i.flowBMinValue;
                    flowBMaxValueLogger = i.flowBMaxValue;
                    flowBVisibleLogger = i.flowBVisible;
                    flowBAxisPosition = i.flowBAxisPosition;
                    flowBLabelSize = i.flowBLabelSize;
                    flowBUnit = i.flowBUnit;
                    flowBMarginMin = i.flowBMinState === 'custom' ? 0 : 0.1
                    flowBMarginMax = i.flowBMaxState === 'custom' ? 0 : 0.1

                    //Total B
                    flowBTotalMinValueLogger = i.flowBTotalMinValue;
                    flowBTotalMaxValueLogger = i.flowBTotalMaxValue;
                    flowBTotalVisibleLogger = i.flowBTotalVisible;
                    flowBTotalAxisPosition = i.flowBTotalAxisPosition;
                    flowBTotalLabelSize = i.flowBTotalLabelSize;
                    flowBTotalUnit = i.flowBTotalUnit;
                    flowBTotal24Hrs = i.flowBTotalPerDay
                    flowBTotalMarginMin = i.flowBTotalMinState === 'custom' ? 0 : 0.1
                    flowBTotalMarginMax = i.flowBTotalMaxState === 'custom' ? 0 : 0.1

                    //Consumption B
                    flowBConsumptionMinValueLogger = i.flowBConsumptionMinValue;
                    flowBConsumptionMaxValueLogger = i.flowBConsumptionMaxValue;
                    flowBConsumptionVisibleLogger = i.flowBConsumptionVisible;
                    flowBConsumptionAxisPosition = i.flowBConsumptionAxisPosition;
                    flowBConsumptionLabelSize = i.flowBConsumptionLabelSize;
                    flowBConsumptionUnit = i.flowBConsumptionUnit;
                    flowBConsumption24Hrs = i.flowBConsumptionPerDay
                    flowBConsumptionMarginMin = i.flowBConsumptionMinState === 'custom' ? 0 : 0.1
                    flowBConsumptionMarginMax = i.flowBConsumptionMaxState === 'custom' ? 0 : 0.1

                    // pressure C
                    pressureCMinValueLogger = i.pressureCMinValue
                    pressureCMaxValueLogger = i.pressureCMaxValue
                    pressureCVisibleLogger = i.pressureCVisible
                    pressureCAxisPosition = i.pressureCAxisPosition
                    pressureCLabelSize = i.pressureCLabelSize
                    pressureCUnit = i.pressureCUnit
                    pressureCMarginMin = i.pressureCMinState === 'custom' ? 0 : 0.1
                    pressureCMarginMax = i.pressureCMaxState === 'custom' ? 0 : 0.1

                    if (pressureUnits.map(unit => unit.value).includes(pressureCUnit)) {
                        pressureCChannelName = intl.formatMessage({ id: 'Pressure C' })
                    } else {
                        pressureCChannelName = intl.formatMessage({ id: 'Analog C' })
                    }

                    // pressure D
                    pressureDMinValueLogger = i.pressureDMinValue
                    pressureDMaxValueLogger = i.pressureDMaxValue
                    pressureDVisibleLogger = i.pressureDVisible
                    pressureDAxisPosition = i.pressureDAxisPosition
                    pressureDLabelSize = i.pressureDLabelSize
                    pressureDUnit = i.pressureDUnit
                    pressureDMarginMin = i.pressureDMinState === 'custom' ? 0 : 0.1
                    pressureDMarginMax = i.pressureDMaxState === 'custom' ? 0 : 0.1

                    if (pressureUnits.map(unit => unit.value).includes(pressureDUnit)) {
                        pressureDChannelName = intl.formatMessage({ id: 'Pressure D' })
                    } else {
                        pressureDChannelName = intl.formatMessage({ id: 'Analog D' })
                    }

                    // pressure E
                    pressureEMinValueLogger = i.pressureEMinValue
                    pressureEMaxValueLogger = i.pressureEMaxValue
                    pressureEVisibleLogger = i.pressureEVisible
                    pressureEAxisPosition = i.pressureEAxisPosition
                    pressureELabelSize = i.pressureELabelSize
                    pressureEUnit = i.pressureEUnit
                    pressureEMarginMin = i.pressureEMinState === 'custom' ? 0 : 0.1
                    pressureEMarginMax = i.pressureEMaxState === 'custom' ? 0 : 0.1

                    if (pressureUnits.map(unit => unit.value).includes(pressureEUnit)) {
                        pressureEChannelName = intl.formatMessage({ id: 'Pressure E' })
                    } else {
                        pressureEChannelName = intl.formatMessage({ id: 'Analog E' })
                    }
                }

                // Handle default and non-default values for color
                if (!item.isAshridgeDefault) {
                    if (i.flowADefaultColor) {
                        flowAColor = colors.red[counter];
                    } else {
                        flowAColor = i.flowAColor;
                    }
                    if (i.flowATotalDefaultColor) {
                        flowATotalColor = colors.yellow[counter];
                    } else {
                        flowATotalColor = i.flowATotalColor;
                    }
                    if (i.flowAConsumptionDefaultColor) {
                        flowAConsumptionColor = colors.teal[counter];
                    } else {
                        flowAConsumptionColor = i.flowAConsumptionColor;
                    }
                    if (i.flowBDefaultColor) {
                        flowBColor = colors.green[counter];
                    } else {
                        flowBColor = i.flowBColor;
                    }
                    if (i.flowBTotalDefaultColor) {
                        flowBTotalColor = colors.brown[counter];
                    } else {
                        flowBTotalColor = i.flowBTotalColor;
                    }
                    if (i.flowBConsumptionDefaultColor) {
                        flowBConsumptionColor = colors.pink[counter];
                    } else {
                        flowBConsumptionColor = i.flowBConsumptionColor;
                    }
                    if (i.pressureCDefaultColor) {
                        pressureCColor = colors.blue[counter]
                    } else {
                        pressureCColor = i.pressureCColor
                    }
                    if (i.pressureDDefaultColor) {
                        pressureDColor = colors.orange[counter]
                    } else {
                        pressureDColor = i.pressureDColor
                    }
                    if (i.pressureEDefaultColor) {
                        pressureEColor = colors.purple[counter]
                    } else {
                        pressureEColor = i.pressureEColor
                    }
                    counter === 9 ? counter = 0 : counter++;
                } else {
                    flowAColor = colors.red[counter];
                    flowATotalColor = colors.yellow[counter];
                    flowAConsumptionColor = colors.teal[counter];
                    flowBColor = colors.green[counter];
                    flowBTotalColor = colors.brown[counter];
                    flowBConsumptionColor = colors.pink[counter];
                    pressureCColor = colors.blue[counter]
                    pressureDColor = colors.orange[counter]
                    pressureEColor = colors.purple[counter]
                    counter === 9 ? counter = 0 : counter++;
                }
                
                // Only render the ValueAxis if it's visible
                if (flowAVisibleLogger && item.channelsAvail & 0x01) {

                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`A ${logger.Serial}`}
                            visualRange={item.graphSettings.flowAIsDigital ? { startValue: 0, endValue: 1 } : { startValue: flowAMinValueLogger, endValue: flowAMaxValueLogger }}
                            allowDecimals={true}
                            label={{
                                customizeText: (axisInfo) => {
                                    
                                    if (item.graphSettings.flowAIsDigital) {
                                        if (axisInfo.value === 1) {
                                            return 'ON'
                                        } else if (axisInfo.value === 0) {
                                            return 'OFF'
                                        } else return ''

                                    } else {
                                        return axisInfo.value
                                    }
                                },
                                font: { color: flowAColor }

                            }}
                            title={{ text: flowAMinValueLogger === Number.NEGATIVE_INFINITY && flowAMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelARef} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Flow A' })})` : `${logger.Serial} ${logger.ChannelARef} ${item.graphSettings.flowAIsDigital ? '' : intl.formatMessage({ id: "In" })} ${flowAUnit} ${item.graphSettings.flowAIsDigital ? "" : '(' + intl.formatMessage({ id: 'Flow A' }) + ')'}`, font: { color: flowAColor, size: flowALabelSize } }}
                            position={flowAAxisPosition}
                            color={flowAColor}
                            key={`A-${logger.Serial}`} // Unique key for each axis
                            minValueMargin={flowAMarginMin }
                            maxValueMargin={flowAMarginMax }
                        >
                            {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'A'), item)}
                            {showMNFAF && loggers.length === 1 &&
                                <ConstantLine
                                    value={MNFValue.value}
                                    width={2}
                                    color={'green'}
                                >
                                    <Label text={`${intl.formatMessage({ id: 'Minimum Night Flow' })} - ${MNFValue.value} ${unitsAndValues[0].graphSettings.flowAUnit}`} font={{ color: 'green' }} horizontalAlignment='left'/>
                                </ConstantLine>
                            }
                            {showMNFAF && loggers.length === 1 &&
                                <ConstantLine
                                    value={minMaxData[0].A.avg}
                                    width={2}
                                    color={'purple'}
                                >
                                    <Label text={`${intl.formatMessage({ id: 'Average Flow' })} - ${minMaxData[0].A.avg} ${unitsAndValues[0].graphSettings.flowAUnit}`} font={{ color: 'purple' }} horizontalAlignment='left' />
                                </ConstantLine>
                            }
                        </ValueAxis>
                    );
                }
                if (flowATotalVisibleLogger && item.channelsAvail & 0x01) {
                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`AT-Total ${logger.Serial}`}
                            visualRange={{ startValue: flowATotalMinValueLogger, endValue: flowATotalMaxValueLogger }}
                            allowDecimals={true}
                            title={{ text: flowATotalMinValueLogger === Number.NEGATIVE_INFINITY && flowATotalMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: 'Total' })} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Totaliser A' })})` : `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: "In" })} ${flowATotalUnit} ${flowATotal24Hrs ? intl.formatMessage({ id: '-24hr Total' }) : ''} (${intl.formatMessage({ id: 'Totaliser A' })})`, font: { color: flowATotalColor, size: flowATotalLabelSize } }}
                            position={flowATotalAxisPosition}
                            color={flowATotalColor}
                            key={`AT-Total ${logger.Serial}`} // Unique key for each axis
                            minValueMargin={flowATotalMarginMin}
                            maxValueMargin={flowATotalMarginMax}
                        >
                            <Label font={{ color: flowATotalColor }} />
                        </ValueAxis>
                    );
                }
                if (flowAConsumptionVisibleLogger && item.channelsAvail & 0x01) {
                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`AC-Consumption ${logger.Serial}`}
                            visualRange={{ startValue: flowAConsumptionMinValueLogger, endValue: flowAConsumptionMaxValueLogger }}
                            allowDecimals={true}
                            title={{text: flowAConsumptionMinValueLogger === Number.NEGATIVE_INFINITY && flowAConsumptionMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: 'Consumption' })} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Consumption A' })})` : `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: "In" })} ${flowAConsumptionUnit} ${flowAConsumption24Hrs ? intl.formatMessage({ id: '-24hr Consumption' }) : ''} (${intl.formatMessage({ id: 'Consumption A' })})`, font: { color: flowAConsumptionColor, size: flowAConsumptionLabelSize } }}
                            position={flowAConsumptionAxisPosition}
                            color={flowAConsumptionColor}
                            key={`AC-Consumption ${logger.Serial}`} // Unique key for each axis
                            minValueMargin={flowAConsumptionMarginMin}
                            maxValueMargin={flowAConsumptionMarginMax}
                        >
                            <Label font={{ color: flowAConsumptionColor }} />
                        </ValueAxis>
                    );
                }

                if (flowBVisibleLogger && item.channelsAvail & 0x02) {
                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`B ${logger.Serial}`}
                            visualRange={item.graphSettings.flowBIsDigital ? { startValue: 0, endValue: 1 } :{ startValue: flowBMinValueLogger, endValue: flowBMaxValueLogger }}
                            label={{
                                customizeText: (axisInfo) => {
                                    if (item.graphSettings.flowBIsDigital) {
                                        if (axisInfo.value === 1) {
                                            return 'ON'
                                        } else if (axisInfo.value === 0) {
                                            return 'OFF'
                                        } else return ''
                                        
                                    } else {
                                        return axisInfo.value
                                    }
                                },
                                font: { color: flowBColor } 
                            }}
                            
                            allowDecimals={true}
                            title={{ text: flowBMinValueLogger === Number.NEGATIVE_INFINITY && flowBMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelBRef} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Flow B' })})` : `${logger.Serial} ${logger.ChannelBRef} ${item.graphSettings.flowBIsDigital ? '' : intl.formatMessage({ id: "In" })} ${flowBUnit} ${item.graphSettings.flowBIsDigital ? "" :  '(' + intl.formatMessage({ id: 'Flow B' }) + ')'}`, font: { color: flowBColor, size: flowBLabelSize } }}
                            position={flowBAxisPosition}
                            color={flowBColor}
                            key={`B-${logger.Serial}`} // Unique key for each axis
                            minValueMargin={flowBMarginMin}
                            maxValueMargin={flowBMarginMax}
                        >
                            {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'B'), item)}
                        </ValueAxis>
                    );
                }
                if (flowBTotalVisibleLogger && item.channelsAvail & 0x02) {
                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`BT-Total ${logger.Serial}`}
                            visualRange={{ startValue: flowBTotalMinValueLogger, endValue: flowBTotalMaxValueLogger }}
                            allowDecimals={true}
                            title={{ text: flowBTotalMinValueLogger === Number.NEGATIVE_INFINITY && flowBTotalMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: 'Total' })} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Totaliser B' })})` : `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: "In" })} ${flowBTotalUnit} ${flowBTotal24Hrs ? intl.formatMessage({ id: '-24hr Total' }) : ''} (${intl.formatMessage({ id: 'Totaliser B' })})`, font: { color: flowBTotalColor, size: flowBTotalLabelSize } }} ///here
                            position={flowBTotalAxisPosition}
                            color={flowBTotalColor}
                            key={`BT-Total ${logger.Serial}`} // Unique key for each axis
                            minValueMargin={flowBTotalMarginMin}
                            maxValueMargin={flowBTotalMarginMax}
                        >
                            <Label font={{ color: flowBTotalColor }} />
                        </ValueAxis>
                    );
                }
                if (flowBConsumptionVisibleLogger && item.channelsAvail & 0x02) {
                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`BC-Consumption ${logger.Serial}`}
                            visualRange={{ startValue: flowBConsumptionMinValueLogger, endValue: flowBConsumptionMaxValueLogger }}
                            allowDecimals={true}
                            title={{ text: flowBConsumptionMinValueLogger === Number.NEGATIVE_INFINITY && flowBConsumptionMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: 'Consumption' })} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Consumption B' })})` : `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: "In" })} ${flowBConsumptionUnit} ${flowBConsumption24Hrs ? intl.formatMessage({ id: '-24hr Consumption' }) : ''} (${intl.formatMessage({ id: 'Consumption B' })})`, font: { color: flowBConsumptionColor, size: flowBConsumptionLabelSize } }}
                            position={flowBConsumptionAxisPosition}
                            color={flowBConsumptionColor}
                            key={`BC-Consumption ${logger.Serial}`} // Unique key for each axis
                            minValueMargin={flowBConsumptionMarginMin}
                            maxValueMargin={flowBConsumptionMarginMax}
                        >
                            <Label font={{ color: flowBConsumptionColor }} />
                        </ValueAxis>
                    );
                }
                if (pressureCVisibleLogger && item.channelsAvail & 0x04) {

                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`C ${logger.Serial}`}
                            visualRange={{ startValue: pressureCMinValueLogger, endValue: pressureCMaxValueLogger }}
                            allowDecimals={true}
                            title={{
                                text: pressureCMinValueLogger === Number.NEGATIVE_INFINITY && pressureCMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelCRef} - ${intl.formatMessage({ id: 'NO DATA' })} (${pressureCChannelName})` : `${logger.Serial} ${logger.ChannelCRef} ${intl.formatMessage({ id: "In" })} ${pressureCUnit} (${pressureCChannelName})`, font: { color: pressureCColor, size: pressureCLabelSize }
                            }}
                            position={pressureCAxisPosition}
                            color={pressureCColor}
                            key={`C-${logger.Serial}`} // Unique key for each axis
                            minValueMargin={pressureCMarginMin}
                            maxValueMargin={pressureCMarginMax}
                        >
                            <Label font={{ color: pressureCColor }} />
                            {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'C'), item)}
                            {/*{currentMinMax.maxC && currentMinMax.minC && renderCurrentMinMax()}*/}
                        </ValueAxis>
                    );
                }
                if (pressureDVisibleLogger && item.channelsAvail & 0x08) {
                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`D ${logger.Serial}`}
                            visualRange={{ startValue: pressureDMinValueLogger, endValue: pressureDMaxValueLogger }}
                            allowDecimals={true}
                            title={{
                                text: pressureDMinValueLogger === Number.NEGATIVE_INFINITY && pressureDMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelDRef} - ${intl.formatMessage({ id: 'NO DATA' })} (${pressureDChannelName})` : `${logger.Serial} ${logger.ChannelDRef} ${intl.formatMessage({ id: "In" })} ${pressureDUnit} (${pressureDChannelName})`, font: { color: pressureDColor, size: pressureDLabelSize }
                            }}
                            position={pressureDAxisPosition}
                            color={pressureDColor}
                            key={`D-${logger.Serial}`} // Unique key for each axis
                            minValueMargin={pressureDMarginMin}
                            maxValueMargin={pressureDMarginMax}
                        >
                            <Label font={{ color: pressureDColor }} />
                            {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'D'), item)}
                        </ValueAxis>
                    );
                }
                if (pressureEVisibleLogger && item.channelsAvail & 0x10) {
                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`E ${logger.Serial}`}
                            visualRange={{ startValue: pressureEMinValueLogger, endValue: pressureEMaxValueLogger }}
                            allowDecimals={true}
                            title={{
                                text: pressureEMinValueLogger === Number.NEGATIVE_INFINITY && pressureEMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelERef} - ${intl.formatMessage({ id: 'NO DATA' })} (${pressureEChannelName})` : `${logger.Serial} ${logger.ChannelERef} ${intl.formatMessage({ id: "In" })} ${pressureEUnit} (${pressureEChannelName})`, font: { color: pressureEColor, size: pressureELabelSize }
                            }}
                            position={pressureEAxisPosition}
                            color={pressureEColor}
                            key={`E-${logger.Serial}`} // Unique key for each axis
                            minValueMargin={pressureEMarginMin}
                            maxValueMargin={pressureEMarginMax}
                        >
                            <Label font={{ color: pressureEColor }} />
                            {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'E'), item)}
                        </ValueAxis>
                    );
                }
                if (flowACombinedVisibleLogger && location.state.combinedFlowSiteId) {
                    valueAxisArray.push(
                        <ValueAxis
                            width={2}
                            name={`A`}
                            visualRange={{ startValue: item.graphSettings.flowACombinedMinValue, endValue: item.graphSettings.flowACombinedMaxValue }}
                            allowDecimals={true}
                            title={{ text: `Flow A Combined in ${item.graphSettings.flowACombinedUnit}`, font: { color: flowACombinedColor, size: flowACombinedLabelSize } }}
                            position={flowACombinedAxisPosition}
                            color={flowACombinedColor}
                            key={`A`} // Unique key for each axis
                                
                        >
                            
                            <Label font={{ color: flowACombinedColor }} />
                        </ValueAxis>
                    );

                }
            });
        } else {

            //if combine Y is true and want Y axis combined
            let flowAMinValue = Number.MAX_VALUE
            let flowAMaxValue = Number.NEGATIVE_INFINITY
            let flowBMinValue = Number.MAX_VALUE
            let flowBMaxValue = Number.NEGATIVE_INFINITY
            let pressureCMinValue = Number.MAX_VALUE
            let pressureCMaxValue = Number.NEGATIVE_INFINITY
            let pressureDMinValue = Number.MAX_VALUE
            let pressureDMaxValue = Number.NEGATIVE_INFINITY
            let pressureEMinValue = Number.MAX_VALUE
            let pressureEMaxValue = Number.NEGATIVE_INFINITY
            let flowATotalMinValue = Number.MAX_VALUE
            let flowATotalMaxValue = Number.NEGATIVE_INFINITY
            let flowBTotalMinValue = Number.MAX_VALUE
            let flowBTotalMaxValue = Number.NEGATIVE_INFINITY
            let flowAConsumptionMinValue = Number.MAX_VALUE
            let flowAConsumptionMaxValue = Number.NEGATIVE_INFINITY
            let flowBConsumptionMinValue = Number.MAX_VALUE
            let flowBConsumptionMaxValue = Number.NEGATIVE_INFINITY

            /// used if initial unitsna dvalues has custom min max then default min max needs calculating
            let flowAMinValueCust = Number.MAX_VALUE
            let flowAMaxValueCust = Number.NEGATIVE_INFINITY
            let flowBMinValueCust = Number.MAX_VALUE
            let flowBMaxValueCust = Number.NEGATIVE_INFINITY
            let pressureCMinValueCust = Number.MAX_VALUE
            let pressureCMaxValueCust = Number.NEGATIVE_INFINITY
            let pressureDMinValueCust = Number.MAX_VALUE
            let pressureDMaxValueCust = Number.NEGATIVE_INFINITY
            let pressureEMinValueCust = Number.MAX_VALUE
            let pressureEMaxValueCust = Number.NEGATIVE_INFINITY
            let flowATotalMinValueCust = Number.MAX_VALUE
            let flowATotalMaxValueCust = Number.NEGATIVE_INFINITY
            let flowBTotalMinValueCust = Number.MAX_VALUE
            let flowBTotalMaxValueCust = Number.NEGATIVE_INFINITY
            let flowAConsumptionMinValueCust = Number.MAX_VALUE
            let flowAConsumptionMaxValueCust = Number.NEGATIVE_INFINITY
            let flowBConsumptionMinValueCust = Number.MAX_VALUE
            let flowBConsumptionMaxValueCust = Number.NEGATIVE_INFINITY


            /// loop through exist graph data and extract original min max for each channel / type
            
            graphData.forEach(d => {
                unitsAndValues.forEach(unit => {
                    //flow A
                    if (d[`${unit.serial}flowRateA`] && d[`${unit.serial}flowRateA`] < flowAMinValueCust) {
                        flowAMinValueCust = d[`${unit.serial}flowRateA`]
                    }
                    if (d[`${unit.serial}flowRateA`] && d[`${unit.serial}flowRateA`] > flowAMaxValueCust) {
                        flowAMaxValueCust = d[`${unit.serial}flowRateA`]
                    }
                    // totaliser A
                    if (d[`${unit.serial}readingA`] && d[`${unit.serial}readingA`] < flowATotalMinValueCust) {
                        flowATotalMinValueCust = d[`${unit.serial}readingA`]
                    }
                    if (d[`${unit.serial}readingA`] && d[`${unit.serial}readingA`] > flowATotalMaxValueCust) {
                        flowATotalMaxValueCust = d[`${unit.serial}readingA`]
                    }
                    // consumption A
                    if (d[`${unit.serial}consumptionA`] && d[`${unit.serial}consumptionA`] < flowAConsumptionMinValueCust) {
                        flowAConsumptionMinValueCust = d[`${unit.serial}readingA`]
                    }
                    if (d[`${unit.serial}consumptionA`] && d[`${unit.serial}consumptionA`] > flowAConsumptionMaxValueCust) {
                        flowAConsumptionMaxValueCust = d[`${unit.serial}readingA`]
                    }


                    // flow B
                    if (d[`${unit.serial}flowRateB`] && d[`${unit.serial}flowRateB`] < flowBMinValueCust) {
                        flowBMinValueCust = d[`${unit.serial}flowRateB`]
                    }
                    if (d[`${unit.serial}flowRateB`] && d[`${unit.serial}flowRateB`] > flowBMaxValueCust) {
                        flowBMaxValueCust = d[`${unit.serial}flowRateB`]
                    }
                    // totaliser B
                    if (d[`${unit.serial}readingB`] && d[`${unit.serial}readingB`] < flowBTotalMinValueCust) {
                        flowBTotalMinValueCust = d[`${unit.serial}readingB`]
                    }
                    if (d[`${unit.serial}readingB`] && d[`${unit.serial}readingB`] > flowBTotalMaxValueCust) {
                        flowBTotalMaxValueCust = d[`${unit.serial}readingB`]
                    }
                    // consumption B
                    if (d[`${unit.serial}consumptionB`] && d[`${unit.serial}consumptionB`] < flowBConsumptionMinValueCust) {
                        flowBConsumptionMinValueCust = d[`${unit.serial}readingB`]
                    }
                    if (d[`${unit.serial}consumptionB`] && d[`${unit.serial}consumptionB`] > flowBConsumptionMaxValueCust) {
                        flowBConsumptionMaxValueCust = d[`${unit.serial}readingB`]
                    }


                    //pressureC
                    if (d[`${unit.serial}readingC`] && d[`${unit.serial}readingC`] < pressureCMinValueCust) {
                        pressureCMinValueCust = d[`${unit.serial}readingC`]
                    }
                    if (d[`${unit.serial}readingC`] && d[`${unit.serial}readingC`] > pressureCMaxValueCust) {
                        pressureCMaxValueCust = d[`${unit.serial}readingC`]
                    }

                    //pressureD
                    if (d[`${unit.serial}readingD`] && d[`${unit.serial}readingD`] < pressureDMinValueCust) {
                        pressureDMinValueCust = d[`${unit.serial}readingD`]
                    }
                    if (d[`${unit.serial}readingD`] && d[`${unit.serial}readingD`] > pressureDMaxValueCust) {
                        pressureDMaxValueCust = d[`${unit.serial}readingD`]
                    }

                    //pressureE
                    if (d[`${unit.serial}readingE`] && d[`${unit.serial}readingE`] < pressureEMinValueCust) {
                        pressureEMinValueCust = d[`${unit.serial}readingE`]
                    }
                    if (d[`${unit.serial}readingE`] && d[`${unit.serial}readingE`] > pressureEMaxValueCust) {
                        pressureEMaxValueCust = d[`${unit.serial}readingE`]
                    }
                })
                if (d.combinedFlowA) {
                    if (d.combinedFlowA > flowAMaxValueCust) {
                        flowAMaxValueCust = d.combinedFlowA
                    }
                    if (d.combinedFlowA < flowAMinValueCust) {
                        flowAMinValueCust = d.combinedFlowA
                    }

                }
                if (d.combinedFlowB) {
                    if (d.combinedFlowB > flowBMaxValueCust) {
                        flowBMaxValueCust = d.combinedFlowB
                    }
                    if (d.combinedFlowB < flowBMinValueCust) {
                        flowBMinValueCust = d.combinedFlowB
                    }

                }
            })

            let hasChannelA = false
            let hasChannelB = false
            let hasChannelC = false
            let hasChannelD = false
            let hasChannelE = false
            const flowAAxisPosition = 'left'
            const flowATotalAxisPosition = 'right'
            const flowAConsumptionAxisPosition = 'right'
            const flowBAxisPosition = 'left'
            const flowBTotalAxisPosition = 'right'
            const flowBConsumptionAxisPosition = 'right'
            const pressureCAxisPosition = 'left'
            const pressureDAxisPosition = 'right'
            const pressureEAxisPosition = 'left'
            const nonIntegratableUnits = {
                C: false,
                D: false,
                E: false
            }
            let unitsC = []
            let unitsD = []
            let unitsE = []
            unitsAndValues.forEach(u => {
                const sett = u.graphSettings
                unitsC.push(sett.pressureCUnit)
                unitsD.push(sett.pressureDUnit)
                unitsE.push(sett.pressureEUnit)
            })


            unitsC = unitsC.map(unit => pressureUnits.map(u => u.value).includes(unit))
            unitsD = unitsD.map(unit => pressureUnits.map(u => u.value).includes(unit))
            unitsE = unitsE.map(unit => pressureUnits.map(u => u.value).includes(unit))
            if (!unitsC.every(un => un === true)) {
                if (!unitsC.every(u => u === unitsC[0])) {
                    //non pressure units and not the same for all loggers
                    nonIntegratableUnits.C = true
                }
            }
            if (!unitsD.every(un => un === true)) {
                if (!unitsD.every(u => u === unitsD[0])) {
                    //non pressure units and not the same for all loggers
                    nonIntegratableUnits.D = true
                }
            }
            if (!unitsE.every(un => un === true)) {
                if (!unitsE.every(u => u === unitsE[0])) {
                    //non pressure units and not the same for all loggers
                   nonIntegratableUnits.E = true
                }
            }  



            unitsAndValues.map(unit => {

                if (unit.channelsAvail & 0x01) hasChannelA = true
                if (unit.channelsAvail & 0x02) hasChannelB = true
                if (unit.channelsAvail & 0x04) hasChannelC = true
                if (unit.channelsAvail & 0x08) hasChannelD = true
                if (unit.channelsAvail & 0x10) hasChannelE = true

                const settings = unit.graphSettings

                //determine min and max for combined
                //flow A
                if (settings.flowAMinState === 'default' && !combineY) {
                    if (settings.flowAMinValue < flowAMinValue) {
                        flowAMinValue = settings.flowAMinValue
                    }
                } else {
                    flowAMinValue = flowAMinValueCust
                }
                if (settings.flowAMaxState === 'default' && !combineY) {
                    if (settings.flowAMaxValue > flowAMaxValue) {
                        flowAMaxValue = settings.flowAMaxValue
                    }
                } else { 
                    flowAMaxValue = flowAMaxValueCust
                } 



                    
                    
                /// totaliser A
                if (settings.flowATotalMinState === 'default') {
                    if (settings.flowATotalMinValue < flowATotalMinValue) {
                        flowATotalMinValue = settings.flowATotalMinValue
                    }
                } else {
                    flowATotalMinValue = flowATotalMinValueCust
                }
                if (settings.flowATotalMaxState === 'default') {
                    if (settings.flowATotalMaxValue > flowATotalMaxValue) {
                        flowATotalMaxValue = settings.flowATotalMaxValue
                    }
                } else {
                    flowATotalMaxValue = flowATotalMaxValueCust
                }

                ///consumption A
                if (settings.flowAConsumptionMinState === 'default') {
                    if (settings.flowAConsumptionMinValue < flowAConsumptionMinValue) {
                        flowAConsumptionMinValue = settings.flowAConsumptionMinValue
                    }
                } else {
                    flowAConsumptionMinValue = flowAConsumptionMinValueCust
                }
                if (settings.flowAConsumptionMaxState === 'default') {
                    if (settings.flowAConsumptionMaxValue > flowAConsumptionMaxValue) {
                        flowAConsumptionMaxValue = settings.flowAConsumptionMaxValue
                    }
                } else {
                    flowAConsumptionMaxValue = flowAConsumptionMaxValueCust
                }
                
                //flow B
                if (settings.flowBMinState === 'default') {
                    if (settings.flowBMinValue < flowBMinValue) {
                        flowBMinValue = settings.flowBMinValue
                    }
                } else {
                    flowBMinValue = flowBMinValueCust
                }
                if (settings.flowBMaxState === 'default') {
                    if (settings.flowBMaxValue > flowBMaxValue) {
                        flowBMaxValue = settings.flowBMaxValue
                    }
                } else {
                    flowBMaxValue = flowBMaxValueCust
                }


                /// totaliser B
                if (settings.flowBTotalMinState === 'default') {
                    if (settings.flowBTotalMinValue < flowBTotalMinValue) {
                        flowBTotalMinValue = settings.flowBTotalMinValue
                    }
                } else {
                    flowBTotalMinValue = flowBTotalMinValueCust
                }
                if (settings.flowBTotalMaxState === 'default') {
                    if (settings.flowBTotalMaxValue > flowBTotalMaxValue) {
                        flowBTotalMaxValue = settings.flowBTotalMaxValue
                    }
                } else {
                    flowBTotalMaxValue = flowBTotalMaxValueCust
                }

                ///consumption B
                if (settings.flowBConsumptionMinState === 'default') {
                    if (settings.flowBConsumptionMinValue < flowBConsumptionMinValue) {
                        flowBConsumptionMinValue = settings.flowBConsumptionMinValue
                    }
                } else {
                    flowBConsumptionMinValue = flowBConsumptionMinValueCust
                }
                if (settings.flowBConsumptionMaxState === 'default') {
                    if (settings.flowBConsumptionMaxValue > flowBConsumptionMaxValue) {
                        flowBConsumptionMaxValue = settings.flowBConsumptionMaxValue
                    }
                } else {
                    flowBConsumptionMaxValue = flowBConsumptionMaxValueCust
                }
                //C
                if (!nonIntegratableUnits.C) {
                    if (settings.pressureCMinState === 'default') {

                        if (settings.pressureCMinValue < pressureCMinValue) {
                            pressureCMinValue = settings.pressureCMinValue
                        }
                    } else {
                        pressureCMinValue = pressureCMinValueCust
                    }
                    if (settings.pressureCMaxState === 'default') {
                        if (settings.pressureCMaxValue > pressureCMaxValue) {
                            pressureCMaxValue = settings.pressureCMaxValue
                        }
                    } else {
                        pressureCMaxValue = pressureCMaxValueCust
                    }
                }
                //D
                if (!nonIntegratableUnits.D) {
                    if (settings.pressureDMinState === 'default') {
                        if (settings.pressureDMinValue < pressureDMinValue) {
                            pressureDMinValue = settings.pressureDMinValue
                        }
                    } else {
                        pressureDMinValue = pressureDMinValueCust
                    }
                    if (settings.pressureDMaxState === 'default') {
                        if (settings.pressureDMaxValue > pressureDMaxValue) {
                            pressureDMaxValue = settings.pressureDMaxValue
                        }
                    } else {
                        pressureDMaxValue = pressureDMaxValueCust
                    }
                }
                //E
                if (!nonIntegratableUnits.E) {
                    if (settings.pressureEMinValue < pressureEMinValue) {
                        pressureEMinValue = settings.pressureEMinValue
                    }
                    if (settings.pressureEMaxValue > pressureEMaxValue) {
                        pressureEMaxValue = settings.pressureEMaxValue
                    }
                }


            })


            //if (hasChannelA && showCombinedFlow) {
            //    flowAMaxValue = 
            //}

            if (hasChannelA && combinedFlowAUnit) {
                if (showFlow) {
                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`A`}
                        visualRange={{ startValue: flowAMinValue, endValue: flowAMaxValue }}
                        allowDecimals={true}
                        title={{
                            text: `${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Flow A' }) : intl.formatMessage({ id: 'Channel A' })} - ${combinedFlowAUnit}`, font: { color: colors.red[0], size: unitsAndValues[0].graphSettings.flowALabelSize }
                        }}
                        position={flowAAxisPosition}
                        color={colors.red[0]}
                        key={`A`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.red[0] }} />
                        {showMNFAF &&
                            <ConstantLine
                                value={MNFValue.value}
                                width={2}
                                color={'green'}
                            >
                                <Label text={`${intl.formatMessage({ id: 'Min Night Flow' })}`} font={{ color: 'green' }} horizontalAlignment='left' />
                            </ConstantLine>
                        }
                        {showMNFAF &&
                            <ConstantLine
                                value={minMaxData[loggers.length].A.avg}
                                width={2}
                                color={'purple'}
                            >
                                <Label text={`${intl.formatMessage({ id: 'Avg Flow' })}`} font={{ color: 'purple' }} horizontalAlignment='left' />
                            </ConstantLine>
                        }
                    </ValueAxis>)
                }
                if (showTotal) {
                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`AT`}
                        visualRange={{ startValue: flowATotalMinValue, endValue: flowATotalMaxValue }}
                        allowDecimals={true}
                        title={{
                            text: `${intl.formatMessage({ id: 'Totaliser A' })} - ${combinedTotalAUnit}`, font: { color: colors.yellow[0], size: unitsAndValues[0].graphSettings.flowATotalLabelSize } }}
                        position={flowATotalAxisPosition}
                        color={colors.yellow[0]}
                        key={`AT`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.yellow[0] }} />
                    </ValueAxis>)
                }
                if (showConsumption) {
                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`AC`}
                        visualRange={{ startValue: flowAConsumptionMinValue, endValue: flowAConsumptionMaxValue }}
                        allowDecimals={true}
                        title={{
                            text: `${intl.formatMessage({ id: 'Consumption A' })} - ${combinedConsumptionAUnit}`, font: { color: colors.teal[0], size: unitsAndValues[0].graphSettings.flowAConsumptionLabelSize } }}
                        position={flowAConsumptionAxisPosition}
                        color={colors.teal[0]}
                        key={`AC`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.teal[0] }} />
                    </ValueAxis>)
                }
            }
            if (hasChannelB && combinedFlowBUnit) {
                if (showFlow) {
                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`B`}
                        visualRange={{ startValue: flowBMinValue, endValue: flowBMaxValue }}
                        allowDecimals={true}
                        title={{ text: `${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Flow B' }) : intl.formatMessage({ id: 'Channel B' }) } - ${combinedFlowBUnit}`, font: { color: colors.green[0], size: unitsAndValues[0].graphSettings.flowBLabelSize } }}
                        position={flowBAxisPosition}
                        color={colors.green[0]}
                        key={`B`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.green[0] }} />
                    </ValueAxis>)
                }
                if (showTotal) {
                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`BT`}
                        visualRange={{ startValue: flowBTotalMinValue, endValue: flowBTotalMaxValue }}
                        allowDecimals={true}
                        title={{ text: `${intl.formatMessage({ id: 'Totaliser B' })} - ${combinedTotalBUnit}`, font: { color: colors.brown[0], size: unitsAndValues[0].graphSettings.flowBTotalLabelSize } }}
                        position={flowBTotalAxisPosition}
                        color={colors.brown[0]}
                        key={`BT`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.brown[0] }} />
                    </ValueAxis>)
                }
                if (showConsumption) {
                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`BC`}
                        visualRange={{ startValue: flowBConsumptionMinValue, endValue: flowBConsumptionMaxValue }}
                        allowDecimals={true}
                        title={{ text: `${intl.formatMessage({ id: 'Consumption B' })} - ${combinedConsumptionBUnit}`, font: { color: colors.pink[0], size: unitsAndValues[0].graphSettings.flowBConsumptionLabelSize } }}
                        position={flowBConsumptionAxisPosition}
                        color={colors.pink[0]}
                        key={`BC`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.pink[0] }} />
                    </ValueAxis>)
                }
            }
            if (showPressure) {
                if (hasChannelC && combinedPressureCUnit && !nonIntegratableUnits.C) {
                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`C`}
                        visualRange={{ startValue: pressureCMinValueCust, endValue: pressureCMaxValueCust }}
                        allowDecimals={true}
                        title={{
                            text: `${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure C' }) : intl.formatMessage({ id: 'Channel C' })} - ${combinedPressureCUnit}`, font: { color: colors.blue[0], size: unitsAndValues[0].graphSettings.pressureCLabelSize } }}
                        position={pressureCAxisPosition}
                        color={colors.blue[0]}
                        key={`C`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.blue[0] }} />
                    </ValueAxis>)
                }
                if (hasChannelD && combinedPressureDUnit && !nonIntegratableUnits.D) {
                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`D`}
                        visualRange={{ startValue: pressureDMinValueCust, endValue: pressureDMaxValueCust }}
                        allowDecimals={true}
                        title={{ text: `${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure D' }) : intl.formatMessage({ id: 'Channel D' })} - ${combinedPressureDUnit}`, font: { color: colors.orange[0], size: unitsAndValues[0].graphSettings.pressureDLabelSize } }}
                        position={pressureDAxisPosition}
                        color={colors.orange[0]}
                        key={`D`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.orange[0] }} />
                    </ValueAxis>)
                }
                if (hasChannelE && combinedPressureEUnit && !nonIntegratableUnits.E) {

                    valueAxisArray.push(<ValueAxis
                        width={2}
                        name={`E`}
                        visualRange={{ startValue: pressureEMinValueCust, endValue: pressureEMaxValueCust }}
                        allowDecimals={true}
                        title={{ text: `${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure E' }) : intl.formatMessage({ id: 'Channel E' })} - ${combinedPressureEUnit}`, font: { color: colors.purple[0], size: unitsAndValues[0].graphSettings.pressureELabelSize } }}
                        position={pressureEAxisPosition}
                        color={colors.purple[0]}
                        key={`E`} // Unique key for each axis
                        minValueMargin={0.1}
                        maxValueMargin={0.1}
                    >
                        <Label font={{ color: colors.purple[0] }} />
                    </ValueAxis>)
                }
                if (nonIntegratableUnits.C && hasChannelC) {
                    unitsAndValues.map((item, idx) => {
                        const sett = item.graphSettings
                        
                        let pressureCMinValueSeperate = Number.MAX_VALUE
                        let pressureCMaxValueSeperate = Number.NEGATIVE_INFINITY

                        if (sett.pressureCMinValue < pressureCMinValueSeperate) {
                            pressureCMinValueSeperate = sett.pressureCMinValue
                        }
                        if (sett.pressureCMaxValue > pressureCMaxValueSeperate) {
                            pressureCMaxValueSeperate = sett.pressureCMaxValue
                        }
                        valueAxisArray.push(<ValueAxis
                            width={2}
                            name={`C ${logger.Serial}`}
                            visualRange={{ startValue: pressureCMinValueSeperate, endValue: pressureCMaxValueSeperate }}
                            allowDecimals={true}
                            title={{ text: `${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure C' }) : intl.formatMessage({ id: 'Channel C' })} - ${sett.pressureCUnit}`, font: { color: colors.blue[idx], size: sett.pressureCLabelSize } }}
                            position={sett.pressureCAxisPosition}
                            color={colors.blue[idx]}
                            key={`C ${logger.Serial}`} // Unique key for each axis
                            minValueMargin={0.1}
                            maxValueMargin={0.1}
                        >
                            <Label font={{ color: colors.blue[idx] }} />
                        </ValueAxis>)
                    })
                }
                if (nonIntegratableUnits.D && hasChannelD) {
                    unitsAndValues.map((item, idx) => {
                        const sett = item.graphSettings

                        let pressureDMinValueSeperate = Number.MAX_VALUE
                        let pressureDMaxValueSeperate = Number.NEGATIVE_INFINITY

                        if (sett.pressureDMinValue < pressureDMinValueSeperate) {
                            pressureDMinValueSeperate = sett.pressureDMinValue
                        }
                        if (sett.pressureDMaxValue > pressureDMaxValueSeperate) {
                            pressureDMaxValueSeperate = sett.pressureDMaxValue
                        }
                        valueAxisArray.push(<ValueAxis
                            width={2}
                            name={`D ${logger.Serial}`}
                            visualRange={{ startValue: pressureDMinValueSeperate, endValue: pressureDMaxValueSeperate }}
                            allowDecimals={true}
                            title={{ text: `${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure D' }) : intl.formatMessage({ id: 'Channel D' })} - ${sett.pressureDUnit}`, font: { color: colors.orange[idx], size: sett.pressureDLabelSize } }}
                            position={sett.pressureDAxisPosition}
                            color={colors.orange[idx]}
                            key={`D ${logger.Serial}`} // Unique key for each axis
                            minValueMargin={0.1}
                            maxValueMargin={0.1}
                        >
                            <Label font={{ color: colors.orange[idx] }} />
                        </ValueAxis>)
                    })
                }
                if (nonIntegratableUnits.E && hasChannelE) {
                    unitsAndValues.map((item, idx) => {
                        const sett = item.graphSettings

                        let pressureEMinValueSeperate = Number.MAX_VALUE
                        let pressureEMaxValueSeperate = Number.NEGATIVE_INFINITY

                        if (sett.pressureEMinValue < pressureEMinValueSeperate) {
                            pressureEMinValueSeperate = sett.pressureEMinValue
                        }
                        if (sett.pressureEMaxValue > pressureEMaxValueSeperate) {
                            pressureEMaxValueSeperate = sett.pressureEMaxValue
                        }
                        valueAxisArray.push(<ValueAxis
                            width={2}
                            name={`E ${logger.Serial}`}
                            visualRange={{ startValue: pressureEMinValueSeperate, endValue: pressureEMaxValueSeperate }}
                            allowDecimals={true}
                            title={{ text: `${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure E' }) : intl.formatMessage({ id: 'Channel E' })} - ${sett.pressureEUnit}`, font: { color: colors.purple[idx], size: sett.pressureELabelSize } }}
                            position={sett.pressureEAxisPosition}
                            color={colors.purple[idx]}
                            key={`E ${logger.Serial}`} // Unique key for each axis
                            minValueMargin={0.1}
                            maxValueMargin={0.1}
                        >
                            <Label font={{ color: colors.purple[idx] }} />
                        </ValueAxis>)
                    })
                }
            }
        }
        return valueAxisArray;
    };
            

    const renderLoggerSeries = (logger: APILoggerDetail): unknown => {
        let counter = 0
        const loggerSeries = []


        const hasCombinedAChannel = unitsAndValues.some(u => u.channelsAvail & 0x01)
        const hasCombinedBChannel = unitsAndValues.some(u => u.channelsAvail & 0x02)

        unitsAndValues.map(item => {

            const i = item.graphSettings
            //flow A
            let flowAVisibleLogger = false
            let flowAGraphType = ""
            let flowAColor = ''
            let flowALineWidth = 0

            //Total A
            let flowATotalVisibleLogger = false
            let flowATotalGraphType = ""
            let flowATotalColor = ''
            let flowATotalLineWidth = 0


            //Consumption A
            let flowAConsumptionVisibleLogger = false
            let flowAConsumptionGraphType = ""
            let flowAConsumptionColor = ''
            let flowAConsumptionLineWidth = 0


            //flow A Combined
            let flowACombinedVisibleLogger = false
            let flowACombinedGraphType = ""
            let flowACombinedColor = ''
            let flowACombinedLineWidth = 0

            //flow B
            let flowBVisibleLogger = false
            let flowBGraphType = ""
            let flowBColor = ''
            let flowBLineWidth = 0

            //Total B
            let flowBTotalVisibleLogger = false
            let flowBTotalGraphType = ""
            let flowBTotalColor = ''
            let flowBTotalLineWidth = 0

            //Consumption B
            let flowBConsumptionVisibleLogger = false
            let flowBConsumptionGraphType = ""
            let flowBConsumptionColor = ''
            let flowBConsumptionLineWidth = 0

            //pressure C
            let pressureCVisibleLogger = false
            let pressureCGraphType = ""
            let pressureCColor = ''
            let pressureCLineWidth = 0
            let pressureCValueField = `${logger.Serial}readingC`
            const pressureCMinValueField = `${logger.Serial}readingCmin`
            const pressureCMaxValueField = `${logger.Serial}readingCmax`

            //pressure D
            let pressureDVisibleLogger = false
            let pressureDGraphType = ""
            let pressureDColor = ''
            let pressureDLineWidth = 0
            let pressureDValueField = `${logger.Serial}readingD`
            const pressureDMinValueField = `${logger.Serial}readingDmin`
            const pressureDMaxValueField = `${logger.Serial}readingDmax`

            //pressure E
            let pressureEVisibleLogger = false
            let pressureEGraphType = ""
            let pressureEColor = ''
            let pressureELineWidth = 0
            let pressureEValueField = `${logger.Serial}readingE`
            const pressureEMinValueField = `${logger.Serial}readingEmin`
            const pressureEMaxValueField = `${logger.Serial}readingEmax`

            if (item.serial === logger.Serial) {
                //flow A
                flowAVisibleLogger = i.flowAVisible
                flowAGraphType = i.flowAGraphType
                flowALineWidth = i.flowALineWidth

                ///Total A
                flowATotalVisibleLogger = i.flowATotalVisible
                flowATotalGraphType = i.flowATotalGraphType
                flowATotalLineWidth = i.flowATotalLineWidth

                ///Consumption A

                flowAConsumptionVisibleLogger = i.flowAConsumptionVisible
                flowAConsumptionGraphType = i.flowAConsumptionGraphType
                flowAConsumptionLineWidth = i.flowAConsumptionLineWidth


                //flow A Combined
                flowACombinedVisibleLogger = i.flowACombinedVisible
                flowACombinedGraphType = i.flowACombinedGraphType
                flowACombinedLineWidth = i.flowACombinedLineWidth
                flowACombinedColor = i.flowACombinedColor

                //flow B
                flowBVisibleLogger = i.flowBVisible
                flowBGraphType = i.flowBGraphType
                flowBLineWidth = i.flowBLineWidth
                ///Total B
                flowBTotalVisibleLogger = i.flowBTotalVisible
                flowBTotalGraphType = i.flowBTotalGraphType
                flowBTotalLineWidth = i.flowBTotalLineWidth
                ///Consumption A
                flowBConsumptionVisibleLogger = i.flowBConsumptionVisible
                flowBConsumptionGraphType = i.flowBConsumptionGraphType
                flowBConsumptionLineWidth = i.flowBConsumptionLineWidth

                //pressure C
                pressureCVisibleLogger = i.pressureCVisible
                pressureCGraphType = i.pressureCGraphType
                pressureCLineWidth = i.pressureCLineWidth
                //pressure D
                pressureDVisibleLogger = i.pressureDVisible
                pressureDGraphType = i.pressureDGraphType
                pressureDLineWidth = i.pressureDLineWidth
                //pressure E
                pressureEVisibleLogger = i.pressureEVisible
                pressureEGraphType = item.graphSettings.pressureEGraphType
                pressureELineWidth = item.graphSettings.pressureELineWidth
            }

            if (!i.pressureCDisplayAll) {
                if (i.pressureCValueAs === 'max') {
                    pressureCValueField = `${logger.Serial}readingCmax`
                }
                if (i.pressureCValueAs === 'min') {
                    pressureCValueField = `${logger.Serial}readingCmin`
                }
            }
            if (!i.pressureDDisplayAll) {
                if (i.pressureDValueAs === 'max') {
                    pressureDValueField = `${logger.Serial}readingDmax`
                }
                if (i.pressureDValueAs === 'min') {
                    pressureDValueField = `${logger.Serial}readingDmin`
                }
            }
            if (!i.pressureEDisplayAll) {
                if (i.pressureEValueAs === 'max') {
                    pressureEValueField = `${logger.Serial}readingEmax`
                }
                if (i.pressureEValueAs === 'min') {
                    pressureEValueField = `${logger.Serial}readingEmin`
                }
            }

            if (item.isAshridgeDefault) {
                flowAColor = colors.red[counter]
                flowATotalColor = colors.yellow[counter]
                flowAConsumptionColor = colors.teal[counter]
                flowBTotalColor = colors.brown[counter]
                flowBColor = colors.green[counter]
                flowBConsumptionColor = colors.pink[counter]
                pressureCColor = colors.blue[counter]
                pressureDColor = colors.orange[counter]
                pressureEColor = colors.purple[counter]
                counter === 9 ? counter = 0 : counter++;
            } else  {
                if (i.flowADefaultColor) {
                    flowAColor = colors.red[counter];
                } else {
                    flowAColor = i.flowAColor;
                }
                if (i.flowATotalDefaultColor) {
                    flowATotalColor = colors.yellow[counter];
                } else {
                    flowATotalColor = i.flowATotalColor;
                }
                if (i.flowAConsumptionDefaultColor) {
                    flowAConsumptionColor = colors.teal[counter];
                } else {
                    flowAConsumptionColor = i.flowAConsumptionColor;
                }
                if (i.flowBDefaultColor) {
                    flowBColor = colors.green[counter];
                } else {
                    flowBColor = i.flowBColor;
                }
                if (i.flowBTotalDefaultColor) {
                    flowBTotalColor = colors.brown[counter];
                } else {
                    flowBTotalColor = i.flowBTotalColor;
                }
                if (i.flowBConsumptionDefaultColor) {
                    flowBConsumptionColor = colors.pink[counter];
                } else {
                    flowBConsumptionColor = i.flowBConsumptionColor;
                }
                if (i.pressureCDefaultColor) {
                    pressureCColor = colors.blue[counter]
                } else {
                    pressureCColor = i.pressureCColor


                }
                if (i.pressureDDefaultColor) {
                    pressureDColor = colors.orange[counter]
                } else {
                    pressureDColor = i.pressureDColor
                }
                if (i.pressureEDefaultColor) {
                    pressureEColor = colors.purple[counter]
                } else {
                    pressureEColor = i.pressureEColor
                }
                counter === 9 ? counter = 0 : counter++;
            }
            
        
       
            if ((flowAVisibleLogger && item.channelsAvail & 0x01)) {
                loggerSeries.push(<Series
                    color={flowAColor}
                    key={`${logger.Serial}-A`}
                    type={flowAGraphType}
                    axis={combineY ? "A" : `A ${logger.Serial}`}
                    valueField={`${logger.Serial}flowRateA`}
                    name={`A ${logger.Serial}`}
                    point={{ visible: false }} 
                    width={flowALineWidth}
                    barWidth = { flowALineWidth } />)
            }
            if (flowATotalVisibleLogger && item.channelsAvail & 0x01 && (i.flowATotalMaxValue !== Number.NEGATIVE_INFINITY || i.flowATotalMaxValue !== null)) {
                loggerSeries.push(<Series
                    color={flowATotalColor}
                    key={`${logger.Serial}-A-Total`}
                    type={flowATotalGraphType}
                    axis={combineY ? "AT" : `AT-Total ${logger.Serial}`}
                    valueField={`${logger.Serial}readingA`}
                    name={`AT-Total ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowATotalLineWidth}
                    barWidth={flowATotalLineWidth} />)
            }

            if (flowAConsumptionVisibleLogger && item.channelsAvail & 0x01 && (i.flowAConsumptionMaxValue !== Number.NEGATIVE_INFINITY || i.flowAConsumptionMaxValue !== null)) {

                loggerSeries.push(<Series
                    color={flowAConsumptionColor}
                    key={`${logger.Serial}-AC-Consumption`}
                    type={flowAConsumptionGraphType}
                    axis={combineY ? "AC" : `AC-Consumption ${logger.Serial}`}
                    valueField={`${logger.Serial}consumptionA`}
                    name={`AC-Consumption ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowAConsumptionLineWidth}
                    barWidth={flowAConsumptionLineWidth} />)
            }
            if (flowBVisibleLogger && item.channelsAvail & 0x02) {
            loggerSeries.push(<Series
                color={flowBColor}
                key={`${logger.Serial}-B`}
                type={flowBGraphType}
                axis={combineY ? "B" : `B ${logger.Serial}`}
                valueField={`${logger.Serial}flowRateB`}
                name={`B ${logger.Serial}`}
                point={{ visible: false }} 
                width = { flowBLineWidth }
                barWidth = { flowBLineWidth } />)
            }
            if (flowBTotalVisibleLogger && item.channelsAvail & 0x02 && i.flowBTotalMaxValue !== Number.NEGATIVE_INFINITY) {
                loggerSeries.push(<Series
                    color={flowBTotalColor}
                    key={`${logger.Serial}-B-Total`}
                    type={flowBTotalGraphType}
                    axis={combineY ? "BT" : `BT-Total ${logger.Serial}`}
                    valueField={`${logger.Serial}readingB`}
                    name={`BT-Total ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowBTotalLineWidth}
                    barWidth={flowBTotalLineWidth} />)
            }
            if (flowBConsumptionVisibleLogger && item.channelsAvail & 0x02 && i.flowBConsumptionMaxValue !== Number.NEGATIVE_INFINITY) {
                loggerSeries.push(<Series
                    color={flowBConsumptionColor}
                    key={`${logger.Serial}-BC-Consumption`}
                    type={flowBConsumptionGraphType}
                    axis={combineY ? "BC" : `BC-Consumption ${logger.Serial}`}
                    valueField={`${logger.Serial}consumptionB`}
                    name={`BC-Consumption ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowBConsumptionLineWidth}
                    barWidth={flowBConsumptionLineWidth} />)
            }
            if (i.pressureCDisplayAll && unitsAndValues.length === 1 && item.channelsAvail & 0x04 && pressureCVisibleLogger && pressureCGraphType === 'spline' && pressureCMinValueField !== null && pressureCMaxValueField !== null) {
                loggerSeries.push(<Series
                    color={pressureCColor + '65'}
                    key={`${logger.Serial}-CRange`}
                    type='rangeArea'
                    axis={combineY ? "C" : `C ${logger.Serial}`}
                    rangeValue1Field={pressureCMinValueField}
                    rangeValue2Field={pressureCMaxValueField}
                    name={`C ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureCLineWidth}
                    barWidth={pressureCLineWidth}
                    

                />)
            }
            if (pressureCVisibleLogger && item.channelsAvail & 0x04) {

                loggerSeries.push(<Series
                    color={pressureCColor}
                    key={`${logger.Serial}-C`}
                    type={pressureCGraphType}
                    axis={combineY ? "C" : `C ${logger.Serial}`}
                    valueField={pressureCValueField}
                    name={`C ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureCLineWidth}
                    barWidth={pressureCLineWidth}

            />)  
            }
            if (i.pressureDDisplayAll && unitsAndValues.length === 1 && item.channelsAvail & 0x08 && pressureDVisibleLogger && pressureDGraphType === 'spline' && pressureDMinValueField !== null && pressureDMaxValueField !== null) {
                loggerSeries.push(<Series
                    color={pressureDColor + '65'}
                    key={`${logger.Serial}-DRange`}
                    type='rangeArea'
                    axis={combineY ? "D" : `D ${logger.Serial}`}
                    rangeValue1Field={pressureDMinValueField}
                    rangeValue2Field={pressureDMaxValueField}
                    name={`D ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureDLineWidth}
                    barWidth={pressureDLineWidth}


                />)
            }
            if (pressureDVisibleLogger && item.channelsAvail & 0x08) {
                loggerSeries.push(<Series
                    color={pressureDColor}
                    key={`${logger.Serial}-D`}
                    type={pressureDGraphType}
                    axis={combineY ? "D" : `D ${logger.Serial}`}
                    valueField={pressureDValueField}
                    name={`D ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureDLineWidth}
                    barWidth={pressureDLineWidth} />)
            }
            
            if (pressureEVisibleLogger && item.channelsAvail & 0x10) {
                loggerSeries.push(<Series
                    color={pressureEColor}
                    key={`${logger.Serial}-E`}
                    type={pressureEGraphType}
                    axis={combineY ? "E" : `E ${logger.Serial}`}
                    valueField={pressureEValueField}
                    name={`E ${logger.Serial}`}
                    point={{ visible: false }} // This hides individual points
                    width={pressureELineWidth}
                    barWidth={pressureELineWidth}
                    
                    
                />)
            }
            if (i.pressureEDisplayAll && unitsAndValues.length === 1 && item.channelsAvail & 0x10 && pressureEVisibleLogger && pressureEGraphType === 'spline' && pressureEMinValueField !== null && pressureEMaxValueField !== null) {
                loggerSeries.push(<Series
                    color={pressureEColor + '65'}
                    key={`${logger.Serial}-ERange`}
                    type='rangeArea'
                    axis={combineY ? "E" : `E ${logger.Serial}`}
                    rangeValue1Field={pressureEMinValueField}
                    rangeValue2Field={pressureEMaxValueField}
                    name={`E ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureELineWidth}
                    barWidth={pressureELineWidth}


                />)
            }          
            if (flowACombinedVisibleLogger && location.state.combinedFlowSiteId) {
                    loggerSeries.push(<Series
                        color={flowACombinedColor}
                        key={`A`}
                        type={flowACombinedGraphType}
                        axis={"A"}
                        valueField={`combinedFlowA`}
                        name={`A Flow Combined`}
                        point={{ visible: false }}
                        width={flowACombinedLineWidth}
                        barWidth={flowACombinedLineWidth} />)
             
            }
        })
            return loggerSeries
    }


    const renderRangeFinderSeries = (logger) => {
        const rangeSeries = []
        let counter = 0

        

        unitsAndValues.map(item => {
            const i = item.graphSettings
            //flow A
            let flowAVisibleLogger = false
            let flowAColor = ''
            let flowAGraphType = ''

            //flow A Total
            let flowATotalVisibleLogger = false
            let flowATotalColor = ''
            let flowATotalGraphType = ''

            //flow A Consumption
            let flowAConsumptionVisibleLogger = false
            let flowAConsumptionColor = ''
            let flowAConsumptionGraphType = ''

            //flowB
            let flowBVisibleLogger = false
            let flowBColor = ''
            let flowBGraphType = ''

            //flow B Total
            let flowBTotalVisibleLogger = false
            let flowBTotalColor = ''
            let flowBTotalGraphType = ''

            //flow B Consumption
            let flowBConsumptionVisibleLogger = false
            let flowBConsumptionColor = ''
            let flowBConsumptionGraphType = ''

            //pressure C
            let pressureCVisibleLogger = false
            let pressureCColor = ''
            let pressureCGraphType = ''

            //pressure D
            let pressureDVisibleLogger = false
            let pressureDColor = ''
            let pressureDGraphType = ''

            //pressure E
            let pressureEVisibleLogger = false
            let pressureEColor = ''
            let pressureEGraphType = ''


            if (item.serial === logger.Serial) {
                // Flow A
                flowAVisibleLogger = i.flowAVisible
                flowAGraphType = i.flowAGraphType
                // Flow A Total
                flowATotalVisibleLogger = i.flowATotalVisible
                flowATotalGraphType = i.flowATotalGraphType
                // Flow A Consumption
                flowAConsumptionVisibleLogger = i.flowAConsumptionVisible
                flowAConsumptionGraphType = i.flowAConsumptionGraphType
                //Flow B
                flowBVisibleLogger = i.flowBVisible
                flowBGraphType = i.flowBGraphType
                // Flow B Total
                flowBTotalVisibleLogger = i.flowBTotalVisible
                flowBTotalGraphType = i.flowBTotalGraphType
                // Flow A Consumption
                flowBConsumptionVisibleLogger = i.flowBConsumptionVisible
                flowBConsumptionGraphType = i.flowBConsumptionGraphType
                //pressure C
                pressureCVisibleLogger = i.pressureCVisible
                pressureCGraphType = i.pressureCGraphType
                //pressure D
                pressureDVisibleLogger = i.pressureDVisible
                pressureDGraphType = i.pressureDGraphType

                //pressure E
                pressureEVisibleLogger = i.pressureEVisible
                pressureEGraphType = i.pressureEGraphType
            }
            if (item.isAshridgeDefault) {
                flowAColor = colors.red[counter]
                flowATotalColor = colors.yellow[counter]
                flowAConsumptionColor = colors.teal[counter]
                flowBColor = colors.green[counter]
                flowBTotalColor = colors.brown[counter]
                pressureCColor = colors.blue[counter]
                pressureDColor = colors.orange[counter]
                pressureEColor = colors.purple[counter]
                counter === 5 ? counter = 0 : counter++;
            } else {
                if (i.flowADefaultColor) {
                    flowAColor = colors.red[counter];
                } else {
                    flowAColor = i.flowAColor;
                }
                if (i.flowATotalDefaultColor) {
                    flowATotalColor = colors.yellow[counter];
                } else {
                    flowATotalColor = i.flowATotalColor;
                }
                if (i.flowAConsumptionDefaultColor) {
                    flowAConsumptionColor = colors.teal[counter];
                } else {
                    flowAConsumptionColor = i.flowAConsumptionColor;
                }
                if (i.flowBDefaultColor) {
                    flowBColor = colors.green[counter];
                } else {
                    flowBColor = i.flowBColor;
                }
                if (i.flowBTotalDefaultColor) {
                    flowBTotalColor = colors.brown[counter];
                } else {
                    flowBTotalColor = i.flowBTotalColor;
                }
                if (i.flowBConsumptionDefaultColor) {
                    flowBConsumptionColor = colors.pink[counter];
                } else {
                    flowBConsumptionColor = i.flowBConsumptionColor;
                }
                if (i.pressureCDefaultColor) {
                    pressureCColor = colors.blue[counter]
                } else {
                    pressureCColor = i.pressureCColor
                }
                if (i.pressureDDefaultColor) {
                    pressureDColor = colors.orange[counter]
                } else {
                    pressureDColor = i.pressureDColor
                }
                if (i.pressureEDefaultColor) {
                    pressureEColor = colors.purple[counter]
                } else {
                    pressureEColor = i.pressureEColor
                }
                counter === 9 ? counter = 0 : counter++;
            }
            
        
        
        if (flowAVisibleLogger && item.channelsAvail & 0x01) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}flowRateA`}
                color={flowAColor}
                key={`${logger.Serial}-A`}
                type={flowAGraphType}
                
            />)
            }
            if (flowATotalVisibleLogger && item.channelsAvail & 0x01 && (i.flowATotalMaxValue !== Number.NEGATIVE_INFINITY || i.flowATotalMaxValue !== null)) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}readingA`}
                color={flowATotalColor}
                key={`${logger.Serial}-A-Total`}
                type={flowATotalGraphType}
            />)
            }
            if (flowAConsumptionVisibleLogger && item.channelsAvail & 0x01 && (i.flowAConsumptionMaxValue !== Number.NEGATIVE_INFINITY || i.flowAConsumptionMaxValue !== null)) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}consumptionA`}
                color={flowAConsumptionColor}
                key={`${logger.Serial}-A-Consumption`}
                type={flowAConsumptionGraphType}
            />)
        }
        if (flowBVisibleLogger && item.channelsAvail & 0x02) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}flowRateB`}
                color={flowBColor}
                key={`${logger.Serial}-B`}
                type={flowBGraphType}
            />)
            }
        if (flowBTotalVisibleLogger && item.channelsAvail & 0x02 && i.flowBTotalMaxValue !== Number.NEGATIVE_INFINITY) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}readingB`}
                color={flowBTotalColor}
                key={`${logger.Serial}-B-Total`}
                type={flowBTotalGraphType}
            />)
            }
        if (flowBConsumptionVisibleLogger && item.channelsAvail & 0x02 && i.flowBConsumptionMaxValue !== Number.NEGATIVE_INFINITY) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}consumptionB`}
                color={flowBConsumptionColor}
                key={`${logger.Serial}-B-Consumption`}
                type={flowBConsumptionGraphType}
            />)
        }
        if (pressureCVisibleLogger && item.channelsAvail & 0x04) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}readingC`}
                color={pressureCColor}
                key={`${logger.Serial}-C`}
                type={pressureCGraphType}
                
            />)
        }
        if (pressureDVisibleLogger && item.channelsAvail & 0x08) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}readingD`}
                color={pressureDColor}
                key={`${logger.Serial}-D`}
                type={pressureDGraphType}
            />)
        }
        if (pressureEVisibleLogger && item.channelsAvail & 0x10) {
            rangeSeries.push(<Series
                argumentField="date"
                valueField={`${logger.Serial}readingE`}
                color={pressureEColor}
                key={`${logger.Serial}-E`}
                type={pressureEGraphType}
            />)
            }

        })

        return rangeSeries
    }






    const resetZoom = useCallback(() => {
        if (chartRef.current && chartRef.current.instance) {
            const chartInstance = chartRef.current.instance();
            chartInstance.option('argumentAxis.visualRange', { startValue: startDate, endValue: endDate });
        }
        
        updateVisualRange({ value: {startValue: startDate, endValue: endDate}})
        setGraphHeight('50vh')
    }, [startDate, endDate, visualRange])

    
    const handleToggleFlow = (e, type: string): void => {
        setToggling(true)
        const checked = e.target.checked
        const unitsAndValuesTemp = unitsAndValues

        unitsAndValuesTemp.forEach(logger => {
            const l = logger.graphSettings
            const chan = logger.channelsAvail
            if (type === 'Flow' || type === 'Digital') {
                if (type === 'Flow') {
                    if (!l.flowAIsDigital) {
                        l.flowAVisible = checked
                    }
                    if (!l.flowBIsDigital && chan & 0x02) {
                        l.flowBVisible = checked
                    }
                    setShowFlow(checked)
                } else {
                    if (l.flowAIsDigital) {

                        l.flowAVisible = checked
                    }
                    if (l.flowBIsDigital && chan & 0x02) {
                        l.flowBVisible = checked
                    }
                    setShowDigital(checked)
                }
            } else if (type === 'Pressure') {
                if (chan & 0x04) {

                    l.pressureCVisible = checked
                    if (checked === false) {
                        l.pressureCDisplayAll = checked
                        setShowMinMax(checked)
                    }
                }
                if (chan & 0x08) {
                    l.pressureDVisible = checked
                    if (checked === false) {
                        l.pressureDDisplayAll = checked
                        setShowMinMax(checked)
                    }
                }
                if (!window.location.hostname.includes('zonelog.net') && (chan & 0x10)) {
                    l.pressureEVisible = checked
                    if (checked === false) {
                        l.pressureEDisplayAll = checked
                        setShowMinMax(checked)
                    }
                }

                setShowPressure(checked)
            } else if (type === 'Total') {
                l.flowATotalVisible = checked
                if (chan & 0x02) {
                    l.flowBTotalVisible = checked
                }
                setShowTotal(checked)
            } else if (type === 'Consumption') {
                l.flowAConsumptionVisible = checked
                if (chan & 0x02) {
                    l.flowBConsumptionVisible = checked
                }
                setShowConsumption(checked)
            } else if (type === 'Combined Flow') {
                l.flowACombinedVisible = checked
                setShowCombinedFlow(checked)
            } else if (type === 'MNF') {
                setShowMNFAF(checked)

            } else if (type === 'MinMax') {


                if (chan & 0x04) {
                    l.pressureCDisplayAll = checked
                }
                if (chan & 0x08) {
                    l.pressureDDisplayAll= checked
                }
                if (!window.location.hostname.includes('zonelog.net') && (chan & 0x10)) {
                    l.pressureEDisplayAll = checked
                }
                
                if (checked) {
                    let maxC = l.pressureCMaxValue
                    let minC = l.pressureCMinValue
                    let maxD = l.pressureDMaxValue
                    let minD = l.pressureDMinValue
                    let maxE = l.pressureEMaxValue
                    let minE = l.pressureEMinValue
                    graphData.forEach(reading => {
                        if (`${reading.serial}readingCmax` != null) {
                            if (reading[`${reading.serial}readingCmax`] > maxC) {
                                maxC = reading[`${reading.serial}readingCmax`]
                            }
                        }
                        if (`${reading.serial}readingCmin` != null) {
                            if (reading[`${reading.serial}readingCmin`] < minC) {
                                minC = reading[`${reading.serial}readingCmin`]
                            }
                        }
                        if (`${reading.serial}readingDmax` != null) {
                            if (reading[`${reading.serial}readingDmax`] > maxD) {
                                maxD = reading[`${reading.serial}readingDmax`]
                            }
                        }
                        if (`${reading.serial}readingDmin` != null) {
                            if (reading[`${reading.serial}readingDmin`] < minD) {
                                minD = reading[`${reading.serial}readingDmin`]
                            }
                        }
                        if (`${reading.serial}readingEmax` != null) {
                            if (reading[`${reading.serial}readingEmax`] > maxE) {
                                maxE = reading[`${reading.serial}readingEmax`]
                            }
                        }
                        if (`${reading.serial}readingEmin` != null) {
                            if (reading[`${reading.serial}readingEmin`] < minE) {
                                minE = reading[`${reading.serial}readingEmin`]
                            }
                        }
                    })
                    l.pressureCMaxValue = maxC
                    l.pressureCMinValue = minC
                    l.pressureDMaxValue = maxD
                    l.pressureDMinValue = minD
                    l.pressureEMaxValue = maxE
                    l.pressureEMinValue = minE
                    
                } else {
                    let maxC = Number.NEGATIVE_INFINITY
                    let minC = Number.MAX_VALUE
                    let maxD = Number.NEGATIVE_INFINITY
                    let minD = Number.MAX_VALUE
                    let maxE = Number.NEGATIVE_INFINITY
                    let minE = Number.MAX_VALUE
                    graphData.forEach(reading => {
                        if (`${reading.serial}readingC` != null) {
                            if (l.pressureCMaxState === 'default') {
                                if (reading[`${reading.serial}readingC`] > maxC) {
                                    maxC = reading[`${reading.serial}readingC`]
                                }
                            } else {
                                maxC = l.pressureCOriginalMax
                            }
                            
                        }
                        if (`${reading.serial}readingC` != null) {
                            if (l.pressureCMinState === 'default') {
                                if (reading[`${reading.serial}readingC`] < minC) {
                                    minC = reading[`${reading.serial}readingC`]
                                }
                            } else {
                                minC = l.pressureCOriginalMin
                            }
                        }
                        if (`${reading.serial}readingD` != null) {
                            if (l.pressureDMaxState === 'default') {
                                if (reading[`${reading.serial}readingD`] > maxD) {
                                    maxD = reading[`${reading.serial}readingD`]
                                }
                            } else {
                                maxD = l.pressureDOriginalMax
                            }
                        }
                        if (`${reading.serial}readingD` != null) {
                            if (l.pressureDMinState === 'default') {
                                if (reading[`${reading.serial}readingD`] < minD) {
                                    minD = reading[`${reading.serial}readingD`]
                                }
                            } else {
                                minD = l.pressureDOriginalMin
                            }
                        }
                        if (`${reading.serial}readingE` != null) {
                            if (l.pressureEMaxState === 'default') {
                                if (reading[`${reading.serial}readingE`] > maxE) {
                                    maxE = reading[`${reading.serial}readingE`]
                                }
                            } else {
                                maxE = l.pressureEOriginalMax
                            }
                        }
                        if (`${reading.serial}readingE` != null) {
                            if (l.pressureEMinState === 'default') {
                                if (reading[`${reading.serial}readingE`] < minE) {
                                    minE = reading[`${reading.serial}readingE`]
                                }
                            } else {
                                minE = l.pressureEOriginalMin
                            }
                        }
                    })
                    l.pressureCMaxValue = maxC
                    l.pressureCMinValue = minC
                    l.pressureDMaxValue = maxD
                    l.pressureDMinValue = minD
                    l.pressureEMaxValue = maxE
                    l.pressureEMinValue = minE
                } 
                
                setShowMinMax(checked)
            }
        })

        setUnitsAndValues(unitsAndValuesTemp)
        setToggling(false)
    }


    //const renderImportedDataStrips = ():React.ReactNode => {
    //    const renderStrips: React.ReactNode[] = []

    //    const set = unitsAndValues[0].graphSettings
    //    if (importData) {
    //        if (importData.A.length > 0) {
    //            importData.A.forEach((item, idx) => {
    //                renderStrips.push(
    //                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.flowAColor}40`} >
    //                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.flowAColor}`} /></Label>
    //                    </Strip>)
    //            })
    //        }
    //        if (importData.B.length > 0) {
    //            importData.B.forEach((item, idx) => {
    //                renderStrips.push(
    //                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.flowBColor}40`} >
    //                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.flowBColor}`} /></Label>
    //                    </Strip>)
    //            })
    //        }
    //        if (importData.C.length > 0) {
    //            importData.C.forEach((item, idx) => {
    //                renderStrips.push(
    //                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.pressureCColor}40`} >
    //                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.pressureCColor}`} /></Label>
    //                    </Strip>)
    //            })
    //        }
    //        if (importData.D.length > 0) {
    //            importData.D.forEach((item, idx) => {
    //                renderStrips.push(
    //                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.pressureDColor}40`} >
    //                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.pressureDColor}`} /></Label>
    //                    </Strip>)
    //            })
    //        }
    //        if (importData.E.length > 0) {
    //            importData.E.forEach((item, idx) => {
    //                renderStrips.push(
    //                    <Strip startValue={moment(item.start).toDate()} endValue={moment(item.end).toDate()} color={`${set.pressureEColor}40`} >
    //                        <Label text={idx > 0 ? "" : "Imported Data"} verticalAlignment='bottom' rotationAngle={90}><Font color={`${set.pressureEColor}`} /></Label>
    //                    </Strip>)
    //            })
    //        }
    //    }
    //    return renderStrips
    //}


    const customArgument = (date: Date): string => {
        if (moment(date).isSame(moment(date).startOf('day'), 'second')) {
            return moment(date).format('Do HH:mm')
        } else {
            return moment(date).format('HH:mm')
        }
    }



    const toggleExportModal = ():void => {
        setExportModal(!exportModal)
    }

    const handleExportTypeChange = (value): void => {

        setExportAs(value)
    }

    const deviceOverviewClick = (serial: number | null, model: string | null): void => {
                setRedirect(true)
                setRedirectPath(!isLCLLogger(model ? model : this.state.tempDevice?.model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
                setRedirectProps({
                    serial: serial
                    //mapKey: this.props.mapKey
                })
    }

    const handleHideLoggerChannel = (serial:number, channel: string):void => {

        const unitUpdate = unitsAndValues.map(unit => {
            if (unit.serial === serial) {
                if (channel === 'A') {
                    unit.graphSettings.flowAVisible = !unit.graphSettings.flowAVisible
                }
                if (channel === 'AT') {
                    unit.graphSettings.flowATotalVisible = !unit.graphSettings.flowATotalVisible
                }
                if (channel === 'AC') {
                    unit.graphSettings.flowAConsumptionVisible = !unit.graphSettings.flowAConsumptionVisible
                }
                if (channel === 'B') {
                    unit.graphSettings.flowBVisible = !unit.graphSettings.flowBVisible
                }
                if (channel === 'BT') {
                    unit.graphSettings.flowBTotalVisible = !unit.graphSettings.flowBTotalVisible
                }
                if (channel === 'BC') {
                    unit.graphSettings.flowBConsumptionVisible = !unit.graphSettings.flowBConsumptionVisible
                }
                if (channel === 'C') {
                    unit.graphSettings.pressureCVisible = !unit.graphSettings.pressureCVisible
                }
                if (channel === 'D') {
                    unit.graphSettings.pressureDVisible = !unit.graphSettings.pressureDVisible
                }
                if (channel === 'E') {
                    unit.graphSettings.pressureEVisible = !unit.graphSettings.pressureEVisible
                }
            } else if (channel === 'combined') {
                unit.graphSettings.flowACombinedVisible = !unit.graphSettings.flowACombinedVisible
            }
            
            return unit
        })
        let flowEnabled = false
        let TotalEnabled = false
        let ConsumptionEnabled = false
        let pressureEnabled = false
        let combinedEnabled = false
        unitUpdate.forEach(u => {
            const sett = u.graphSettings
            if (sett.flowAVisible || sett.flowBVisible) flowEnabled = true
            if (sett.flowATotalVisible || sett.flowBTotalVisible) TotalEnabled = true
            if (sett.flowAConsumptionVisible || sett.flowBConsumptionVisible) ConsumptionEnabled = true
            if (sett.pressureCVisible || sett.pressureDVisible || sett.pressureEVisible) pressureEnabled = true
            if (sett.flowACombinedVisible) combinedEnabled = true
        })
        setShowCombinedFlow(combinedEnabled)
        setShowFlow(flowEnabled)
        setShowConsumption(ConsumptionEnabled)
        setShowTotal(TotalEnabled)
        setShowPressure(pressureEnabled)
        setUnitsAndValues(unitUpdate)
    }


    const showRelativeChannelDisplay = (): React.ReactNode => {
        let hasChanA = false
        let hasChanB = false
        let hasChanC = false
        let hasChanD = false
        let hasChanE = false

        loggers.map(logger => {
            if (logger) {
                if (logger.ChannelsAvail & 0x01) {
                    hasChanA = true
                }
                if (logger.ChannelsAvail & 0x02) {
                    hasChanB = true
                }
                if (logger.ChannelsAvail & 0x04) {
                    hasChanC = true
                }
                if (logger.ChannelsAvail & 0x08) {
                    hasChanD = true
                }
                if (logger.ChannelsAvail & 0x10) {
                    hasChanE = true
                }
            }
        })

        return (<>
            {hasChanA && <GraphChannelDisplay
                colors={colors}
                name={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Flow A' }) : intl.formatMessage({ id: 'Channel A' })}
                loggers={loggers}
                color="red"
                currentUnit={combinedFlowAUnit}
                type={'flow'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="flowA"
            />}
            {hasChanA && <GraphChannelDisplay
                colors={colors}
                name={intl.formatMessage({ id: 'Totaliser A' })}
                loggers={loggers}
                color="yellow"
                currentUnit={combinedTotalAUnit}
                type={'total'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="flowATotal"
            />}
            {hasChanA && <GraphChannelDisplay
                colors={colors}
                name={intl.formatMessage({ id: 'Consumption A' })}
                loggers={loggers}
                color="teal"
                currentUnit={combinedConsumptionAUnit}
                type={'consumption'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="flowAConsumption"
            />}
            {hasChanB && <GraphChannelDisplay
                colors={colors}
                name={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Flow B' }) : intl.formatMessage({ id: 'Channel B' })}
                loggers={loggers}
                color="green"
                currentUnit={combinedFlowBUnit}
                type={'flow'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="flowB"
            />}
            {hasChanB && <GraphChannelDisplay
                colors={colors}
                name={intl.formatMessage({ id: 'Totaliser B' })}
                loggers={loggers}
                color="brown"
                currentUnit={combinedTotalBUnit}
                type={'total'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="flowBTotal"
            />}
            {hasChanB && <GraphChannelDisplay
                colors={colors}
                name={intl.formatMessage({ id: 'Consumption B' })}
                loggers={loggers}
                color="pink"
                currentUnit={combinedConsumptionBUnit}
                type={'consumption'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="flowBConsumption"
            />}
            {hasChanC && <GraphChannelDisplay
                colors={colors}
                name={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure C' }) : intl.formatMessage({ id: 'Channel C' })}
                loggers={loggers}
                color="blue"
                currentUnit={combinedPressureCUnit}
                type={'pressure'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="pressureC"
            />}
            {hasChanD && <GraphChannelDisplay
                colors={colors}
                name={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure D' }) : intl.formatMessage({ id: 'Channel D' })}
                loggers={loggers}
                color="orange"
                currentUnit={combinedPressureDUnit}
                type={'pressure'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="pressureD"
            />}
            {hasChanE && !window.location.hostname.includes('zonelog.net') && <GraphChannelDisplay
                colors={colors}
                name={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Pressure E' }) : intl.formatMessage({ id: 'Channel E' })}
                loggers={loggers}
                color="purple"
                currentUnit={combinedPressureEUnit}
                type={'pressure'}
                handleHideLoggerChannel={handleHideLoggerChannel}
                unitsAndValues={unitsAndValues}
                handleUnitChange={handleUnitChange}
                handleGraphTypeChange={handleGraphTypeChange}
                graphSettingsType="pressureE"
            />}
        </>)
    }
    const handleGraphTypeChange = (value: string, channel: string):void => {
        const units = [...unitsAndValues]
        units.map(unit => {
            const sett = unit.graphSettings
            if (channel === 'A') {
                sett.flowAGraphType = value
                if (showCombinedFlow) {
                    setCombinedFlowGraphType(value)
                }
            }
            if (channel === 'AT') {
                sett.flowATotalGraphType = value
            }
            if (channel === 'AC') {
                sett.flowAConsumptionGraphType = value
            }
            if (channel === 'B') {
                sett.flowBGraphType = value
            }
            if (channel === 'BT') {
                sett.flowBTotalGraphType = value
            }
            if (channel === 'BC') {
                sett.flowBConsumptionGraphType = value
            }
            if (channel === 'C') {
                sett.pressureCGraphType = value
            }
            if (channel === 'D') {
                sett.pressureDGraphType = value
            }
            if (channel === 'E') {
                sett.pressureEGraphType = value
            }
        })
        setUnitsAndValues(units)
    }

    const handleUnitChange = (value: string, channel: string): void => {

        setLoading(true)
        setIsProcessingUnitChange(true)
        let unitsAndValuesTemp = unitsAndValues
        unitsAndValuesTemp.forEach(item => {
            const set = item.graphSettings
            if (channel === 'A') {
                set.flowAMinValue = Number.MAX_VALUE
                set.flowAMaxValue = Number.NEGATIVE_INFINITY
            }
            if (channel === 'AT') {
                set.flowATotalMinValue = Number.MAX_VALUE
                set.flowATotalMaxValue = Number.NEGATIVE_INFINITY
            }
            if (channel === 'AC') {
                set.flowAConsumptionMinValue = Number.MAX_VALUE
                set.flowAConsumptionMaxValue = Number.NEGATIVE_INFINITY
            }
            if (channel === 'B') {
                set.flowBMinValue = Number.MAX_VALUE
                set.flowBMaxValue = Number.NEGATIVE_INFINITY
            }
            if (channel === 'BT') {
                set.flowBTotalMinValue = Number.MAX_VALUE
                set.flowBTotalMaxValue = Number.NEGATIVE_INFINITY
            }
            if (channel === 'BC') {
                set.flowBConsumptionMinValue = Number.MAX_VALUE
                set.flowBConsumptionMaxValue = Number.NEGATIVE_INFINITY
            }
            if (channel === 'C') {
                set.pressureCMinValue = Number.MAX_VALUE
                set.pressureCMaxValue = Number.NEGATIVE_INFINITY
            }
            if (channel === 'D') {
                set.pressureDMinValue = Number.MAX_VALUE
                set.pressureDMaxValue = Number.NEGATIVE_INFINITY
            }
            if (channel === 'E') {
                set.pressureEMinValue = Number.MAX_VALUE
                set.pressureEMaxValue = Number.NEGATIVE_INFINITY
            }

        })

        const modData = graphData.map(item => {
            const serial = item.serial
            



            if (channel === 'A') {
                const previousUnit = combinedFlowAUnit
                if (Object.keys(item).some(key => new RegExp("flowRateA").test(key))) {
                    item[`${serial}flowRateA`] ? item[`${serial}flowRateA`] = item[`${serial}flowRateA`] * flowConverter(value, previousUnit) : null
                }
                if (Object.keys(item).some(key => new RegExp("combinedFlowA").test(key))) {
                    item.combinedFlowA ? item.combinedFlowA = item.combinedFlowA * flowConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}flowRateA`] !== null) {
                        unit.graphSettings.flowAUnit = value
                        if (item[`${serial}flowRateA`] < unit.graphSettings.flowAMinValue) {

                            unit.graphSettings.flowAMinValue = item[`${serial}flowRateA`]
                        }
                        if (item[`${serial}flowRateA`] > unit.graphSettings.flowAMaxValue) {
                            unit.graphSettings.flowAMaxValue = item[`${serial}flowRateA`]
                        }
                    }
                    return unit
                })
                setCombinedFlowAUnit(value)
            }
            
            if (channel === 'AT') {
                const previousUnit = combinedTotalAUnit
                if (Object.keys(item).some(key => new RegExp("readingA").test(key))) {
                    item[`${serial}readingA`] ? item[`${serial}readingA`] = item[`${serial}readingA`] * totalConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}readingA`] !== null) {
                        unit.graphSettings.flowATotalUnit = value
                        if (item[`${serial}readingA`] < unit.graphSettings.flowATotalMinValue) {
                            unit.graphSettings.flowATotalMinValue = item[`${serial}readingA`]
                        }
                        if (item[`${serial}readingA`] > unit.graphSettings.flowATotalMaxValue) {
                            unit.graphSettings.flowATotalMaxValue = item[`${serial}readingA`]
                        }
                    }
                    return unit
                })
                setCombinedTotalAUnit(value)
            }
            if (channel === 'AC') {
                const previousUnit = combinedConsumptionAUnit
                if (Object.keys(item).some(key => new RegExp("consumptionA").test(key))) {
                    item[`${serial}consumptionA`] ? item[`${serial}consumptionA`] = item[`${serial}consumptionA`] * totalConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}consumptionA`] !== null) {
                        unit.graphSettings.flowAConsumptionUnit = value
                        if (item[`${serial}consumptionA`] < unit.graphSettings.flowAConsumptionMinValue) {
                            unit.graphSettings.flowAConsumptionMinValue = item[`${serial}consumptionA`]
                        }
                        if (item[`${serial}consumptionA`] > unit.graphSettings.flowAConsumptionMaxValue) {
                            unit.graphSettings.flowAConsumptionMaxValue = item[`${serial}consumptionA`]
                        }
                    }
                    return unit
                })
                setCombinedConsumptionAUnit(value)
            }
            if (channel === 'B') {
                const previousUnit = combinedFlowBUnit
                if (Object.keys(item).some(key => new RegExp("flowRateB").test(key))) {
                    item[`${serial}flowRateB`] ? item[`${serial}flowRateB`] = item[`${serial}flowRateB`] * flowConverter(value, previousUnit) : null
                }
                if (Object.keys(item).some(key => new RegExp("combinedFlowB").test(key))) {
                    item.combinedFlowB ? item.combinedFlowB = item.combinedFlowB * flowConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}flowRateB`] !== null) {
                        unit.graphSettings.flowBUnit = value
                        if (item[`${serial}flowRateB`] < unit.graphSettings.flowBMinValue) {
                            unit.graphSettings.flowBMinValue = item[`${serial}flowRateB`]
                        }
                        if (item[`${serial}flowRateB`] > unit.graphSettings.flowBMaxValue) {
                            unit.graphSettings.flowBMaxValue = item[`${serial}flowRateB`]
                        }
                    }
                    return unit
                })
                setCombinedFlowBUnit(value)
            }
            if (channel === 'BT') {
                const previousUnit = combinedTotalBUnit
                if (Object.keys(item).some(key => new RegExp("readingB").test(key))) {
                    item[`${serial}readingB`] ? item[`${serial}readingB`] = item[`${serial}readingB`] * totalConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}readingB`] !== null) {
                        unit.graphSettings.flowBTotalUnit = value
                        if (item[`${serial}readingB`] < unit.graphSettings.flowBTotalMinValue) {
                            unit.graphSettings.flowBTotalMinValue = item[`${serial}readingB`]
                        }
                        if (item[`${serial}readingB`] > unit.graphSettings.flowBTotalMaxValue) {
                            unit.graphSettings.flowBTotalMaxValue = item[`${serial}readingB`]
                        }
                    }
                    return unit
                })
                setCombinedTotalBUnit(value)
            }
            if (channel === 'BC') {
                const previousUnit = combinedConsumptionBUnit
                if (Object.keys(item).some(key => new RegExp("consumptionB").test(key))) {
                    item[`${serial}consumptionB`] ? item[`${serial}consumptionB`] = item[`${serial}consumptionB`] * totalConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}consumptionB`] !== null) {
                        unit.graphSettings.flowBConsumptionUnit = value
                        if (item[`${serial}consumptionB`] < unit.graphSettings.flowBConsumptionMinValue) {
                            unit.graphSettings.flowBConsumptionMinValue = item[`${serial}consumptionB`]
                        }
                        if (item[`${serial}consumptionB`] > unit.graphSettings.flowBConsumptionMaxValue) {
                            unit.graphSettings.flowBConsumptionMaxValue = item[`${serial}consumptionB`]
                        }
                    }
                    return unit
                })
                setCombinedConsumptionBUnit(value)
            }
            if (channel === 'C') {
                const previousUnit = combinedPressureCUnit
                if (Object.keys(item).some(key => new RegExp("readingC").test(key))) {

                    item[`${serial}readingC`] ? item[`${serial}readingC`] = item[`${serial}readingC`] * pressureConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}readingC`] !== null) {
                        unit.graphSettings.pressureCUnit = value
                        if (item[`${serial}readingC`] < unit.graphSettings.pressureCMinValue) {
                            unit.graphSettings.pressureCMinValue = item[`${serial}readingC`]
                        }
                        if (item[`${serial}readingC`] > unit.graphSettings.pressureCMaxValue) {
                            unit.graphSettings.pressureCMaxValue = item[`${serial}readingC`]
                        }
                    }
                    return unit
                })
                setCombinedPressureCUnit(value)
            }
            if (channel === 'D') {
                const previousUnit = combinedPressureDUnit
                if (Object.keys(item).some(key => new RegExp("readingD").test(key))) {
                    item[`${serial}readingD`] ? item[`${serial}readingD`] = item[`${serial}readingD`] * pressureConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}readingD`] !== null) {
                        unit.graphSettings.pressureDUnit = value
                        if (item[`${serial}readingD`] < unit.graphSettings.pressureDMinValue) {
                            unit.graphSettings.pressureDMinValue = item[`${serial}readingD`]
                        }
                        if (item[`${serial}readingD`] > unit.graphSettings.pressureDMaxValue) {
                            unit.graphSettings.pressureDMaxValue = item[`${serial}readingD`]
                        }
                    }
                    return unit
                })
                setCombinedPressureDUnit(value)
            }
            if (channel === 'E') {
                const previousUnit = combinedPressureEUnit
                if (Object.keys(item).some(key => new RegExp("readingE").test(key))) {
                    item[`${serial}readingE`] ? item[`${serial}readingE`] = item[`${serial}readingE`] * pressureConverter(value, previousUnit) : null
                }
                unitsAndValuesTemp = unitsAndValuesTemp.map(unit => {
                    if ((unit.serial === serial) && item[`${serial}readingE`] !== null) {
                        unit.graphSettings.pressureEUnit = value
                        if (item[`${serial}readingE`] < unit.graphSettings.pressureEMinValue) {
                            unit.graphSettings.pressureEMinValue = item[`${serial}readingE`]
                        }
                        if (item[`${serial}readingE`] > unit.graphSettings.pressureEMaxValue) {
                            unit.graphSettings.pressureEMaxValue = item[`${serial}readingE`]
                        }
                    }
                    return unit
                })
                setCombinedPressureEUnit(value)
            }

            return item
        })
        //setLoading(false)
        setUnitsAndValues(unitsAndValuesTemp)
        setGraphData(modData)

    }


    const handleCombineYClick = () => {
        CallPostAPI(CreateUrl(`/api/aquaguard/userSettings?companyId=${sessionStorage.getItem('companyId')}&userId=${sessionStorage.getItem('userId')}&settingsType=Graph&key=CombineY&value=${!combineY}`), {})
            .then(data => {/**/ })
            .catch(err => console.error(err))

            handleCombineY()
    }


    const handleCombineY = (): void => {

        
        if (!combineY) {
            const pressureCUnitCount = [0,0,0,0,0,0,0,0]
            const pressureDUnitCount = [0,0,0,0,0,0,0,0]
            const pressureEUnitCount = [0,0,0,0,0,0,0,0]
            const flowAUnitCount = [0,0,0,0,0,0,0]
            const flowBUnitCount = [0,0,0,0,0,0,0]
            const flowATotalUnitCount = [0,0,0,0]
            const flowBTotalUnitCount = [0,0,0,0]
            const flowAConsumptionUnitCount = [0,0,0,0]
            const flowBConsumptionUnitCount = [0,0,0,0]
            let flowUnitA = ""
            let flowUnitB = ""
            let totalUnitA = ""
            let totalUnitB = ""
            let consumptionUnitA = ""
            let consumptionUnitB = ""
            let pressureCUnit = ""
            let pressureDUnit = ""
            let pressureEUnit = ""
            unitsAndValues.forEach(u => {
                const channelsAvail = u.channelsAvail

                const sett = u.graphSettings

                if (channelsAvail & 0x01) {
                    if (showFlow) { 
                        sett.flowAVisible = true
                    }
                    setHasFlow(true)
                    setHasConsumption(true)
                    setHasTotal(true)
                    flowRateUnits.forEach((unit, idx) => {
                        if (unit.value === sett.flowAUnit) {
                            flowAUnitCount[idx]++
                        }
                    })
                    if (showTotal) {
                        sett.flowATotalVisible = true
                    }
                    flowUnits.forEach((unit, idx) => {
                        if (unit.value === sett.flowATotalUnit) {
                            flowATotalUnitCount[idx]++
                        }
                    })
                    if (showConsumption) {
                        sett.flowAConsumptionVisible = true
                    }
                    flowUnits.forEach((unit, idx) => {
                        if (unit.value === sett.flowAConsumptionUnit) {
                            flowAConsumptionUnitCount[idx]++
                        }
                    })
                }
                if (channelsAvail & 0x02) {
                    if (showFlow) {
                        sett.flowBVisible = true
                    }
                    sett.flowBVisible = true
                    setHasFlow(true)
                    setHasConsumption(true)
                    setHasTotal(true)
                    flowRateUnits.forEach((unit, idx) => {
                        if (unit.value === sett.flowBUnit) {
                            flowBUnitCount[idx]++
                        }
                    })
                    if (showTotal) {
                        sett.flowBTotalVisible = true
                    }
                    flowUnits.forEach((unit, idx) => {
                        if (unit.value === sett.flowBTotalUnit) {
                            flowBTotalUnitCount[idx]++
                        }
                    })
                    if (showConsumption) {
                        sett.flowBConsumptionVisible = true
                    }
                    flowUnits.forEach((unit, idx) => {
                        if (unit.value === sett.flowBConsumptionUnit) {
                            flowBConsumptionUnitCount[idx]++
                        }
                    })
                }

                if (channelsAvail & 0x04) {
                    setHasPressureChannels(true)
                    if (showPressure) {
                        sett.pressureCVisible = true
                    }
                    
                    if (pressureUnits.map(unit => unit.value).includes(sett.pressureCUnit)) {
                        pressureUnits.forEach((unit, idx) => {

                            if (unit.value === sett.pressureCUnit) {
                                pressureCUnitCount[idx]++
                            }
                        })
                    }
                }
                if (channelsAvail & 0x08) {
                    setHasPressureChannels(true)
                    if (showPressure) {
                        sett.pressureDVisible = true
                    }
                    if (pressureUnits.map(unit => unit.value).includes(sett.pressureDUnit)) {
                        pressureUnits.forEach((unit, idx) => {
                            if (unit.value === sett.pressureDUnit) {
                                pressureDUnitCount[idx]++
                            }
                        })
                    }
                }
                if (channelsAvail & 0x10) {
                    setHasPressureChannels(true)
                    if (showPressure) {
                        sett.pressureEVisible = true
                    }
                    if (pressureUnits.map(unit => unit.value).includes(sett.pressureEUnit)) {
                        pressureUnits.forEach((unit, idx) => {
                            if (unit.value === sett.pressureEUnit) {
                                pressureEUnitCount[idx]++
                            }
                        })
                    }
                }
                //setShowFlow(true)
                //setShowPressure(true)
                //setShowTotal(true)
                //setShowConsumption(true)



            })
            flowUnitA = flowRateUnits[flowAUnitCount.indexOf(Math.max(...flowAUnitCount))].value
            totalUnitA = flowUnits[flowATotalUnitCount.indexOf(Math.max(...flowATotalUnitCount))].value
            consumptionUnitA = flowUnits[flowAConsumptionUnitCount.indexOf(Math.max(...flowAConsumptionUnitCount))].value
            flowUnitB = flowRateUnits[flowBUnitCount.indexOf(Math.max(...flowBUnitCount))].value
            totalUnitB = flowUnits[flowBTotalUnitCount.indexOf(Math.max(...flowBTotalUnitCount))].value
            consumptionUnitB = flowUnits[flowBConsumptionUnitCount.indexOf(Math.max(...flowBConsumptionUnitCount))].value

            if (Math.max(...pressureCUnitCount) === 0) {
                const pressureCArr = unitsAndValues.map(log => log.graphSettings.pressureCUnit)
                const allSame = pressureCArr.every(unit => unit === pressureCArr[0])
                if (allSame) {
                    pressureCUnit = pressureCArr[0]
                }
            } else {
                pressureCUnit = pressureUnits[pressureCUnitCount.indexOf(Math.max(...pressureCUnitCount))].value
            }
            if (Math.max(...pressureDUnitCount) === 0) {
                const pressureDArr = unitsAndValues.map(log => log.graphSettings.pressureDUnit)
                const allSame = pressureDArr.every(unit => unit === pressureDArr[0])
                if (allSame) {
                    pressureDUnit = pressureDArr[0]
                }
            } else {
                pressureDUnit = pressureUnits[pressureDUnitCount.indexOf(Math.max(...pressureDUnitCount))].value
            }

            if (Math.max(...pressureEUnitCount) === 0) {
                const pressureEArr = unitsAndValues.map(log => log.graphSettings.pressureEUnit)
                const allSame = pressureEArr.every(unit => unit === pressureEArr[0])
                if (allSame) {
                    pressureEUnit = pressureEArr[0]
                }
            } else {
                pressureEUnit = pressureUnits[pressureEUnitCount.indexOf(Math.max(...pressureEUnitCount))].value
            }


            setCombinedFlowAUnit(flowUnitA)
            setCombinedTotalAUnit(totalUnitA)
            setCombinedConsumptionAUnit(consumptionUnitA)
            setCombinedFlowBUnit(flowUnitB)
            setCombinedTotalBUnit(totalUnitB)
            setCombinedConsumptionBUnit(consumptionUnitB)

            setCombinedPressureCUnit(pressureCUnit)
            setCombinedPressureDUnit(pressureDUnit)
            setCombinedPressureEUnit(pressureEUnit)

            modifyGraphData(flowUnitA, flowUnitB, totalUnitA, totalUnitB, consumptionUnitA, consumptionUnitB, pressureCUnit, pressureDUnit, pressureEUnit)
            unitsAndValues.forEach(unit => {
                const sett = unit.graphSettings
                sett.flowAGraphType = 'spline'
                sett.flowATotalGraphType = 'bar'
                sett.flowAConsumptionGraphType = 'bar'
                sett.flowBGraphType = 'spline'
                sett.flowBTotalGraphType = 'bar'
                sett.flowBConsumptionGraphType = 'bar'
                sett.pressureCGraphType = 'spline'
                sett.pressureDGraphType = 'spline'
                sett.pressureEGraphType = 'spline'
            })
        } else {
            setShowCombinedFlow(false)
            reloadData(location.state.groupId, location.state.loggers, location.state.site, true)
        }
        setCombineY(!combineY)
    }

    const modifyGraphData = (flowUnitA: string, flowUnitB: string, totalUnitA: string, totalUnitB: string, consumptionUnitA: string, consumptionUnitB: string , pressureCUnit: string, pressureDUnit: string, pressureEUnit: string):void => {
        setLoading(true)
        let resetMinMaxUnitsAndValues = [...unitsAndValues]

        resetMinMaxUnitsAndValues.forEach(unit => {
            const sett = unit.graphSettings
            if (sett.flowAUnit !== flowUnitA) {
                sett.flowAMinValue = Number.MAX_VALUE
                sett.flowAMaxValue = Number.NEGATIVE_INFINITY
            }
            if (sett.flowATotalUnit !== totalUnitA) {
                sett.flowATotalMinValue = Number.MAX_VALUE
                sett.flowATotalMaxValue = Number.NEGATIVE_INFINITY
            }
            if (sett.flowAConsumptionUnit !== consumptionUnitA) {
                sett.flowAConsumptionMinValue = Number.MAX_VALUE
                sett.flowAConsumptionMaxValue = Number.NEGATIVE_INFINITY
            }
            if (sett.flowBUnit !== flowUnitB) {
                sett.flowBMinValue = Number.MAX_VALUE
                sett.flowBMaxValue = Number.NEGATIVE_INFINITY
            }
            if (sett.flowBTotalUnit !== totalUnitB) {
                sett.flowBTotalMinValue = Number.MAX_VALUE
                sett.flowBTotalMaxValue = Number.NEGATIVE_INFINITY
            }
            if (sett.flowBConsumptionUnit !== consumptionUnitB) {
                sett.flowBConsumptionMinValue = Number.MAX_VALUE
                sett.flowBConsumptionMaxValue = Number.NEGATIVE_INFINITY
            }
            if (sett.pressureCUnit !== pressureCUnit) {
                sett.pressureCMinValue = Number.MAX_VALUE
                sett.pressureCMaxValue = Number.NEGATIVE_INFINITY
            }
            if (sett.pressureDUnit !== pressureDUnit) {
                sett.pressureDMinValue = Number.MAX_VALUE
                sett.pressureDMaxValue = Number.NEGATIVE_INFINITY
            }
            if (sett.pressureEUnit !== pressureEUnit) {
                sett.pressureEMinValue = Number.MAX_VALUE
                sett.pressureEMaxValue = Number.NEGATIVE_INFINITY
            }
        })
        const modData = graphData.map(item => {
            const modItem = { ...item }

       
            
                
            //if (!showCombinedFlow) {

                const serial = parseInt(modItem.serial)
               
                const graphSettings = unitsAndValues.filter(unit => unit.serial === serial)[0]?.graphSettings

                if (Object.keys(modItem).some(key => key === `${serial}flowRateA` && modItem[`${serial}flowRateA`] !== null)) {
                    if (graphSettings?.flowAUnit !== flowUnitA) {
                        modItem[`${serial}flowRateA`] = modItem[`${serial}flowRateA`] * flowConverter(flowUnitA, graphSettings?.flowAUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === parseInt(serial)) {
                                if (modItem[`${serial}flowRateA`] > item.graphSettings.flowAMaxValue) {
                                    item.graphSettings.flowAMaxValue = modItem[`${serial}flowRateA`]
                                }
                                if (modItem[`${serial}flowRateA`] < item.graphSettings.flowAMinValue) {
                                    item.graphSettings.flowAMinValue = modItem[`${serial}flowRateA`]
                                }

                            }
                            return item
                        })
                    }
                }
                if (Object.keys(modItem).some(key => key === `${serial}readingA` && modItem[`${serial}readingA`] !== null)) {
                    if (graphSettings?.flowATotalUnit !== totalUnitA) {
                        modItem[`${serial}readingA`] = modItem[`${serial}readingA`] * totalConverter(totalUnitA, graphSettings?.flowATotalUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === parseInt(serial)) {
                                if (modItem[`${serial}readingA`] > item.graphSettings.flowATotalMaxValue) {
                                    item.graphSettings.flowATotalMaxValue = modItem[`${serial}readingA`]
                                }
                                if (modItem[`${serial}readingA`] < item.graphSettings.flowATotalMinValue) {
                                    item.graphSettings.flowATotalMinValue = modItem[`${serial}readingA`]
                                }

                            }
                            return item
                        })
                    }
                }
                if (Object.keys(modItem).some(key => key === `${serial}consumptionA` && modItem[`${serial}consumptionA`] !== null)) {
                    if (graphSettings?.flowAConsumptionUnit !== consumptionUnitA) {
                        modItem[`${serial}consumptionA`] = modItem[`${serial}consumptionA`] * totalConverter(consumptionUnitA, graphSettings?.flowAConsumptionUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === parseInt(serial)) {
                                if (modItem[`${serial}consumptionA`] > item.graphSettings.flowAConsumptionMaxValue) {
                                    item.graphSettings.flowAConsumptionMaxValue = modItem[`${serial}consumptionA`]
                                }
                                if (modItem[`${serial}consumptionA`] < item.graphSettings.flowAConsumptionMinValue) {
                                    item.graphSettings.flowAConsumptionMinValue = modItem[`${serial}consumptionA`]
                                }

                            }
                            return item
                        })
                    }
                }
                if (Object.keys(modItem).some(key => key === 'combinedFlowA')) {
                    if (graphSettings?.flowACombinedUnit !== flowUnitA) {
                        modItem.combinedFlowA = modItem.combinedFlowA * flowConverter(flowUnitA, unitsAndValues[0].graphSettings.flowACombinedUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (modItem.combinedFlowA > item.graphSettings.flowACombinedMaxValue) {
                                item.graphSettings.flowACombinedMaxValue = modItem.combinedFlowA
                            }
                            if (modItem.combinedFlowA < item.graphSettings.flowACombinedMaxValue) {
                                item.graphSettings.flowACombinedMaxValue = modItem.combinedFlowA
                            }
                            return item
                        })
                    }
                }
                if (Object.keys(modItem).some(key => key === `${serial}flowRateB` && modItem[`${serial}flowRateB`] !== null)) {
                    if (graphSettings?.flowBUnit !== flowUnitB) {
                        modItem[`${serial}flowRateB`] = modItem[`${serial}flowRateB`] * flowConverter(flowUnitB, graphSettings?.flowBUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === parseInt(serial)) {
                                if (modItem[`${serial}flowRateB`] > item.graphSettings.flowBMaxValue) {
                                    item.graphSettings.flowBMaxValue = modItem[`${serial}flowRateB`]
                                }
                                if (modItem[`${serial}flowRateB`] < item.graphSettings.flowBMinValue) {
                                    item.graphSettings.flowBMinValue = modItem[`${serial}flowRateB`]
                                }

                            }
                            return item
                        })
                    }
                }
                if (Object.keys(modItem).some(key => key === `${serial}readingB` && modItem[`${serial}readingB`] !== null)) {
                    if (graphSettings?.flowBTotalUnit !== totalUnitB) {
                        modItem[`${serial}readingB`] = modItem[`${serial}readingB`] * totalConverter(totalUnitB, graphSettings?.flowBTotalUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === parseInt(serial)) {
                                if (modItem[`${serial}readingB`] > item.graphSettings.flowBTotalMaxValue) {
                                    item.graphSettings.flowBTotalMaxValue = modItem[`${serial}readingB`]
                                }
                                if (modItem[`${serial}readingB`] < item.graphSettings.flowBTotalMinValue) {
                                    item.graphSettings.flowBTotalMinValue = modItem[`${serial}readingB`]
                                }

                            }
                            return item
                        })
                    }
                }
                if (Object.keys(modItem).some(key => key === `${serial}consumptionB` && modItem[`${serial}consumptionB`] !== null)) {
                    if (graphSettings?.flowBConsumptionUnit !== consumptionUnitB) {
                        modItem[`${serial}consumptionB`] = modItem[`${serial}consumptionB`] * totalConverter(consumptionUnitB, graphSettings?.flowBConsumptionUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === parseInt(serial)) {
                                if (modItem[`${serial}consumptionB`] > item.graphSettings.flowBConsumptionMaxValue) {
                                    item.graphSettings.flowBConsumptionMaxValue = modItem[`${serial}consumptionB`]
                                }
                                if (modItem[`${serial}consumptionB`] < item.graphSettings.flowBConsumptionMinValue) {
                                    item.graphSettings.flowBConsumptionMinValue = modItem[`${serial}consumptionB`]
                                }

                            }
                            return item
                        })
                    }
                }
                if (Object.keys(modItem).some(key => key === `${serial}readingC`) && modItem[`${serial}readingC`] !== null) {
                    if (graphSettings?.pressureCUnit !== pressureCUnit) {
                        modItem[`${serial}readingC`] = modItem[`${serial}readingC`] * pressureConverter(pressureCUnit, graphSettings?.pressureCUnit)
                        if (modItem[`${serial}readingCmin`] !== null) {
                            modItem[`${serial}readingCmin`] = modItem[`${serial}readingCmin`] * pressureConverter(pressureCUnit, graphSettings?.pressureCUnit)
                        }
                        if (modItem[`${serial}readingCmax`] !== null) {
                            modItem[`${serial}readingCmax`] = modItem[`${serial}readingCmax`] * pressureConverter(pressureCUnit, graphSettings?.pressureCUnit)
                        }
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === serial) {
                                if (item.graphSettings.pressureCValueAs === 'max') {
                                    if (modItem[`${serial}readingCmax`] > item.graphSettings.pressureCMaxValue) {
                                        item.graphSettings.pressureCMaxValue = modItem[`${serial}readingCmax`]
                                    }

                                    if (modItem[`${serial}readingCmax`] < item.graphSettings.pressureCMinValue) {
                                        item.graphSettings.pressureCMinValue = modItem[`${serial}readingCmax`]
                                    }
                                } else if (item.graphSettings.pressureCValueAs === 'min') {
                                    if (modItem[`${serial}readingCmin`] > item.graphSettings.pressureCMaxValue) {
                                        item.graphSettings.pressureCMaxValue = modItem[`${serial}readingCmin`]
                                    }

                                    if (modItem[`${serial}readingCmin`] < item.graphSettings.pressureCMinValue) {
                                        item.graphSettings.pressureCMinValue = modItem[`${serial}readingCmin`]
                                    }
                                } else {
                                    if (modItem[`${serial}readingC`] > item.graphSettings.pressureCMaxValue) {
                                        item.graphSettings.pressureCMaxValue = modItem[`${serial}readingC`]
                                    }

                                    if (modItem[`${serial}readingC`] < item.graphSettings.pressureCMinValue) {
                                        item.graphSettings.pressureCMinValue = modItem[`${serial}readingC`]
                                    }
                                }

                            }
                            return item
                        })
                    } 
                    
                }
                if (Object.keys(modItem).some(key => key === `${serial}readingD`) && modItem[`${serial}readingD`] !== null) {
                    if (graphSettings?.pressureDUnit !== pressureDUnit) {

                        modItem[`${serial}readingD`] = modItem[`${serial}readingD`] * pressureConverter(pressureDUnit, graphSettings?.pressureDUnit)
                        modItem[`${serial}readingDmin`] = modItem[`${serial}readingDmin`] * pressureConverter(pressureDUnit, graphSettings?.pressureDUnit)
                        modItem[`${serial}readingDmax`] = modItem[`${serial}readingDmax`] * pressureConverter(pressureDUnit, graphSettings?.pressureDUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === parseInt(serial)) {
                                if (item.graphSettings.pressureDValueAs === 'max') {
                                    if (modItem[`${serial}readingDmax`] > item.graphSettings.pressureDMaxValue) {
                                        item.graphSettings.pressureDMaxValue = modItem[`${serial}readingDmax`]
                                    }

                                    if (modItem[`${serial}readingDmax`] < item.graphSettings.pressureDMinValue) {
                                        item.graphSettings.pressureDMinValue = modItem[`${serial}readingDmax`]
                                    }
                                } else if (item.graphSettings.pressureDValueAs === 'min') {
                                    if (modItem[`${serial}readingDmin`] > item.graphSettings.pressureDMaxValue) {
                                        item.graphSettings.pressureDMaxValue = modItem[`${serial}readingDmin`]
                                    }

                                    if (modItem[`${serial}readingDmin`] < item.graphSettings.pressureDMinValue) {
                                        item.graphSettings.pressureDMinValue = modItem[`${serial}readingDmin`]
                                    }
                                } else {
                                    if (modItem[`${serial}readingD`] > item.graphSettings.pressureDMaxValue) {
                                        item.graphSettings.pressureDMaxValue = modItem[`${serial}readingD`]
                                    }

                                    if (modItem[`${serial}readingD`] < item.graphSettings.pressureDMinValue) {
                                        item.graphSettings.pressureDMinValue = modItem[`${serial}readingD`]
                                    }
                                }

                            }
                            return item
                        })
                    }
                }
                if (Object.keys(modItem).some(key => key === `${serial}readingE`) && modItem[`${serial}readingE`] !== null) {
                    if (graphSettings?.pressureEUnit !== pressureEUnit) {

                        modItem[`${serial}readingE`] = modItem[`${serial}readingE`] * pressureConverter(pressureEUnit, graphSettings?.pressureEUnit)
                        modItem[`${serial}readingEmin`] = modItem[`${serial}readingEmin`] * pressureConverter(pressureEUnit, graphSettings?.pressureEUnit)
                        modItem[`${serial}readingEmax`] = modItem[`${serial}readingEmax`] * pressureConverter(pressureEUnit, graphSettings?.pressureEUnit)
                        resetMinMaxUnitsAndValues = resetMinMaxUnitsAndValues.map(item => {
                            if (item.serial === parseInt(serial)) {
                                if (item.graphSettings.pressureEValueAs === 'max') {
                                    if (modItem[`${serial}readingEmax`] > item.graphSettings.pressureEMaxValue) {
                                        item.graphSettings.pressureEMaxValue = modItem[`${serial}readingEmax`]
                                    }

                                    if (modItem[`${serial}readingEmax`] < item.graphSettings.pressureEMinValue) {
                                        item.graphSettings.pressureEMinValue = modItem[`${serial}readingEmax`]
                                    }
                                } else if (item.graphSettings.pressureEValueAs === 'min') {
                                    if (modItem[`${serial}readingEmin`] > item.graphSettings.pressureEMaxValue) {
                                        item.graphSettings.pressureEMaxValue = modItem[`${serial}readingEmin`]
                                    }

                                    if (modItem[`${serial}readingEmin`] < item.graphSettings.pressureEMinValue) {
                                        item.graphSettings.pressureEMinValue = modItem[`${serial}readingEmin`]
                                    }
                                } else {
                                    if (modItem[`${serial}readingE`] > item.graphSettings.pressureEMaxValue) {
                                        item.graphSettings.pressureEMaxValue = modItem[`${serial}readingE`]
                                    }

                                    if (modItem[`${serial}readingE`] < item.graphSettings.pressureEMinValue) {
                                        item.graphSettings.pressureEMinValue = modItem[`${serial}readingE`]
                                    }
                                }

                            }
                            return item
                        })
                    }
                }
            //}
            
           return modItem

        }).filter(item => item !== null)
        setUnitsAndValues(resetMinMaxUnitsAndValues)
        setGraphData(modData)
        setLoading(false)


    }


    const customizePoint = (e: {value: number | null }) => {
        if (e.value) {
            return {
                visible: true, size: 1
}
        } else return {visible: false}
    }

    const handleZoomDrag = (e): void => {
        const prev = e.previousRange
        const range = e.range
        if (!moment(prev.startValue).isSame(moment(range.startValue)) && !moment(prev.endValue).isSame(moment(range.endValue)) && range.startValue !== Number.NEGATIVE_INFINITY) {
            setVisualRange({ startValue: e.range.startValue, endValue: e.range.endValue })
        }
    }


    const printChart = useCallback(() => {
        setExportModal(!exportModal)
        chartRef.current?.instance().print();
        
    }, []);










    ///tabs
    const tabsIconandTextSingleLogger = [
        {
            id: 0,
            text: intl.formatMessage({ id: "Flow" }),
            icon: "fa fa-water",
        },
        {
            id: 1,
            text: window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Analog Channels" }),
            icon: "fa fa-gauge"
        },
        {
            id: 2,
            text: intl.formatMessage({ id: "Totaliser" }),
            icon: "fa fa-signal"
        },
        {
            id: 3,
            text: intl.formatMessage({ id: "Consumption" }),
            icon: "fa fa-faucet"
        },
        ...(window.location.pathname.includes('SiteDetail')
            ? [{
                id: 4,
                text: intl.formatMessage({ id: "Combined Flow" }),
                icon: "fa fa-compress-arrows-alt",
            }]
            : [])
        
    ]

    const tabsIconandTextNoPressureSingleLogger = [
        {
            id: 0,
            text: intl.formatMessage({ id: "Flow" }),
            icon: "fa fa-water",
        },
        {
            id: 1,
            text: intl.formatMessage({ id: "Totaliser" }),
            icon: "fa fa-signal"
        },
        {
            id: 2,
            text: intl.formatMessage({ id: "Consumption" }),
            icon: "fa fa-faucet"
        },
        ...(window.location.pathname.includes('SiteDetail')
            ? [{
                id: 3,
                text: intl.formatMessage({ id: "Combined Flow" }),
                icon: "fa fa-compress-arrows-alt",
            }]
            : [])

    ]

    const tabsIconandTextMultiLogger = [
        {
            id: 0,
            text: intl.formatMessage({ id: "Flow" }),
            icon: "fa fa-water",
        },
        {
            id: 1,
            text: window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Analog Channels" }),
            icon: "fa fa-gauge"
        },
        {
            id: 2,
            text: intl.formatMessage({ id: "Totaliser" }),
            icon: "fa fa-signal"
        },
        {
            id: 3,
            text: intl.formatMessage({ id: "Consumption" }),
            icon: "fa fa-faucet"
        },
        ...(window.location.pathname.includes('SiteDetail')
            ? [{
                id: 4,
                text: intl.formatMessage({ id: "Combined Flow" }),
                icon: "fa fa-compress-arrows-alt",
            }]
            : [])

    ]

    const tabsIconandTextNoPressureMultiLogger = [
        {
            id: 0,
            text: intl.formatMessage({ id: "Flow" }),
            icon: "fa fa-water",

        },
        {
            id: 1,
            text: intl.formatMessage({ id: "Totaliser" }),
            icon: "fa fa-signal"
        },
        {
            id: 2,
            text: intl.formatMessage({ id: "Consumption" }),
            icon: "fa fa-faucet"
        },
        ...(window.location.pathname.includes('SiteDetail')
            ? [{
                id: 3,
                text: intl.formatMessage({ id: "Combined Flow" }),
                icon: "fa fa-compress-arrows-alt",
            }]
            : [])
    ]



    const overViewStyle = {

        borderRadius: "5px",
        padding: "10px 10px 30px 10px",

        boxShadow: "2px 2px 10px #00000060",
        marginBottom: "30px",

    }


    const modalParagraphStyle = { margin: "auto 0 ", color: "#000000", fontWeight: 400 }

    const settings = graphTemplate.graphSettings


    const theme = useTheme()




    return (


        <>
            {!redirect ? <>

                {/*switch loading back around later */}
                {loading &&
                    <div style={{
                        position: 'absolute', left: 'Calc(50% - 100px)', top: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 13000
                    }}>
                        <Loader color={undefined} />
                    </div>
                }
                {!loading &&
                    <div>

                        {APIFailed &&
                            <ApiFailed />
                        }
                        {!APIFailed &&
                            <div style={{ position: "relative" }}>
                                <Modal
                                    show={minMaxModal}
                                    style={{
                                        width: "90%",
                                        
                                        //marginTop: "100px",
                                        position: 'absolute', left: '50%', top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 11000000
                                    }}
                                >
                                    <Modal.Header>
                                    <Modal.Title>Minimum / Maximum / Average Values</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div>

                                            <h5 style={{textAlign: 'center'} }>Between: {moment(startDate).format('DD MMM YYYY HH:mm:ss')} - {moment(endDate).format('DD MMM YYYY HH:mm:ss')}</h5>
                                            <DataGrid
                                                dataSource={minMaxDisplay}
                                                scrolling={{
                                                    mode: 'standard',
                                                    useNative: false
                                                }}
                                                allowColumnResizing={true}
                                                allowColumnReordering={true}

                                            >
                                                <FilterRow visible={true} />
                                                <HeaderFilter visible={true} search={{ enabled: true }} />
                                            </DataGrid>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant='contained' color='error' onClick={() => setMinMaxModal(false)}>Close</Button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal
                                    show={exportModal}
                                    style={{
                                        width: "40%",
                                        height: "50%",
                                        //marginTop: "100px",
                                        position: 'absolute', left: '50%', top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 11000000
                                    }}
                                >
                                    <Modal.Header>
                                        <Modal.Title>{!exportPrintType ? intl.formatMessage({ id: 'Select Output' }) : exportPrintType === 'Type of Export' ? intl.formatMessage({ id: "Type of Export" }) : ''}
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {exportPrintType === 'Type of Export'  && <div>
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <FormControlLabel value="CSV" style={{ color: "#000000" }} control={<Radio color="secondary" />} name={"exportType"} label="CSV" checked={exportAs === 'CSV'} onChange={(e): void => handleExportTypeChange(e.target.value)} />
                                                <FormControlLabel value="XLSX" style={{ color: "#000000" }} control={<Radio color="secondary" />} name={"exportType"} label="XLSX" checked={exportAs === 'XLSX'} onChange={(e): void => handleExportTypeChange(e.target.value)} />
                                                <FormControlLabel value="XLSX-T" style={{ color: "#000000" }} control={<Radio color="secondary" />} name={"exportType"} label="XLSX-T" checked={exportAs === 'XLSX-T'} onChange={(e): void => handleExportTypeChange(e.target.value)} />
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                <FormControlLabel style={{ color: "#000000" }} control={<Switch checked={splitDate} onChange={(): void => setSplitDate(!splitDate)} />} label={intl.formatMessage({ id: "Split Graph Export date in seperate columns" })} />
                                            </div>
                                        </div>}
                                        {!exportPrintType && <div style={{display: 'flex', justifyContent: 'center', width: '100%'} }>
                                            <Button variant="contained" color="secondary" style={{ marginRight: 10 }} onClick={():void => printChart() }>Print</Button>
                                            <Button onClick={():void => setExportPrintType('Type of Export') } variant='contained'>Export</Button>
                                        </div>}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        {exportPrintType === 'Type of Export' && <Button
                                            variant="contained"
                                            style={{ marginRight: "10px" }}
                                            onClick={(): void => {
                                                setExportPrintType("");
                                                exportConfirm(
                                                    toggleExportModal,
                                                    setLoading,
                                                    readingsData,
                                                    unitsAndValues,
                                                    splitDate,
                                                    exportAs,
                                                    startDate,
                                                    endDate,
                                                    location.state.groupId,
                                                    location.state.loggers,
                                                    location.state.site,
                                                    reloadData,
                                                    intl,
                                                    loggerSiteDetails
                                                )
                                            }}>
                                            <FormattedMessage id="Confirm" />
                                        </Button>}
                                        <Button variant="contained" color="error" onClick={(): void => { toggleExportModal() }}><FormattedMessage id="Cancel" /></Button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal
                                    show={selectLoggerToTemplate}
                                    style={{
                                        width: "40%",
                                        height: "50%",
                                        marginTop: "100px",
                                        position: 'absolute', left: '50%', top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        //zIndex: 10000
                                    }}
                                >
                                    <Modal.Header>
                                        <Modal.Title><FormattedMessage id="Which logger would you like to create your settings for?" />
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                            {loggers.length > 1 ?
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <Select
                                                        value={loggersToTemplate}
                                                        size="small"
                                                        style={{ background: "#ffffff", zIndex: 1000, width: "214px" }}
                                                        onChange={(e): void => { handleLoggerTemplateChange(e.target.value) }}
                                                    >
                                                        {loggers.map((logger) => {

                                                            return (<MenuItem style={{ zIndex: 1111111111111111 }} value={logger.Serial} key={logger.LoggerId}>{logger.Serial}</MenuItem>)
                                                        })}
                                                    </Select>
                                                </div> :
                                                <Button variant="contained" style={{ width: "214px", margin: "auto" }} onClick={(): void => toggleCreateTemplateOpen(true, false, false)}>{loggers.length > 0 && loggers[0].Serial}</Button>}
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                        <h5 style={{ margin: "0 auto" }}><FormattedMessage id="Or" /></h5>
                                                        <Button variant="contained" color="secondary" onClick={(): void => toggleCreateUserDefault()}><FormattedMessage id="Create User Default" /></Button>
                                                    </div>
                                                </div>
                                            {sessionStorage.getItem('canConfig') === 'true' &&
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                        
                                                        <h5 style={{ margin: "0 auto" }}><FormattedMessage id="Or" /></h5>
                                                        <Button variant="contained" color="warning" onClick={(): void => toggleCreateCompanyDefault()}><FormattedMessage id="Create Company Default" /></Button>
                                                    </div>
                                                </div>}
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>

                                        {loggers.length > 1 && <Button variant="contained" color="primary" style={{ marginRight: "10px" }} onClick={(): void => toggleCreateTemplateOpen(true, null, null)}><FormattedMessage id="Select" /></Button>}
                                        <Button variant="contained" color="error" onClick={(): void => closeGraphTemplateWindow()}><FormattedMessage id="Cancel" /></Button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal
                                    show={createTemplateOpen}
                                    style={{
                                        //zIndex: 10001,
                                        width: "100%",
                                        height: "90%",
                                        position: 'absolute',
                                        transform: 'translate(0%, 30%)',




                                    }}
                                >
                                    <Modal.Header>
                                        <Modal.Title><FormattedMessage id="Create Graph Settings Template" /></Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {!createCompanyDefault && !createUserDefault && <div style={{ display: "flex", justifyContent: "space-between", borderLeft: "10px solid #000000", width: "98.7%", margin: " 20px 300px 0 10px", backgroundImage: "linear-gradient(30deg, #f7f7f7, #f7f7f7 71%, #808080)", ...overViewStyle }}>
                                            <div style={{ display: "flex" }}>
                                                <h4 style={{ margin: "auto" }}><FormattedMessage id="Current Selected Loggers that styling will be applied to:" /> </h4>
                                                <div>
                                                    {selectedTabName === 'Combined Flow' ?
                                                        <h4 style={{ margin: '3px 0 0 10px' }}><b>Combined Flow</b></h4> :
                                                        loggersToTemplate && <Chip style={{ margin: " 5px 5px auto 10px" }}
                                                        label={loggersToTemplate} color="primary" />}
                                                    
                                                </div>
                                            </div>
                                        </div>}
                                        <div style={{ display: "flex" }}>
                                            <Tabs
                                                onItemClick={(e): void => { setSelectedTabName(e.itemData?.text); setSelectedTab(e.itemIndex) }}
                                                dataSource={loggers.length === 1 ? (graphTemplate.channelsAvail > 3 ? tabsIconandTextSingleLogger : tabsIconandTextNoPressureSingleLogger) : (graphTemplate.channelsAvail > 3 ? tabsIconandTextMultiLogger : tabsIconandTextNoPressureMultiLogger)}
                                                defaultSelectedIndex={0}
                                                style={{ fontSize: "18px" }}
                                                selectionMode={'single'}
                                                selectedIndex={selectedTab}
                                                

                                            />


                                        </div>
                                        {unitsAndValues.length > 0 && <div style={{ border: "1px solid #dddddd" }}>
                                            {selectedTab === 0 &&
                                                <div>


                                                    {/*Flow A*/}
                                                    {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x01)) &&
                                                        <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={'#009fe3'}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"flowA"}
                                                        isPressure={false}
                                                        visible={settings.flowAVisible}
                                                        unit={settings.flowAUnit}
                                                        minState={settings.flowAMinState}
                                                        minValue={settings.flowAMinValue}
                                                        maxState={settings.flowAMaxState}
                                                        maxValue={settings.flowAMaxValue}
                                                        valueAs={null}
                                                        axisPosition={settings.flowAAxisPosition}
                                                        lineWidth={settings.flowALineWidth}
                                                        graphType={settings.flowAGraphType}
                                                        color={settings.flowAColor}
                                                        labelSize={settings.flowALabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={settings.flowAIsDigital ? `${intl.formatMessage({ id:'Digital'})} A` :intl.formatMessage({ id: "Flow A" })}
                                                        displayUnits={flowRateUnits}
                                                        isTotaliser={false}
                                                        totalPerDay={settings.flowATotalPerDay}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.flowADefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={undefined}
                                                        allowMinMax={undefined}
                                                        isDigital={settings.flowAIsDigital}
                                                        />
                                                    }



                                                    {/*Flow B*/}

                                                    {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x02)) &&
                                                        <GraphSettingsComponent
                                                            overViewStyle={overViewStyle}
                                                            borderColor={'#eed202'}
                                                            modalParagraphStyle={modalParagraphStyle}
                                                            handleGraphSettingsChange={handleGraphSettingsChange}
                                                            changeGroup={"flowB"}
                                                            isPressure={false}
                                                            visible={settings.flowBVisible}
                                                            unit={settings.flowBUnit}
                                                            minState={settings.flowBMinState}
                                                            minValue={settings.flowBMinValue}
                                                            maxState={settings.flowBMaxState}
                                                            maxValue={settings.flowBMaxValue}
                                                            valueAs={null}
                                                            axisPosition={settings.flowBAxisPosition}
                                                            lineWidth={settings.flowBLineWidth}
                                                            graphType={settings.flowBGraphType}
                                                            color={settings.flowBColor}
                                                            labelSize={settings.flowBLabelSize}
                                                            startDate={startDate}
                                                            loggers={loggers}
                                                            channel={settings.flowBIsDigital ? `${intl.formatMessage({ id: 'Digital' })} B` : intl.formatMessage({ id: "Flow B" })}
                                                            displayUnits={flowRateUnits}
                                                            isTotaliser={false}
                                                            totalPerDay={settings.flowBTotalPerDay}
                                                            companyDefault={createCompanyDefault}
                                                            defaultColor={settings.flowBDefaultColor}
                                                            pressureUnits={pressureUnits}
                                                            displayAll={undefined}
                                                            allowMinMax={undefined}
                                                            isDigital={settings.flowBIsDigital}
                                                        />}
                                                </div>

                                            }
                                            {}
                                            {!!(graphTemplate.channelsAvail > 3 ? selectedTab === 1 : selectedTab === 999) &&
                                                <div>
                                                    {/*Analoge C*/}

                                                    {(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x04)) &&
                                                        <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={'#6f2da8'}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"pressureC"}
                                                        isPressure={true}
                                                        visible={settings.pressureCVisible}
                                                        unit={settings.pressureCUnit}
                                                        minState={settings.pressureCMinState}
                                                        minValue={settings.pressureCMinValue}
                                                        maxState={settings.pressureCMaxState}
                                                        maxValue={settings.pressureCMaxValue}
                                                        valueAs={settings.pressureCValueAs}
                                                        axisPosition={settings.pressureCAxisPosition}
                                                        lineWidth={settings.pressureCLineWidth}
                                                        graphType={settings.pressureCGraphType}
                                                        color={settings.pressureCColor}
                                                        labelSize={settings.pressureCLabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure C" }) : intl.formatMessage({ id: "Analog C" })}
                                                        displayUnits={pressureUnits}
                                                        isTotaliser={false}
                                                        totalPerDay={settings.flowATotalPerDay}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.pressureCDefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={settings.pressureCDisplayAll}
                                                        allowMinMax={settings.pressureCAllowMinMax}
                                                        isDigital={undefined}
                                                        />}


                                                    {/*Analoge D*/}

                                                    {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x08)) &&
                                                        <GraphSettingsComponent
                                                            overViewStyle={overViewStyle}
                                                            borderColor={'#00ADBA'}
                                                            modalParagraphStyle={modalParagraphStyle}
                                                            handleGraphSettingsChange={handleGraphSettingsChange}
                                                            changeGroup={"pressureD"}
                                                            isPressure={true}
                                                            visible={settings.pressureDVisible}
                                                            unit={settings.pressureDUnit}
                                                            minState={settings.pressureDMinState}
                                                            minValue={settings.pressureDMinValue}
                                                            maxState={settings.pressureDMaxState}
                                                            maxValue={settings.pressureDMaxValue}
                                                            valueAs={settings.pressureDValueAs}
                                                            axisPosition={settings.pressureDAxisPosition}
                                                            lineWidth={settings.pressureDLineWidth}
                                                            graphType={settings.pressureDGraphType}
                                                            color={settings.pressureDColor}
                                                            labelSize={settings.pressureDLabelSize}
                                                            startDate={startDate}
                                                            loggers={loggers}
                                                            channel={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure D" }) : intl.formatMessage({ id: "Analog D" })}
                                                            displayUnits={pressureUnits}
                                                            isTotaliser={false}
                                                            totalPerDay={settings.flowATotalPerDay}
                                                            companyDefault={createCompanyDefault}
                                                            defaultColor={settings.pressureDDefaultColor}
                                                            pressureUnits={pressureUnits}
                                                            displayAll={settings.pressureDDisplayAll}
                                                            allowMinMax={settings.pressureDAllowMinMax}
                                                            isDigital={undefined}
                                                        />}
                                                    

                                                    {/*Analoge E*/}

                                                    {!!((createCompanyDefault || createUserDefault && !window.location.hostname.includes('zonelog.net')) || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x10)) &&
                                                        <GraphSettingsComponent
                                                            overViewStyle={overViewStyle}
                                                            borderColor={'#FF0000'}
                                                            modalParagraphStyle={modalParagraphStyle}
                                                            handleGraphSettingsChange={handleGraphSettingsChange}
                                                            changeGroup={"pressureE"}
                                                            isPressure={true}
                                                            visible={settings.pressureEVisible}
                                                            unit={settings.pressureEUnit}
                                                            minState={settings.pressureEMinState}
                                                            minValue={settings.pressureEMinValue}
                                                            maxState={settings.pressureEMaxState}
                                                            maxValue={settings.pressureEMaxValue}
                                                            valueAs={settings.pressureEValueAs}
                                                            axisPosition={settings.pressureEAxisPosition}
                                                            lineWidth={settings.pressureELineWidth}
                                                            graphType={settings.pressureEGraphType}
                                                            color={settings.pressureEColor}
                                                            labelSize={settings.pressureELabelSize}
                                                            startDate={startDate}
                                                            loggers={loggers}
                                                            channel={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure E" }) : intl.formatMessage({ id: "Analog E" })}
                                                            displayUnits={pressureUnits}
                                                            isTotaliser={false}
                                                            totalPerDay={settings.flowATotalPerDay}
                                                            companyDefault={createCompanyDefault}
                                                            defaultColor={settings.pressureEDefaultColor}
                                                            pressureUnits={pressureUnits}
                                                            displayAll={settings.pressureEDisplayAll}
                                                            allowMinMax={settings.pressureEAllowMinMax}
                                                            isDigital={undefined}
                                                        />}
                                                </div>

                                            }
                                            {selectedTab === 1 && graphTemplate.channelsAvail <= 3 &&
                                                <div>
                                                    {/*Total A*/}

                                                    {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.find(item => item.serial === loggersToTemplate)?.channelsAvail & 0x01)) && !settings.flowAIsDigital &&
                                                        <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={'#009fe3'}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"flowATotal"}
                                                        isPressure={false}
                                                        visible={settings.flowATotalVisible}
                                                        unit={settings.flowATotalUnit}
                                                        minState={settings.flowATotalMinState}
                                                        minValue={settings.flowATotalMinValue}
                                                        maxState={settings.flowATotalMaxState}
                                                        maxValue={settings.flowATotalMaxValue}
                                                        valueAs={null}
                                                        axisPosition={settings.flowATotalAxisPosition}
                                                        lineWidth={settings.flowATotalLineWidth}
                                                        graphType={settings.flowATotalGraphType}
                                                        color={settings.flowATotalColor}
                                                        labelSize={settings.flowATotalLabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={intl.formatMessage({ id: "Totaliser A" })}
                                                        displayUnits={flowUnits}
                                                        isTotaliser={true}
                                                        totalPerDay={settings.flowATotalPerDay}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.flowATotalDefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={undefined}
                                                        allowMinMax={undefined}
                                                        isDigital={undefined}
                                                        />
                                                    }



                                                    {/*Total B*/}

                                                    {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x02)) && !settings.flowBIsDigital &&
                                                        <GraphSettingsComponent
                                                            overViewStyle={overViewStyle}
                                                            borderColor={'#eed202'}
                                                            modalParagraphStyle={modalParagraphStyle}
                                                            handleGraphSettingsChange={handleGraphSettingsChange}
                                                            changeGroup={"flowBTotal"}
                                                            isPressure={false}
                                                            visible={settings.flowBTotalVisible}
                                                            unit={settings.flowBTotalUnit}
                                                            minState={settings.flowBTotalMinState}
                                                            minValue={settings.flowBTotalMinValue}
                                                            maxState={settings.flowBTotalMaxState}
                                                            maxValue={settings.flowBTotalMaxValue}
                                                            valueAs={null}
                                                            axisPosition={settings.flowBTotalAxisPosition}
                                                            lineWidth={settings.flowBTotalLineWidth}
                                                            graphType={settings.flowBTotalGraphType}
                                                            color={settings.flowBTotalColor}
                                                            labelSize={settings.flowBTotalLabelSize}
                                                            startDate={startDate}
                                                            loggers={loggers}
                                                            channel={intl.formatMessage({ id: "Totaliser B" })}
                                                            displayUnits={flowUnits}
                                                            isTotaliser={true}
                                                            totalPerDay={settings.flowATotalPerDay}
                                                            companyDefault={createCompanyDefault}
                                                            defaultColor={settings.flowBTotalDefaultColor}
                                                            pressureUnits={pressureUnits}
                                                            displayAll={undefined}
                                                            allowMinMax={undefined}
                                                            isDigital={undefined}
                                                        />}
                                                </div>}
                                            {selectedTab === 2 && graphTemplate.channelsAvail > 3 &&
                                                <div>
                                                    {/*Total A*/}

                                                    {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x01)) && !settings.flowAIsDigital &&
                                                        <GraphSettingsComponent
                                                            overViewStyle={overViewStyle}
                                                            borderColor={'#009fe3'}
                                                            modalParagraphStyle={modalParagraphStyle}
                                                            handleGraphSettingsChange={handleGraphSettingsChange}
                                                            changeGroup={"flowATotal"}
                                                            isPressure={false}
                                                            visible={settings.flowATotalVisible}
                                                            unit={settings.flowATotalUnit}
                                                            minState={settings.flowATotalMinState}
                                                            minValue={settings.flowATotalMinValue}
                                                            maxState={settings.flowATotalMaxState}
                                                            maxValue={settings.flowATotalMaxValue}
                                                            valueAs={null}
                                                            axisPosition={settings.flowATotalAxisPosition}
                                                            lineWidth={settings.flowATotalLineWidth}
                                                            graphType={settings.flowATotalGraphType}
                                                            color={settings.flowATotalColor}
                                                            labelSize={settings.flowATotalLabelSize}
                                                            startDate={startDate}
                                                            loggers={loggers}
                                                            channel={intl.formatMessage({ id: "Totaliser A" })}
                                                            displayUnits={flowUnits}
                                                            isTotaliser={true}
                                                            totalPerDay={settings.flowATotalPerDay}
                                                            companyDefault={createCompanyDefault}
                                                            defaultColor={settings.flowATotalDefaultColor}
                                                            pressureUnits={pressureUnits}
                                                            displayAll={undefined}
                                                            allowMinMax={undefined}
                                                            isDigital={undefined}
                                                            />
                                                    }



                                                    {/*Total B*/}

                                                    {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x02)) && !settings.flowBIsDigital &&
                                                        <GraphSettingsComponent
                                                            overViewStyle={overViewStyle}
                                                            borderColor={'#eed202'}
                                                            modalParagraphStyle={modalParagraphStyle}
                                                            handleGraphSettingsChange={handleGraphSettingsChange}
                                                            changeGroup={"flowBTotal"}
                                                            isPressure={false}
                                                            visible={settings.flowBTotalVisible}
                                                            unit={settings.flowBTotalUnit}
                                                            minState={settings.flowBTotalMinState}
                                                            minValue={settings.flowBTotalMinValue}
                                                            maxState={settings.flowBTotalMaxState}
                                                            maxValue={settings.flowBTotalMaxValue}
                                                            valueAs={null}
                                                            axisPosition={settings.flowBTotalAxisPosition}
                                                            lineWidth={settings.flowBTotalLineWidth}
                                                            graphType={settings.flowBTotalGraphType}
                                                            color={settings.flowBTotalColor}
                                                            labelSize={settings.flowBTotalLabelSize}
                                                            startDate={startDate}
                                                            loggers={loggers}
                                                            channel={intl.formatMessage({ id: "Totaliser B" })}
                                                            displayUnits={flowUnits}
                                                            isTotaliser={true}
                                                            totalPerDay={settings.flowBTotalPerDay}
                                                            companyDefault={createCompanyDefault}
                                                            defaultColor={settings.flowBTotalDefaultColor}
                                                            pressureUnits={pressureUnits}
                                                            displayAll={undefined}
                                                            allowMinMax={undefined}
                                                            isDigital={undefined}
                                                        />}
                                                </div>}
                                            {selectedTab === 2 && graphTemplate.channelsAvail <= 3 && <div>
                                                {/*Consumption A*/}

                                                {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x01)) && !settings.flowAIsDigital && 
                                                    <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={colors.teal[0]}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"flowAConsumption"}
                                                        isPressure={false}
                                                        visible={settings.flowAConsumptionVisible}
                                                        unit={settings.flowAConsumptionUnit}
                                                        minState={settings.flowAConsumptionMinState}
                                                        minValue={settings.flowAConsumptionMinValue}
                                                        maxState={settings.flowAConsumptionMaxState}
                                                        maxValue={settings.flowAConsumptionMaxValue}
                                                        valueAs={null}
                                                        axisPosition={settings.flowAConsumptionAxisPosition}
                                                        lineWidth={settings.flowAConsumptionLineWidth}
                                                        graphType={settings.flowAConsumptionGraphType}
                                                        color={settings.flowAConsumptionColor}
                                                        labelSize={settings.flowAConsumptionLabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={intl.formatMessage({ id: "Consumption A" })}
                                                        displayUnits={flowUnits}
                                                        totalPerDay={false}
                                                        isTotaliser={false}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.flowAConsumptionDefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={undefined}
                                                        allowMinMax={undefined}
                                                        isDigital={undefined}
                                                    />
                                                }



                                                {/*Consumption B*/}

                                                {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x02)) && !settings.flowBIsDigital &&
                                                    <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={colors.pink[0]}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"flowBConsumption"}
                                                        isPressure={false}
                                                        visible={settings.flowBConsumptionVisible}
                                                        unit={settings.flowBConsumptionUnit}
                                                        minState={settings.flowBConsumptionMinState}
                                                        minValue={settings.flowBConsumptionMinValue}
                                                        maxState={settings.flowBConsumptionMaxState}
                                                        maxValue={settings.flowBConsumptionMaxValue}
                                                        valueAs={null}
                                                        axisPosition={settings.flowBConsumptionAxisPosition}
                                                        lineWidth={settings.flowBConsumptionLineWidth}
                                                        graphType={settings.flowBConsumptionGraphType}
                                                        color={settings.flowBConsumptionColor}
                                                        labelSize={settings.flowBConsumptionLabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={intl.formatMessage({ id: "Consumption B" })}
                                                        displayUnits={flowUnits}
                                                        totalPerDay={false}
                                                        isTotaliser={false}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.flowBConsumptionDefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={undefined}
                                                        allowMinMax={undefined}
                                                        isDigital={undefined}
                                                    />}
                                            </div>}
                                            {selectedTab === 3 && graphTemplate.channelsAvail > 3 && <div>
                                                {/*Consumption A*/}

                                                {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x01)) && !settings.flowAIsDigital &&
                                                    <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={colors.teal[0]}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"flowAConsumption"}
                                                        isPressure={false}
                                                        visible={settings.flowAConsumptionVisible}
                                                        unit={settings.flowAConsumptionUnit}
                                                        minState={settings.flowAConsumptionMinState}
                                                        minValue={settings.flowAConsumptionMinValue}
                                                        maxState={settings.flowAConsumptionMaxState}
                                                        maxValue={settings.flowAConsumptionMaxValue}
                                                        valueAs={null}
                                                        axisPosition={settings.flowAConsumptionAxisPosition}
                                                        lineWidth={settings.flowAConsumptionLineWidth}
                                                        graphType={settings.flowAConsumptionGraphType}
                                                        color={settings.flowAConsumptionColor}
                                                        labelSize={settings.flowAConsumptionLabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={intl.formatMessage({ id: "Consumption A" })}
                                                        displayUnits={flowUnits}
                                                        totalPerDay={false}
                                                        isTotaliser={false}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.flowAConsumptionDefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={undefined}
                                                        allowMinMax={undefined}
                                                        isDigital={undefined}
                                                    />
                                                }



                                                {/*Consumption B*/}

                                                {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x02)) && !settings.flowBIsDigital &&
                                                    <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={colors.pink[0]}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"flowBConsumption"}
                                                        isPressure={false}
                                                        visible={settings.flowBConsumptionVisible}
                                                        unit={settings.flowBConsumptionUnit}
                                                        minState={settings.flowBConsumptionMinState}
                                                        minValue={settings.flowBConsumptionMinValue}
                                                        maxState={settings.flowBConsumptionMaxState}
                                                        maxValue={settings.flowBConsumptionMaxValue}
                                                        valueAs={null}
                                                        axisPosition={settings.flowBConsumptionAxisPosition}
                                                        lineWidth={settings.flowBConsumptionLineWidth}
                                                        graphType={settings.flowBConsumptionGraphType}
                                                        color={settings.flowBConsumptionColor}
                                                        labelSize={settings.flowBConsumptionLabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={intl.formatMessage({ id: "Consumption B" })}
                                                        displayUnits={flowUnits}
                                                        totalPerDay={false}
                                                        isTotaliser={false}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.flowBConsumptionDefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={undefined}
                                                        allowMinMax={undefined}
                                                        isDigital={undefined}
                                                    />}
                                            </div>
                                            }
                                            {selectedTab === 3 && graphTemplate.channelsAvail <= 3 && <div>
                                                {/*Combined Flow*/}
                                                {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x01)) && !settings.flowAIsDigital &&
                                                    <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={'red'}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"flowACombined"}
                                                        isPressure={false}
                                                        visible={settings.flowACombinedVisible}
                                                        unit={settings.flowACombinedUnit}
                                                        minState={settings.flowACombinedMinState}
                                                        minValue={settings.flowACombinedMinValue}
                                                        maxState={settings.flowACombinedMaxState}
                                                        maxValue={settings.flowACombinedMaxValue}
                                                        valueAs={null}
                                                        axisPosition={settings.flowACombinedAxisPosition}
                                                        lineWidth={settings.flowACombinedLineWidth}
                                                        graphType={settings.flowACombinedGraphType}
                                                        color={settings.flowACombinedColor}
                                                        labelSize={settings.flowACombinedLabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={intl.formatMessage({ id: "Combined Flow" })}
                                                        displayUnits={flowRateUnits}
                                                        isTotaliser={false}
                                                        totalPerDay={settings.flowATotalPerDay}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.flowACombinedDefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={undefined}
                                                        allowMinMax={undefined}
                                                        isDigital={undefined}
                                                    />
                                                }
                                            </div>
                                            }
                                            {selectedTab === 4 && graphTemplate.channelsAvail > 3 && <div>
                                                {/*Combined Flow*/}
                                                
                                                {!!(createCompanyDefault || createUserDefault || (unitsAndValues.length > 0 && unitsAndValues.filter(item => item.serial === loggersToTemplate)[0]?.channelsAvail & 0x01)) && !settings.flowAIsDigital &&
                                                    <GraphSettingsComponent
                                                        overViewStyle={overViewStyle}
                                                        borderColor={'red'}
                                                        modalParagraphStyle={modalParagraphStyle}
                                                        handleGraphSettingsChange={handleGraphSettingsChange}
                                                        changeGroup={"flowACombined"}
                                                        isPressure={false}
                                                        visible={settings.flowACombinedVisible}
                                                        unit={settings.flowACombinedUnit}
                                                        minState={settings.flowACombinedMinState}
                                                        minValue={settings.flowACombinedMinValue}
                                                        maxState={settings.flowACombinedMaxState}
                                                        maxValue={settings.flowACombinedMaxValue}
                                                        valueAs={null}
                                                        axisPosition={settings.flowACombinedAxisPosition}
                                                        lineWidth={settings.flowACombinedLineWidth}
                                                        graphType={settings.flowACombinedGraphType}
                                                        color={settings.flowACombinedColor}
                                                        labelSize={settings.flowACombinedLabelSize}
                                                        startDate={startDate}
                                                        loggers={loggers}
                                                        channel={intl.formatMessage({ id: "Combined Flow" })}
                                                        displayUnits={flowRateUnits}
                                                        isTotaliser={false}
                                                        totalPerDay={settings.flowATotalPerDay}
                                                        companyDefault={createCompanyDefault}
                                                        defaultColor={settings.flowACombinedDefaultColor}
                                                        pressureUnits={pressureUnits}
                                                        displayAll={undefined}
                                                        allowMinMax={undefined}
                                                        isDigital={undefined}
                                                    />
                                                    
                                                }
                                            </div>
                                            }


                                        </div>}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                                            <div>
                                                {createCompanyDefault && <Button color="primary" style={{ marginRight: "10px" }} onClick={(): void => handlePostGraphTemplate()} variant="contained"><FormattedMessage id="Save Company Default" /></Button>}
                                                {createUserDefault && <Button color="primary" style={{ marginRight: "10px" }} onClick={(): void => handlePostGraphTemplate()} variant="contained"><FormattedMessage id="Save User Default" /></Button>}
                                                {!createCompanyDefault && !createUserDefault && <Button color="primary" style={{ marginRight: "10px" }} onClick={(): void => handlePostGraphTemplate()} variant="contained"><FormattedMessage id="Save User Template for Selected Logger" /></Button>}
                                                <Button color="error" variant="contained" onClick={(): void => closeGraphTemplateWindow()}><FormattedMessage id="Exit" /></Button>
                                            </div>
                                        </div>
                                    </Modal.Footer>
                                </Modal>




                                {!fullscreen && <CardHeader color="primary" className="view view-cascade" style={{ marginTop: "1px" }}>
                                    <Grid container  >
                                        <Grid item lg={12} >
                                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                                                <div style={{ display: 'flex', maxWidth: '15%' }}>
                                                    {location && location.state && location.state.showBackButton &&
                                                        <IconButton
                                                            style={{ display: 'inline', margin: "0 -20px 0 0" }}
                                                            onClick={(): void => history.goBack()}
                                                            size="large"><ArrowBackIcon style={{ fill: "white" }} />
                                                        </IconButton>
                                                    }

                                                    {location && location.state &&
                                                        <div style={{ margin: "0 6px 0 25px" }}>
                                                            <p><FormattedMessage id="Loggers" /></p>
                                                            <div style={{ marginTop: "-12px" }}>
                                                                {location.state.showBackButton && loggers.map((logger: APILoggerDetail) => {

                                                                    return <Chip key={logger.LoggerId} style={{ marginRight: "5px" }}
                                                                        label={logger.Serial} onDelete={(): void => removeLogger(logger.Serial)} color="primary" />
                                                                })
                                                                }
                                                                {!location.state.showBackButton && loggers.map((logger: APILoggerDetail) => {
                                                                    return <Chip key={logger.LoggerId} style={{ marginRight: "5px" }}
                                                                        label={logger.Serial} color="primary" onClick={(): void => { deviceOverviewClick(logger.Serial, logger.Model) }} />
                                                                })
                                                                }

                                                                {loggers.length == 0 &&
                                                                    <div style={{ display: 'inline', fontWeight: "bold" }}><FormattedMessage id="None selected!" /></div>
                                                                }
                                                            </div>
                                                        </div>
                                                    }


                                                </div>

                                                <div style={{ margin: "0 10px 0 0", display: "flex" }}>
                                                    <div>
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", margin: "0 30px 0 0" }}>
                                                            <p style={{ textAlign: "center" }}><FormattedMessage id="Specify Time Range" /></p>
                                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                <Checkbox checked={specifyTime} onClick={(): void => setSpecifyTime(!specifyTime)} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", margin: "0 30px 0 0" }}>
                                                            <p style={{ textAlign: "center" }}><FormattedMessage id="Height" /></p>
                                                            <div style={{ marginTop: "-13px", display: "flex" }}>
                                                                <Button sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }} disabled={graphData.length === 0} onClick={(): void => setGraphHeight(`${parseInt(graphHeight.slice(0, 2)) - 5}vh `)} variant="contained"><RemoveIcon /></Button>
                                                                <Button style={{ marginLeft: "8px" }} sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }} disabled={graphData.length === 0} variant="contained" onClick={(): void => setGraphHeight(`${parseInt(graphHeight.slice(0, 2)) + 5}vh `)}><AddIcon /></Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{ display: "flex", padding: " 0px 0 0 10px", margin: "0px 10px 5px 0" }}>
                                                        {hasFlow &&
                                                            <div style={{ marginRight: "35px" }}>
                                                                <p style={{ marginTop: "auto 0", textAlign: "center" }}><FormattedMessage id="Flow" /></p>
                                                                <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                    <Checkbox checked={showFlow} onClick={(e): void => handleToggleFlow(e, "Flow")} />
                                                                </div>
                                                            </div>
                                                        }
                                                        {hasFlow && (loggers.length === 1 || (location.state.combinedFlowSiteId && combineY)) &&
                                                             <div style={{ marginRight: "35px" }}>
                                                                <p style={{ marginTop: "auto 0", textAlign: "center" }}><FormattedMessage id="MNF/AF" /></p>
                                                                <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                    <Checkbox checked={showMNFAF} onClick={(e): void => handleToggleFlow(e, "MNF")} />
                                                                </div>
                                                            </div>

                                                        }
                                                        {hasDigital && <div style={{ marginRight: "35px" }}>
                                                            <p style={{ marginTop: "auto 0", textAlign: "center" }}><FormattedMessage id="Digital" /></p>
                                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                <Checkbox checked={showDigital} onClick={(e): void => handleToggleFlow(e, "Digital")} />
                                                            </div>
                                                        </div>}
                                                        {hasPressureChannels && <div style={{ marginRight: "30px" }}>
                                                            <p style={{ marginTop: "auto 0", textAlign: "center" }}>{window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Pressure/Analog" })}</p>
                                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                <Checkbox checked={showPressure} onClick={(e): void => handleToggleFlow(e, "Pressure")} />
                                                            </div>
                                                        </div>
                                                        }
                                                        {showPressure && loggers.length === 1 && loggers[0].Model !== 'CHAR-WR' && loggers[0].Model !== 'ZL-2A' && <div style={{ marginRight: "30px" }}>
                                                            <p style={{ marginTop: "auto 0", textAlign: "center" }}>{window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Min/Max" }) : intl.formatMessage({ id: "Min/Max" })}</p>
                                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                <Checkbox checked={showMinMax} onClick={(e): void => handleToggleFlow(e, "MinMax")} />
                                                            </div>
                                                        </div>}

                                                        {hasTotal && <div style={{ marginRight: "10px" }}>
                                                            <p style={{ marginTop: "auto 0", textAlign: "center" }}><FormattedMessage id="Totaliser" /></p>
                                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                <Checkbox checked={showTotal} onClick={(e): void => handleToggleFlow(e, "Total")} />
                                                            </div>
                                                        </div>}
                                                        {hasConsumption && <div style={{ marginRight: "10px" }}>
                                                            <p style={{ marginTop: "auto 0", textAlign: "center" }}><FormattedMessage id="Consumption" /></p>
                                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                <Checkbox checked={showConsumption} onClick={(e): void => handleToggleFlow(e, "Consumption")} />
                                                            </div>
                                                        </div>}
                                                        {loggers.length > 1 && location.state.combinedFlowSiteId && <div style={{ marginRight: "10px" }}>
                                                            <p style={{ marginTop: "auto 0", textAlign: "center" }}><FormattedMessage id="Combine Flow" /></p>
                                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "-17px" }}>
                                                                <Checkbox checked={showCombinedFlow} disabled={!allowCombinedFlow} onClick={(e): void => handleToggleFlow(e, "Combined Flow")} />
                                                            </div>
                                                        </div>}

                                                    </div>

                                                    <div style={{ margin: "23px 0 0 0", display: "flex" }}>
                                                        {loggers.length > 1 && <Button size="small" variant="contained" style={{ marginRight: "10px" }} onClick={(): void => handleCombineYClick()} sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}>{combineY ? intl.formatMessage({ id: 'Seperate Y Axis' }) : intl.formatMessage({ id: 'Combine Y Axis' })}</Button>}
                                                        <Button color="secondary" variant="contained" onClick={(): void => resetZoom()} style={{ marginRight: "10px" }} disabled={graphData.length === 0} startIcon={<RefreshRoundedIcon />}><FormattedMessage id="Refresh" /></Button>
                                                        <Button variant="contained" color="primary" style={{ marginRight: "10px" }} disabled={graphData.length === 0} onClick={toggleExportModal}><FormattedMessage id="Export / Print" /></Button>
                                                        <Button disabled={graphData.length === 0} variant='contained' color='secondary' onClick={(): void => setMinMaxModal(true)} style={{ marginRight: "10px" }}><FormattedMessage id='Min/Max' /></Button>
                                                        {unitsAndValues.length > 0 && <Button disabled={combineY || graphData.length === 0} color="warning" style={{ marginRight: "15px" }} variant="contained" onClick={(): void => toggleCreateTemplateOpen()}><FormattedMessage id="Edit Graph Settings" /></Button>}

                                                    </div>


                                                </div>
                                            </div>

                                        </Grid>

                                    </Grid>
                                    <div style={{margin: "px 18px 12px 25px"} }>
                                        <DateRange
                                            startDate={startDate}
                                            endDate={endDate}
                                            rainfall={false}
                                            onDateChange={(
                                                startDateChange: Date,
                                                endDateChange: Date,
                                                rainfall: boolean | null,
                                                recent: boolean,
                                            ): void => onDateChange(
                                                startDateChange,
                                                endDateChange,
                                                rainfall,
                                                recent,
                                                setStartDate,
                                                setEndDate,
                                                setShouldReloadData,
                                                setShowButton,
                                                specifyTime
                                            )}
                                            type={specifyTime ? "datetime" : 'date'}
                                            showButton={showButton}
                                            handleRedrawClick={handleRedrawClick}
                                        />
                                    </div>
                                </CardHeader>}
                                {fullscreen &&
                                    <div style={{width: "100%", display: "flex", justifyContent: "flex-end"} }>
                                        <Button color="secondary" variant="contained" onClick={(): void => resetZoom()} >Refresh</Button>
                                    </div>
                                }

                                {(graphData.length < 1 && !noLoggersInGroup) && <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><h4><FormattedMessage id="No Data available between the dates selected, try expanding the data range" /></h4></div>}
                                {noLoggersInGroup && <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><h4><FormattedMessage id="No Sites exist in this group" /></h4></div>}
                                {graphData.length > 0 && (() => {


                                    // Count items without dates
                                    const missingDates = graphData.filter(item => !item.date).length;


                                    return null;
                                })()}
                                {graphData.length > 0 && startDate && endDate && unitsAndValues.length > 0 &&

                                    <div>
                                        {combineY &&
                                            <div style={{display: "flex", justifyContent: "center", width: "100%", marginTop: "10px"} }>
                                                <div style={{ display: "flex", justifyContent: "space-evenly", width: "100%" }}>
                                                    {showMNFAF && (loggers.length === 1 || (location.state.combinedFlowSiteId && combineY)) &&
                                                        <div>
                                                            <p><b>{`${intl.formatMessage({ id: 'Minimum Night Flow to Average Flow Ratio' })}`}</b> = {`${parseFloat(MNFValue.ratio.toFixed(1))}`}</p>
                                                            <p style={{ marginTop: -15 }}><span style={{ color: 'purple' }}><b>{`${intl.formatMessage({ id: 'Average Flow' })}`}</b></span> = {` ${minMaxData[loggers.length].A.avg} ${unitsAndValues[0].graphSettings.flowAUnit}`}</p>
                                                            <p style={{margin: '-15px 0'} }><span style={{color: 'green'} }><b>{`${intl.formatMessage({ id: 'Minimum Night Flow' })}`}</b></span> = {`${MNFValue.value} ${unitsAndValues[0].graphSettings.flowAUnit}`}</p>
                                                        </div>
                                                    }
                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <p style={{ margin: "5px 20px 0 0" }}><FormattedMessage id="For Combining Y Axis, Custom Graph Settings cannot be applied, instead the following convention will apply:" /></p>

                                                        {showRelativeChannelDisplay()}
                                                    </div>


                                                </div>
                                            </div>}
                                        <div style={{ marginTop: 30 }}>
                                            {console.log(loggers) }
                                            <Chart
                                                dataSource={graphData}
                                                ref={chartRef}
                                                height={fullscreen ? "85vh" : graphHeight}
                                                width="100%"
                                                onZoomEnd={(e): void => handleZoomDrag(e)}

                                            >
                                                <CommonSeriesSettings
                                                    argumentField="date"
                                                    ignoreEmptyPoints={true}
                                                    type={'line'}
                                                >

                                                    <Point size={15} />
                                                    <Font weight={900} size={40} />
                                                </CommonSeriesSettings>


                                                {graphData.length > 0 && unitsAndValues.length > 0 && loggers.map((logger) => {
                                                    return renderLoggerSeries(logger)
                                                })}




                                                {unitsAndValues && alarms && loggers.map((logger) => {
                                                    return renderValueAxis(logger)
                                                })}
                                                



                                                <ArgumentAxis
                                                    width={2}
                                                    allowDecimals={false}
                                                    argumentType="date"
                                                    minValueMargin={combineY ? 0.05 : 0}
                                                    maxValueMargin={combineY ? 0.05 : 0}
                                                    visualRange={visualRange}
                                                    color={'#000000'}
                                                    discreteAxisDivisionMode="crossLabels"

                                                >
                                                    <Label font={{ size: 16, color: '#000000' }} format={(date: Date): string => customArgument(date)} />
                                                    <GridChart visible={true} />
                                                    {loggers.length === 1 && renderImportedDataStrips(
                                                        unitsAndValues,
                                                        importData
                                                    )}


                                                </ArgumentAxis>
                                                <Crosshair
                                                    enabled={true}
                                                    color="#949494"
                                                    width={3}
                                                    dashStyle="dot"
                                                >
                                                    <Label
                                                        visible={true}
                                                        backgroundColor="#949494"
                                                    >
                                                        <Font
                                                            color="#fff"
                                                            size={14}
                                                        />
                                                    </Label>
                                                </Crosshair>
                                                <ZoomAndPan
                                                    allowMouseWheel={false}
                                                    argumentAxis="both"
                                                    valueAxis="none"
                                                    dragToZoom={true}

                                                />
                                                <Legend
                                                    visible={false}
                                                    position="outside"
                                                    horizontalAlignment="center"
                                                    verticalAlignment="top"

                                                />
                                                {!createTemplateOpen && !toggling && <Tooltip
                                                    enabled={true}
                                                    contentRender={(point): React.ReactNode => renderTooltip(
                                                        point,
                                                        loggers,
                                                        intl,
                                                        loggerSiteDetails,
                                                        combineY,
                                                        unitsAndValues,
                                                        combinedFlowAUnit,
                                                        combinedTotalAUnit,
                                                        combinedConsumptionAUnit,
                                                        combinedFlowBUnit,
                                                        combinedTotalBUnit,
                                                        combinedConsumptionBUnit,
                                                        combinedPressureCUnit,
                                                        combinedPressureDUnit,
                                                        combinedPressureEUnit,
                                                        combinedFlowUnits
                                                    )}
                                                    offsetY={-200} />}
                                            </Chart>
                                            </div>
                                        {/*{!fullscreen && normalisedData && normalisedData.length > 0 && (*/}
                                        {/*    <div style={{ marginTop: "40px" }}>*/}
                                        {/*        <CardHeader color="primary">*/}
                                        {/*            <h4 style={{ display: "flex", justifyContent: "center" }}>*/}
                                        {/*                <FormattedMessage id="Range Finder" />*/}
                                        {/*            </h4>*/}
                                        {/*            <GraphRangeSelector*/}
                                        {/*                graphData={normalisedData}*/}
                                        {/*                updateVisualRange={updateVisualRange}*/}
                                        {/*                visualRange={visualRange}*/}
                                        {/*                loggers={loggers}*/}
                                        {/*                renderRangeFinderSeries={renderRangeFinderSeries}*/}
                                        {/*            />*/}
                                        {/*        </CardHeader>*/}
                                        {/*    </div>*/}
                                        {/*)}*/}
                                    </div>}
                            </div>}
                    </div>}
            </> :
                (<Redirect push to={{
                    pathname: redirectPath,
                    state: redirectProps
                }} />)}
        </>
    )
}
export default MultiLoggerGraphV2